// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/MaterialIcons-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/MaterialIcons-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/MaterialIcons-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/MaterialIcons-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Mada:400,500,600,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author       : Dreamguys
Template Name: Doccure - Bootstrap Admin Template
Version      : 1.3
*/

/*============================
 [Table of CSS]

1. General
2. Table
3. Helper Class
4. Bootstrap Classes
5. Select2
6. Nav Tabs
7. Components
8. Header
9. Sidebar
10. Content
11. Login
12. Lock Screen
13. Notifications
14. Dashboard
15. Invoice
16. Calendar
17. Inbox
18. Mail View
19. Error
20. Chat
21. Product
22. Product Details
23. Profile
24. Template Options
25. Blog
26. Blog Details
27. Blog Grid
28. Responsive

========================================*/

/*-----------------
	1. General
-----------------------*/
@font-face {
	font-family: 'Material Icons';
	font-style: normal;
	font-weight: 400;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* For IE6-8 */
	src: local('Material Icons'),
	local('MaterialIcons-Regular'),
	url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
	url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
	url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
html {
	height: 100%;
}
body {
	background-color: #f8f9fa;
	color: #333;
	font-family: 'Mada', sans-serif;
	font-size: 1rem;
	height: 100%;
	line-height: 1.5;
	overflow-x: hidden;
}

 h1, h2,  h3,  h4,  h5, h6 {
	font-family: 'Mada', sans-serif;
	margin-top: 0;
	}

a:hover,
a:active,
a:focus {
	outline: none;
	text-decoration: none;
	color: #00d0f1;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
}
.form-control {
    border: 1px solid #ddd;
    box-shadow: none;
    color: #333;
    font-size: 15px;
    height: 40px;
}
.form-control:focus {
	border-color: #00d0f1;
	box-shadow: none;
	outline: 0 none;
}
.form-control.form-control-sm {
	height: calc(1.5em + .5rem + 2px);
}

.form-control.form-control-lg {
	height: calc(1.5em + 1rem + 2px);
}
a {
	color: #0dd9f9;
}
input,
button,
a {
	transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-ms-transition: all 0.4s ease;
	-webkit-transition: all 0.4s ease;
}
input, input:focus,
button, button:focus {
	outline: none;
}
input[type="file"] {
    height: auto;
    min-height: calc(1.5em + .75rem + 2px);
}
input[type=text],
input[type=password] {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
}
textarea.form-control {
	resize: vertical;
}
.navbar-nav > li {
	float: left;
}
.form-group {
	margin-bottom: 1.25rem;
}
.input-group .form-control {
	height: 40px;
}
.nav .open > a,
.nav .open > a:focus,
.nav .open > a:hover {
	background-color: rgba(0, 0, 0, 0.1);
	border-color: rgba(0, 0, 0, 0.1);
}
.material-icons {
	font-family: 'Material Icons';
	font-weight: normal;
	font-style: normal;
	font-size: 24px;
	display: inline-block;
	line-height: 1;
	text-transform: none;
	letter-spacing: normal;
	word-wrap: normal;
	white-space: nowrap;
	direction: ltr;
	-webkit-font-smoothing: antialiased;
	text-rendering: optimizeLegibility;
	-moz-osx-font-smoothing: grayscale;
	font-feature-settings: 'liga';
}
.font-weight-600 {
	font-weight: 600;
}

/*-----------------
	2. Table
-----------------------*/

.table {
	color: #333;
	max-width: 100%;
	margin-bottom: 0;
	width: 100%;
}
.table-striped > tbody > tr:nth-of-type(2n+1) {
	background-color: #f8f9fa;
}
.table.no-border > tbody > tr > td,
.table > tbody > tr > th,
.table.no-border > tfoot > tr > td,
.table.no-border > tfoot > tr > th,
.table.no-border > thead > tr > td,
.table.no-border > thead > tr > th {
	border-top: 0;
	padding: 10px 8px;
}
.table-nowrap td,
.table-nowrap th {
	white-space: nowrap
}
.table.dataTable {
	border-collapse: collapse !important;
}
table.table td h2 {
	display: inline-block;
	font-size: inherit;
	font-weight: 400;
	margin: 0;
	padding: 0;
	vertical-align: middle;
}
table.table td h2.table-avatar {
    align-items: center;
    display: inline-flex;
    font-size: inherit;
    font-weight: 400;
    margin: 0;
    padding: 0;
    vertical-align: middle;
	white-space: nowrap;
}
table.table td h2 a {
	color: #333;
}
table.table td h2 a:hover {
	color: #00d0f1;
}
table.table td h2 span {
	color: #888;
	display: block;
	font-size: 12px;
	margin-top: 3px;
}
.table thead {
	background-color: #f8f9fa;
	border-bottom: 1px solid rgba(0, 0, 0, 0.03);
}
.table thead tr th {
	font-weight: 600;
	border: 0;
}
.table tbody tr {
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.table tbody tr:last-child {
	border-color: transparent;
}
.table.table-center td,
.table.table-center th {
	vertical-align: middle;
}
.table-hover tbody tr:hover {
	background-color: #f7f7f7;
}
.table-hover tbody tr:hover td {
	color: #474648;
}
.table-striped thead tr {
	border-color: transparent;
}
.table-striped tbody tr {
	border-color: transparent;
}
.table-striped tbody tr:nth-of-type(even) {
	background-color: rgba(255, 255, 255, 0.3);
}
.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(235, 235, 235, 0.4);
}
.table-bordered {
	border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.table-bordered th,
.table-bordered td {
	border-color: rgba(0, 0, 0, 0.05);
}
.card-table .card-body {
    padding: 0;
}
.card-table .card-body .table > thead > tr > th {
    border-top: 0;
}
.card-table .card-body .table tr td:first-child,
.card-table .card-body .table tr th:first-child {
    padding-left: 1.5rem;
}
.card-table .card-body .table tr td:last-child,
.card-table .card-body .table tr th:last-child {
    padding-right: 1.5rem;
}
.card-table .table td, .card-table .table th {
    border-top: 1px solid #e2e5e8;
    padding: 1rem 0.75rem;
    white-space: nowrap;
}
#delete_modal .modal-content {
	text-align: center;
}
/*-----------------
	3. Helper Class
-----------------------*/

.p-20 {
	padding: 20px !important;
}
.p-t-0 {
	padding-top: 0 !important;
}
.m-0 {
	margin: 0 !important;
}
.m-r-5 {
	margin-right: 5px !important;
}
.m-r-10 {
	margin-right: 10px !important;
}
.m-l-5 {
	margin-left: 5px !important;
}
.m-l-15 {
	margin-left: 15px !important;
}
.m-t-5 {
	margin-top: 5px !important;
}
.m-t-0 {
	margin-top: 0 !important;
}
.m-t-10 {
	margin-top: 10px !important;
}
.m-t-15 {
	margin-top: 15px !important;
}
.m-t-20 {
	margin-top: 20px !important;
}
.m-t-30 {
	margin-top: 30px !important;
}
.m-t-50 {
	margin-top: 50px !important;
}
.m-b-5 {
	margin-bottom: 5px !important;
}
.m-b-10 {
	margin-bottom: 10px !important;
}
.m-b-15 {
	margin-bottom: 15px !important;
}
.m-b-20 {
	margin-bottom: 20px !important;
}
.m-b-30 {
	margin-bottom: 30px !important;
}
.block {
	display: block !important;
}
.cal-icon {
	position: relative;
	width: 100%;
}
.cal-icon:after {
	color: #979797;
	content: "\\f073";
	display: block;
	font-family: "FontAwesome";
    font-size: 15px;
    margin: auto;
    position: absolute;
    right: 15px;
    top: 10px;
}

/*-----------------
	4. Bootstrap Classes
-----------------------*/

.btn.focus, .btn:focus {
    box-shadow: unset;
}
.btn-white {
	background-color: #fff;
	border: 1px solid #ccc;
	color: #333;
}
.btn.btn-rounded {
	border-radius: 50px;
}
.bg-primary,
.badge-primary {
	background-color: #00d0f1 !important;
}
a.bg-primary:focus, 
a.bg-primary:hover, 
button.bg-primary:focus, 
button.bg-primary:hover {
    background-color: #19c1dc !important;
}
.bg-success,
.badge-success {
	background-color: #7bb13c !important;
}
a.bg-success:focus, 
a.bg-success:hover, 
button.bg-success:focus, 
button.bg-success:hover {
    background-color: #699834 !important;
}
.bg-info,
.badge-info {
	background-color: #009efb !important;
}
a.bg-info:focus, 
a.bg-info:hover, 
button.bg-info:focus, 
button.bg-info:hover {
    background-color: #028ee1 !important;
}
.bg-warning,
.badge-warning {
	background-color: #ffbc34 !important;
}
a.bg-warning:focus, 
a.bg-warning:hover, 
button.bg-warning:focus, 
button.bg-warning:hover {
    background-color: #e9ab2e !important;
}
.bg-danger,
.badge-danger {
	background-color: #e84646 !important;
}
a.bg-danger:focus, 
a.bg-danger:hover, 
button.bg-danger:focus, 
button.bg-danger:hover {
    background-color: #e63333 !important;
}
.bg-white {
	background-color: #fff;
}
.bg-purple,
.badge-purple {
    background-color: #9368e9 !important;
}
.text-primary,
.dropdown-menu > li > a.text-primary {
	color: #00d0f1 !important
}
.text-success,
.dropdown-menu > li > a.text-success {
	color: #699834 !important;
}
.text-danger,
.dropdown-menu > li > a.text-danger {
	color: #e84646 !important;
}
.text-info,
.dropdown-menu > li > a.text-info {
	color: #009efb !important;
}
.text-warning,
.dropdown-menu > li > a.text-warning {
	color: #ffbc34 !important;
}
.text-purple,
.dropdown-menu > li > a.text-purple {
	color: #7460ee !important;
}
.text-muted {
    color: #757575 !important;
}
.text-secondary {
    color: #b8bdc1!important;
}
.border-primary {
    border-color: #00d0f1!important;
}
.btn-primary {
	background-color: #00d0f1;
    border: 1px solid #00d0f1;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
	background-color: #19c1dc;
	border: 1px solid #19c1dc;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
    color: #fff;
    background-color: #00d0f1;
}
.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary.focus:active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover {
	background-color: #19c1dc;
	border: 1px solid #19c1dc;
}
.btn-primary.active:not(:disabled):not(.disabled),
.btn-primary:active:not(:disabled):not(.disabled),
.show > .btn-primary.dropdown-toggle {
	background-color: #19c1dc;
	border-color: #19c1dc;
	color: #fff;
}
.btn-primary.active:focus:not(:disabled):not(.disabled), 
.btn-primary:active:focus:not(:disabled):not(.disabled), 
.show > .btn-primary.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-primary.disabled, .btn-primary:disabled {
    background-color: #00d0f1;
    border-color: #00d0f1;
    color: #fff;
}
.btn-secondary.active:focus:not(:disabled):not(.disabled), 
.btn-secondary:active:focus:not(:disabled):not(.disabled), 
.show > .btn-secondary.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-success {
	background-color: #7bb13c;
	border: 1px solid #7bb13c
}
.btn-success:hover,
.btn-success:focus,
.btn-success.active,
.btn-success:active,
.open > .dropdown-toggle.btn-success {
	background-color: #699834;
	border: 1px solid #699834;
	color: #fff;
}
.btn-success.active.focus,
.btn-success.active:focus,
.btn-success.active:hover,
.btn-success.focus:active,
.btn-success:active:focus,
.btn-success:active:hover,
.open > .dropdown-toggle.btn-success.focus,
.open > .dropdown-toggle.btn-success:focus,
.open > .dropdown-toggle.btn-success:hover {
	background-color: #699834;
	border: 1px solid #699834
}
.btn-success.active:not(:disabled):not(.disabled),
.btn-success:active:not(:disabled):not(.disabled),
.show > .btn-success.dropdown-toggle {
	background-color: #699834;
	border-color: #699834;
	color: #fff;
}
.btn-success.active:focus:not(:disabled):not(.disabled), 
.btn-success:active:focus:not(:disabled):not(.disabled), 
.show > .btn-success.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-success.disabled, .btn-success:disabled {
    background-color: #7bb13c;
    border-color: #7bb13c;
    color: #fff;
}
.btn-info {
	background-color: #009efb;
	border: 1px solid #009efb
}
.btn-info:hover,
.btn-info:focus,
.btn-info.active,
.btn-info:active,
.open > .dropdown-toggle.btn-info {
	background-color: #028ee1;
	border: 1px solid #028ee1
}
.btn-info.active.focus,
.btn-info.active:focus,
.btn-info.active:hover,
.btn-info.focus:active,
.btn-info:active:focus,
.btn-info:active:hover,
.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover {
	background-color: #028ee1;
	border: 1px solid #028ee1
}
.btn-info.active:not(:disabled):not(.disabled),
.btn-info:active:not(:disabled):not(.disabled),
.show > .btn-info.dropdown-toggle {
	background-color: #028ee1;
	border-color: #028ee1;
	color: #fff;
}
.btn-info.active:focus:not(:disabled):not(.disabled), 
.btn-info:active:focus:not(:disabled):not(.disabled), 
.show > .btn-info.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-info.disabled, .btn-info:disabled {
    background-color: #009efb;
    border-color: #009efb;
    color: #fff;
}
.btn-warning {
	background-color: #ffbc34;
	border: 1px solid #ffbc34
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning.active,
.btn-warning:active,
.open > .dropdown-toggle.btn-warning {
	background-color: #e9ab2e;
	border: 1px solid #e9ab2e
}
.btn-warning.active.focus,
.btn-warning.active:focus,
.btn-warning.active:hover,
.btn-warning.focus:active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover {
	background-color: #e9ab2e;
	border: 1px solid #e9ab2e
}
.btn-warning.active:not(:disabled):not(.disabled),
.btn-warning:active:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle {
	background-color: #e9ab2e;
	border-color: #e9ab2e;
	color: #fff;
}
.btn-warning.active:focus:not(:disabled):not(.disabled), 
.btn-warning:active:focus:not(:disabled):not(.disabled), 
.show > .btn-warning.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-warning.disabled, .btn-warning:disabled {
    background-color: #ffbc34;
    border-color: #ffbc34;
    color: #fff;
}
.btn-danger {
	background-color: #e84646;
	border: 1px solid #e84646;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger.active,
.btn-danger:active,
.open > .dropdown-toggle.btn-danger {
	background-color: #e63333;
	border: 1px solid #e63333;
}
.btn-danger.active.focus,
.btn-danger.active:focus,
.btn-danger.active:hover,
.btn-danger.focus:active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover {
	background-color: #e63333;
	border: 1px solid #e63333;
}
.btn-danger.active:not(:disabled):not(.disabled),
.btn-danger:active:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle {
	background-color: #e63333;
	border-color: #e63333;
	color: #fff;
}
.btn-danger.active:focus:not(:disabled):not(.disabled), 
.btn-danger:active:focus:not(:disabled):not(.disabled), 
.show > .btn-danger.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-danger.disabled, .btn-danger:disabled {
    background-color: #f62d51;
    border-color: #f62d51;
    color: #fff;
}
.btn-light.active:focus:not(:disabled):not(.disabled), 
.btn-light:active:focus:not(:disabled):not(.disabled), 
.show > .btn-light.dropdown-toggle:focus {
    box-shadow: unset;
}
.btn-dark.active:focus:not(:disabled):not(.disabled), 
.btn-dark:active:focus:not(:disabled):not(.disabled), 
.show > .btn-dark.dropdown-toggle:focus {
    box-shadow: unset;
}
.btn-outline-primary {
	color: #00d0f1;
	border-color: #00d0f1;
}
.btn-outline-primary:hover {
	background-color: #00d0f1;
	border-color: #00d0f1;
}
.btn-outline-primary:focus, 
.btn-outline-primary.focus {
	box-shadow: none;
}
.btn-outline-primary.disabled, 
.btn-outline-primary:disabled {
	color: #00d0f1;
	background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, 
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
	background-color: #00d0f1;
	border-color: #00d0f1;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, 
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-success {
	color: #7bb13c;
	border-color: #7bb13c;
}
.btn-outline-success:hover {
	background-color: #7bb13c;
	border-color: #7bb13c;
}
.btn-outline-success:focus, .btn-outline-success.focus {
	box-shadow: none;
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
	color: #7bb13c;
	background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, 
.btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
	background-color: #7bb13c;
	border-color: #7bb13c;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, 
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-info {
	color: #009efb;
	border-color: #009efb;
}
.btn-outline-info:hover {
	color: #fff;
	background-color: #009efb;
	border-color: #009efb;
}
.btn-outline-info:focus, .btn-outline-info.focus {
	box-shadow: none;
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
	background-color: transparent;
	color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled):active, 
.btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
	background-color: #009efb;
	border-color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, 
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-warning {
	color: #ffbc34;
	border-color: #ffbc34;
}
.btn-outline-warning:hover {
	color: #212529;
	background-color: #ffbc34;
	border-color: #ffbc34;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
	box-shadow: none;
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
	background-color: transparent;
	color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, 
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
	color: #212529;
	background-color: #ffbc34;
	border-color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, 
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-danger {
	color: #e84646;
	border-color: #e84646;
}
.btn-outline-danger:hover {
	color: #fff;
	background-color: #e84646;
	border-color: #e84646;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
	box-shadow: none;
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
	background-color: transparent;
	color: #e84646;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, 
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
	background-color: #e84646;
	border-color: #e84646;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, 
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-light {
    color: #ababab;
    border-color: #e6e6e6;
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #ababab;
}
.pagination > .active > a, 
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
	background-color: #00d0f1;
	border-color: #00d0f1;
}
.pagination > li > a, 
.pagination > li > span {
	color: #00d0f1;
}
.page-link:hover {
	color: #00d0f1;
}
.page-link:focus {
	box-shadow: unset;
}
.page-item.active .page-link {
	background-color: #00d0f1;
	border-color: #00d0f1;
}
.dropdown-menu {
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	transform-origin: left top 0;
	box-shadow: inherit;
	background-color: #fff;
}
.dropdown-item.active, .dropdown-item:active {
    background-color: #00d0f1;
}
.navbar-nav .open .dropdown-menu {
	border: 0;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	background-color: #fff;
}
.dropdown-menu {
	font-size: 14px;
}
.card {
    border: 1px solid #f0f0f0;
    margin-bottom: 1.875rem;
}
.card-body {
	padding: 1.5rem;
}
.card-header {
	border-bottom: 1px solid #e6e6e6;
	padding: 1rem 1.5rem;
}
.card-footer {
	background-color: #fff;
	border-top: 1px solid #e6e6e6;
	padding: 1rem 1.5rem;
}
.card .card-header {
    background-color: #fff;
    border-bottom: 1px solid #eaeaea;
}
.card .card-header .card-title {
    margin-bottom: 0;
}
.modal-footer.text-left {
	text-align: left;
}
.modal-footer.text-center {
	text-align: center;
}
.btn-light {
	border-color: #e6e6e6;
	color: #a6a6a6;
}
.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td.active:hover {
	background-color: #00d0f1;
	text-shadow: unset;
}
.bootstrap-datetimepicker-widget table td.today:before{
	border-bottom-color:#00d0f1;
}
.bg-info-light{
	background-color:rgba(2, 182, 179,0.12) !important;
	color:#1db9aa !important;
}
.bg-primary-light{
	background-color:rgba(17, 148, 247,0.12) !important;
	color:#2196f3 !important;
}
.bg-danger-light{
	background-color:rgba(242, 17, 54,0.12) !important;
	color:#e63c3c !important;
}
.bg-warning-light{
	background-color:rgba(255, 152, 0,0.12) !important;
	color:#f39c12 !important;
}
.bg-success-light{
	background-color:rgba(15, 183, 107,0.12) !important;
	color:#26af48 !important;
}
.bg-purple-light{
	background-color:rgba(197, 128, 255,0.12) !important;
	color:#c580ff !important;
}
.bg-default-light{
	background-color:rgba(40, 52, 71,0.12) !important;
	color:#283447 !important;
}

/*-----------------
	5. Select2
-----------------------*/

.select2-container .select2-selection--single {
	border: 1px solid #ddd;
	height: 40px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 38px;
	right: 7px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b {
	border-color: #ddd transparent transparent;
	border-style: solid;
	border-width: 6px 6px 0;
	height: 0;
	left: 50%;
	margin-left: -10px;
	margin-top: -2px;
	position: absolute;
	top: 50%;
	width: 0;
}
.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
	border-color: transparent transparent #ddd;
	border-width: 0 6px 6px;
}
.select2-container .select2-selection--single .select2-selection__rendered {
	padding-right: 30px;
	padding-left: 15px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #333;
	font-size: 15px;
	font-weight: normal;
	line-height: 38px;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
	background-color: #00d0f1;
}
.select2-container--default .select2-selection--multiple {
	border: 1px solid #ddd;
	min-height: 40px;
}

/*-----------------
	6. Nav Tabs
-----------------------*/

.nav-tabs {
	border-bottom: 1px solid #e6e6e6;
}
.card-header-tabs {
    border-bottom: 0;
}
.nav-tabs > li > a {
	margin-right: 0;
	color: #888;
	border-radius: 0;
}
.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
	border-color: transparent;
	color: #333;
}
.nav-tabs.nav-tabs-solid > li > a {
	color: #333;
}
.nav-tabs.nav-tabs-solid > .active > a,
.nav-tabs.nav-tabs-solid > .active > a:hover,
.nav-tabs.nav-tabs-solid > .active > a:focus {
	background-color: #00d0f1;
	border-color: #00d0f1;
	color: #fff;
}
.tab-content {
	padding-top: 20px;
}
.nav-tabs .nav-link {
	border-radius: 0;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    background-color: #eee;
    border-color: transparent;
	color: #333;
}
.nav-tabs.nav-justified > li > a {
	border-radius: 0;
	margin-bottom: 0;
}
.nav-tabs.nav-justified > li > a:hover,
.nav-tabs.nav-justified > li > a:focus {
	border-bottom-color: #ddd;
}
.nav-tabs.nav-justified.nav-tabs-solid > li > a {
	border-color: transparent;
}
.nav-tabs.nav-tabs-solid > li > a {
	color: #333;
}
.nav-tabs.nav-tabs-solid > li > a.active,
.nav-tabs.nav-tabs-solid > li > a.active:hover,
.nav-tabs.nav-tabs-solid > li > a.active:focus {
	background-color: #00d0f1;
	border-color: #00d0f1;
	color: #fff;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded {
	border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {
	border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
	border-radius: 50px;
}
.nav-tabs-justified > li > a {
	border-radius: 0;
	margin-bottom: 0;
}
.nav-tabs-justified > li > a:hover,
.nav-tabs-justified > li > a:focus {
	border-bottom-color: #ddd;
}
.nav-tabs-justified.nav-tabs-solid > li > a {
	border-color: transparent;
}
.nav-tabs.nav-justified.nav-tabs-top {
	border-bottom: 1px solid #ddd;
}
.nav-tabs.nav-justified.nav-tabs-top > li > a,
.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,
.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li {
	margin-bottom: 0;
}
.nav-tabs.nav-tabs-top > li > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li.open > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
	border-top-color: #ddd;
}
.nav-tabs.nav-tabs-top > li+li > a {
	margin-left: 1px;
}
.nav-tabs.nav-tabs-top > li > a.active,
.nav-tabs.nav-tabs-top > li > a.active:hover,
.nav-tabs.nav-tabs-top > li > a.active:focus {
	border-top-color: #00d0f1;
}
.nav-tabs.nav-tabs-bottom > li {
	margin-bottom: -1px;
}
.nav-tabs.nav-tabs-bottom > li > a.active, 
.nav-tabs.nav-tabs-bottom > li > a.active:hover, 
.nav-tabs.nav-tabs-bottom > li > a.active:focus {
	border-bottom-width: 2px;
	border-color: transparent;
	border-bottom-color: #00d0f1;
	background-color: transparent;
	transition: none 0s ease 0s; 
	-moz-transition: none 0s ease 0s; 
	-o-transition: none 0s ease 0s; 
	-ms-transition: none 0s ease 0s; 
	-webkit-transition: none 0s ease 0s;
}
.nav-tabs.nav-tabs-solid {
	background-color: #fafafa;
	border: 0;
}
.nav-tabs.nav-tabs-solid > li {
	margin-bottom: 0;
}
.nav-tabs.nav-tabs-solid > li > a {
	border-color: transparent;
}
.nav-tabs.nav-tabs-solid > li > a:hover,
.nav-tabs.nav-tabs-solid > li > a:focus {
	background-color: #f5f5f5;
}
.nav-tabs.nav-tabs-solid > .open:not(.active) > a {
	background-color: #f5f5f5;
	border-color: transparent;
}
.nav-tabs-justified.nav-tabs-top {
	border-bottom: 1px solid #ddd;
}
.nav-tabs-justified.nav-tabs-top > li > a,
.nav-tabs-justified.nav-tabs-top > li > a:hover,
.nav-tabs-justified.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}

/*-----------------
	7. Components
-----------------------*/

.section-header {
    margin-bottom: 1.875rem;
}
.section-header .section-title {
    color: #333;
}
.line {
    background-color: #00d0f1;
    height: 2px;
    margin: 0;
    width: 60px;
}
.comp-buttons .btn {
	margin-bottom: 5px;
}
.pagination-box .pagination {
	margin-top: 0;
}
.comp-dropdowns .btn-group {
	margin-bottom: 5px;
}
.progress-example .progress {
	margin-bottom: 1.5rem;
}
.progress-xs {
	height: 4px;
}
.progress-sm {
	height: 15px;
}
.progress.progress-sm {
	height: 6px;
}
.progress.progress-md {
	height: 8px;
}
.progress.progress-lg {
	height: 18px;
}
.row.row-sm {
    margin-left: -3px;
    margin-right: -3px;
}
.row.row-sm > div {
    padding-left: 3px;
    padding-right: 3px;
}
.table-responsive {
	white-space: nowrap;
}

/* Avatar */

.avatar {
	position: relative;
	display: inline-block;
	width: 3rem;
	height: 3rem
}
.avatar > img {
	width: 100%;
	height: 100%;
	-o-object-fit: contain;
	object-fit: contain;
}
.avatar-title {
	width: 100%;
	height: 100%;
	background-color: #00d0f1;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.avatar-away:before,
.avatar-offline:before,
.avatar-online:before {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 25%;
	height: 25%;
	border-radius: 50%;
	content: '';
	border: 2px solid #fff;
}
.avatar-online:before {
	background-color: #7bb13c;
}
.avatar-offline:before {
	background-color: #e84646;
}
.avatar-away:before {
	background-color: #ffbc34;
}
.avatar .border {
	border-width: 3px !important;
}
.avatar .rounded {
	border-radius: 6px !important;
}
.avatar .avatar-title {
	font-size: 18px;
}
.avatar-xs {
	width: 1.65rem;
	height: 1.65rem;
}
.avatar-xs .border {
	border-width: 2px !important;
}
.avatar-xs .rounded {
	border-radius: 4px !important;
}
.avatar-xs .avatar-title {
	font-size: 12px;
}
.avatar-xs.avatar-away:before,
.avatar-xs.avatar-offline:before,
.avatar-xs.avatar-online:before {
	border-width: 1px;
}
.avatar-sm {
	width: 2.5rem;
	height: 2.5rem;
}
.avatar-sm .border {
	border-width: 3px !important;
}
.avatar-sm .rounded {
	border-radius: 4px !important;
}
.avatar-sm .avatar-title {
	font-size: 15px;
}
.avatar-sm.avatar-away:before,
.avatar-sm.avatar-offline:before,
.avatar-sm.avatar-online:before {
	border-width: 2px;
}
.avatar-lg {
	width: 3.75rem;
	height: 3.75rem;
}
.avatar-lg .border {
	border-width: 3px !important;
}
.avatar-lg .rounded {
	border-radius: 8px !important;
}
.avatar-lg .avatar-title {
	font-size: 24px;
}
.avatar-lg.avatar-away:before,
.avatar-lg.avatar-offline:before,
.avatar-lg.avatar-online:before {
	border-width: 3px;
}
.avatar-xl {
	width: 5rem;
	height: 5rem;
}
.avatar-xl .border {
	border-width: 4px !important;
}
.avatar-xl .rounded {
	border-radius: 8px !important;
}
.avatar-xl .avatar-title {
	font-size: 28px;
}
.avatar-xl.avatar-away:before,
.avatar-xl.avatar-offline:before,
.avatar-xl.avatar-online:before {
	border-width: 4px;
}
.avatar-xxl {
	width: 5.125rem;
	height: 5.125rem;
}
.avatar-xxl .border {
	border-width: 6px !important;
}
.avatar-xxl .rounded {
	border-radius: 8px !important;
}
.avatar-xxl .avatar-title {
	font-size: 30px;
}
.avatar-xxl.avatar-away:before,
.avatar-xxl.avatar-offline:before,
.avatar-xxl.avatar-online:before {
	border-width: 4px;
}
.avatar-group {
	display: inline-flex;
}
.avatar-group .avatar + .avatar {
	margin-left: -.75rem;
}
.avatar-group .avatar-xs + .avatar-xs {
	margin-left: -.40625rem;
}
.avatar-group .avatar-sm+.avatar-sm {
	margin-left: -.625rem;
}
.avatar-group .avatar-lg + .avatar-lg {
	margin-left: -1rem;
}
.avatar-group .avatar-xl + .avatar-xl {
	margin-left: -1.28125rem;
}
.avatar-group .avatar:hover {
	z-index: 1;
}

/*-----------------
	8. Header
-----------------------*/

.header {
	background: #fff;
	border-bottom: 1px solid #f0f0f0;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 1001;
	height: 60px;
}
.header .header-left {
	float: left;
	height: 60px;
	padding: 0 20px;
	position: relative;
	text-align: center;
	width: 240px;
	z-index: 1;
	transition: all 0.2s ease-in-out;
}
.header .header-left .logo {
	display: inline-block;
	line-height: 60px;
}
.header .header-left .logo img {
    max-height: 40px;
    width: auto;
}
.header-left .logo.logo-small {
    display: none;
}
.header .dropdown-menu > li > a {
	position: relative;
}
.header .dropdown-toggle:after {
	display: none;
}
.header .has-arrow .dropdown-toggle:after {
	border-top: 0;
	border-left: 0;
	border-bottom: 2px solid #333;
	border-right: 2px solid #333;
	content: '';
	height: 8px;
	display: inline-block;
	pointer-events: none;
	-webkit-transform-origin: 66% 66%;
	-ms-transform-origin: 66% 66%;
	transform-origin: 66% 66%;
	-webkit-transform: rotate(45deg);
	-ms-transform: rotate(45deg);
	transform: rotate(45deg);
	-webkit-transition: all 0.15s ease-in-out;
	transition: all 0.15s ease-in-out;
	width: 8px;
	vertical-align: 2px;
}
.header .has-arrow .dropdown-toggle[aria-expanded="true"]:after {
	-webkit-transform: rotate(-135deg);
	-ms-transform: rotate(-135deg);
	transform: rotate(-135deg);
}
.user-menu {
    float: right;
    margin: 0;
    position: relative;
    z-index: 99;
}
.user-menu.nav > li > a {
	color: #333;
	font-size: 14px;
	line-height: 58px;
	padding: 0 15px;
	height: 60px;
}
.user-menu.nav > li > a:hover,
.user-menu.nav > li > a:focus {
	background-color: rgba(0, 0, 0, 0.2);
}
.user-menu.nav > li > a:hover i,
.user-menu.nav > li > a:focus i {
	color: #333;
}
.user-img {
	display: inline-block;
	margin-right: 3px;
	position: relative;
}
.user-menu.nav > li > a.mobile_btn {
	border: 0;
	position: relative;
	padding: 0;
	margin: 0;
	cursor: pointer
}
.user-menu .dropdown-menu {
    min-width: 200px;
    padding: 0;
}
.user-menu .dropdown-menu .dropdown-item {
    padding: 7px 15px;
}
.user-menu .dropdown-menu .dropdown-item {
    display: flex;
    align-items: center;
    border-top: 1px solid #e3e3e3;
    padding: 10px 15px;
}
.user-menu .dropdown-menu .dropdown-item:hover {
	color: #fff;
    background: #00d0f1;
}
.header .dropdown-menu > li > a:focus,
.header .dropdown-menu > li > a:hover {
	background-color: #00d0f1;
	color: #fff;
}
.header .dropdown-menu > li > a:focus i,
.header .dropdown-menu > li > a:hover i {
	color: #fff;
}
.header .dropdown-menu > li > a {
	padding: 10px 18px;
}
.header .dropdown-menu > li > a i {
	color: #00d0f1;
	margin-right: 10px;
	text-align: center;
	width: 18px;
}
.header .user-menu .dropdown-menu > li > a i {
	color: #00d0f1;
	font-size: 16px;
	margin-right: 10px;
	min-width: 18px;
	text-align: center;
}
.header .user-menu .dropdown-menu > li > a:focus i,
.header .user-menu .dropdown-menu > li > a:hover i {
	color: #fff;
}
.mobile_btn {
	display: none;
	float: left;
}
.slide-nav .sidebar {
	margin-left: 0;
}
.app-dropdown .dropdown-menu {
    padding: 0;
    width: 300px;
}
.app-dropdown-menu .app-list {
    padding: 15px;
}
.app-dropdown-menu .app-item {
    border: 1px solid transparent;
    border-radius: 3px;
    color: #737373;
    display: block;
    padding: 10px 0;
    text-align: center;
}
.app-dropdown-menu .app-item i {
    font-size: 20px;
    height: 24px;
}
.app-dropdown-menu .app-item span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.app-dropdown-menu .app-item:hover,
.app-dropdown-menu .app-item:focus,
.app-dropdown-menu .app-item:active, 
.app-dropdown-menu .app-item.active {
	background-color: #f9f9f9;
	border-color: #e3e3e3;
}
.app-list > div + div {
	margin-top: 5px;
}
.app-list > .row {
	margin-left: -5px;
	margin-right: -5px;
}
.app-list > .row > .col {
	padding-left: 5px;
	padding-right: 5px;
}
.user-header {
    background-color: #f9f9f9;
    display: flex;
    padding: 10px 15px;
}
.user-header .user-text {
	margin-left: 10px;
}
.user-header .user-text h6 {
    margin-bottom: 2px;
}
.menu-title {
    color: #a3a3a3;
    display: block;
    font-size: 14px;
    margin-bottom: 5px;
    padding: 0 25px;
}
.sidebar-overlay {
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
    height: 100%;
    left: 0;
    position: fixed;
    top: 60px;
    width: 100%;
    z-index: 1000;
}
html.menu-opened {
	overflow: hidden;
}
html.menu-opened body {
	overflow: hidden;
}

/* Search */

.top-nav-search {
    float: left;
    margin-left: 15px;
}
.top-nav-search form {
    margin-top: 10px;
	position: relative;
    width: 230px;
}
.top-nav-search .form-control {
  
    border-color: rgba(0, 0, 0, 0.1);
    border-radius: 50px;
    color: #333;
    height: 40px;
    padding: 10px 50px 10px 15px;
}
.top-nav-search .btn {
    background-color: transparent;
    border-color: transparent;
    color: #333;
    min-height: 40px;
    padding: 7px 15px;
    position: absolute;
    right: 0;
    top: 0;
}
.top-nav-search .form-control::-webkit-input-placeholder {
	color: #333;
}
.top-nav-search .form-control::-moz-placeholder {
	color: #333;
}
.top-nav-search .form-control:-ms-input-placeholder {
	color: #333;
}
.top-nav-search .form-control::-ms-input-placeholder {
	color: #333;
}
.top-nav-search .form-control::placeholder {
	color: #333;
}
.top-nav-search.active form {
    display: block;
    left: 0;
    position: absolute;
}

/*-----------------
	9. Sidebar
-----------------------*/

.sidebar {
    background-color: #1b5a90;
   /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);*/
    bottom: 0;
    left: 0;
    margin-top: 0;
    position: fixed;
    top: 60px;
    transition: all 0.2s ease-in-out 0s;
    width: 240px;
    z-index: 1001;
}
.sidebar.opened {
	-webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}
.sidebar-inner {
	height: 100%;
	min-height: 100%;
	transition: all 0.2s ease-in-out 0s;
}
.sidebar-menu {
    padding: 15px;
}
.sidebar-menu ul {
	font-size: 15px;
	list-style-type: none;
	margin: 0;
	padding: 0;
	position: relative;
}
.sidebar-menu li a {
	color: #fff;
	display: block;
	font-size: 16px;
	height: auto;
	padding: 0 20px;
}
.sidebar-menu li a:hover {
    color: #5ae8ff;
}
.sidebar-menu > ul > li > a:hover {
	background-color: #19c1dc;
    color: #fff;
}
.sidebar-menu > ul > li.active > a:hover {
    background-color: #19c1dc;
    color: #fff;
}
.sidebar-menu li.active a {
    background-color: #00d0f1;
    color: #fff;
}
.menu-title {
    color: #ebebeb;
    display: flex;
    font-size: 14px;
    opacity: 1;
    padding: 5px 15px;
    white-space: nowrap;
}
.menu-title > i {
	float: right;
	line-height: 40px;
}
.sidebar-menu li.menu-title a {
    color: #ff9b44;
    display: inline-block;
    margin-left: auto;
    padding: 0;
}
.sidebar-menu li.menu-title a.btn {
    color: #fff;
    display: block;
    float: none;
    font-size: 15px;
    margin-bottom: 15px;
    padding: 10px 15px;
}
.sidebar-menu ul ul a.active {
	color: #20e3ff;
	text-decoration: underline;
}
.mobile_btn {
	display: none;
	float: left;
}
.sidebar .sidebar-menu > ul > li > a span {
	transition: all 0.2s ease-in-out 0s;
	display: inline-block;
	margin-left: 10px;
	white-space: nowrap;
}
.sidebar .sidebar-menu > ul > li > a span.chat-user {
    margin-left: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}
.sidebar .sidebar-menu > ul > li > a span.badge {
	margin-left: auto;
}
.sidebar-menu ul ul a {
    display: block;
    font-size: 15px;
    padding: 7px 10px 7px 45px;
    position: relative;
}
.sidebar-menu ul ul {
	display: none;
}
.sidebar-menu ul ul ul a {
	padding-left: 65px;
}
.sidebar-menu ul ul ul ul a {
	padding-left: 85px;
}
.sidebar-menu > ul > li {
    margin-bottom: 3px;
    position: relative;
}
.sidebar-menu > ul > li:last-child {
    margin-bottom: 0;
}
.sidebar-menu .menu-arrow {
	-webkit-transition: -webkit-transform 0.15s;
	-o-transition: -o-transform 0.15s;
	transition: transform .15s;
	position: absolute;
	right: 15px;
	display: inline-block;
	font-family: 'FontAwesome';
	text-rendering: auto;
	line-height: 40px;
	font-size: 16px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-transform: translate(0, 0);
	-ms-transform: translate(0, 0);
	-o-transform: translate(0, 0);
	transform: translate(0, 0);
	line-height: 18px;
	top: 11px;
}
.sidebar-menu .menu-arrow:before {
	content: "\\f105";
}
.sidebar-menu li a.subdrop .menu-arrow {
	-ms-transform: rotate(90deg);
	-webkit-transform: rotate(90deg);
	-o-transform: rotate(90deg);
	transform: rotate(90deg);
}
.sidebar-menu ul ul a .menu-arrow {
	top: 10px;
}
.sidebar-menu > ul > li > a {
    align-items: center;
    border-radius: 3px;
    display: flex;
    justify-content: flex-start;
    padding: 8px 15px;
    position: relative;
    transition: all 0.2s ease-in-out 0s;
	color: #f1f1f1;
}
.sidebar-menu ul li a i {
	display: inline-block;
	font-size: 24px;
	line-height: 24px;
	text-align: left;
	vertical-align: middle;
	width: 20px;
	transition: all 0.2s ease-in-out 0s;
}
.sidebar-menu ul li.menu-title a i {
	font-size: 16px !important;
	margin-right: 0;
	text-align: right;
	width: auto;
}
.sidebar-menu li a > .badge {
    color: #fff;
}
/*-----------------
	6. Toggle Button
-----------------------*/

.check {
	display: block;
	margin: 0;
	padding: 0;
	width: 0;
	height: 0;
	visibility: hidden;
	opacity: 0;
	pointer-events: none;
	position: absolute;
}
.checktoggle {
    background-color: #e0001a;
    border-radius: 12px;
    cursor: pointer;
    display: block;
    font-size: 0;
    height: 24px;
    margin-bottom: 0;
    position: relative;
    width: 48px;
}
.checktoggle:after {
	content: ' ';
	display: block;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translate(5px, -50%);
	width: 16px;
	height: 16px;
	background-color: #fff;
	border-radius: 50%;
	transition: left 300ms ease, transform 300ms ease;
}
.check:checked + .checktoggle {
	background-color: #55ce63;
}
.check:checked + .checktoggle:after {
	left: 100%;
	transform: translate(calc(-100% - 5px), -50%);
}
.onoffswitch {
	margin-left: auto;
    position: relative;
	width: 73px;
    -webkit-user-select:none;
	-moz-user-select:none;
	-ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block; 
	overflow: hidden; 
	cursor: pointer;
	border-radius: 20px;
	margin-bottom: 0;
}
.onoffswitch-inner {
	display: block;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
    width: 200%;
}
.onoffswitch-inner:before, .onoffswitch-inner:after {
    box-sizing: border-box;
    color: #fff;
    display: block;
    float: left;
    font-size: 16px;
    height: 30px;
    line-height: 32px;
    padding: 0;
    width: 50%;
}
.onoffswitch-inner:before {
	background-color: #55ce63;
    color: #fff;
    content: "ON";
    padding-left: 14px;
}
.onoffswitch-inner:after {
    content: "OFF";
    padding-right: 14px;
    background-color: #ccc;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    background: #fff;
    border-radius: 20px;
    bottom: 0;
    display: block;
	height: 20px;
    margin: 5px;
    position: absolute;
    right: 43px;
    top: 0;
    transition: all 0.3s ease-in 0s;
    width: 20px;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px; 
}

/*-----------------
	10. Content
-----------------------*/

.main-wrapper {
	width: 100%;
	height: 100vh;
	min-height: 100vh;
}
.page-wrapper {
	margin-left: 240px;
	padding-top: 60px;
	position: relative;
	transition: all 0.4s ease;
}
.page-wrapper > .content {
	padding: 1.875rem 1.875rem 0;
}
.page-header {
	margin-bottom: 1.875rem;
}
.page-header .breadcrumb {
    background-color: transparent;
    color: #6c757d;
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 0;
    padding: 0;
}
.page-header .breadcrumb a {
	color: #333;
}
.page-title {
    color: #333;
    margin-bottom: 5px;
}

/*-----------------
	11. Login
-----------------------*/

.login-body {
    display: table;
    height: 100vh;
    min-height: 100vh;
}
.login-wrapper {
	width: 100%;
	height: 100%;
	display: table-cell;
	vertical-align: middle;
}
.login-wrapper .loginbox {
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	display: flex;
    margin: 1.875rem auto;
    max-width: 800px;
    min-height: 500px;
    width: 100%;
}
.login-wrapper .loginbox .login-left {
    align-items: center;
    background: linear-gradient(180deg, #1b5a90, #00d0f1);
    border-radius: 6px 0 0 6px;
    flex-direction: column;
    justify-content: center;
    padding: 80px;
    width: 400px;
    display: flex;
}
.login-wrapper .loginbox .login-right {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 40px;
    width: 400px;
}
.login-wrapper .loginbox .login-right .login-right-wrap {
    max-width: 100%;
    flex: 0 0 100%;
}
.login-wrapper .loginbox .login-right h1 {
    font-size: 26px;
    font-weight: 500;
    margin-bottom: 5px;
    text-align: center;
}
.account-subtitle {
    color: #4c4c4c;
    font-size: 17px;
    margin-bottom: 1.875rem;
    text-align: center;
}
.login-wrapper .loginbox .login-right .forgotpass a {
	color: #a0a0a0;
}
.login-wrapper .loginbox .login-right .forgotpass a:hover {
	color: #333;
	text-decoration: underline;
}
.login-wrapper .loginbox .login-right .dont-have {
	color: #a0a0a0;
	margin-top: 1.875rem;
}
.login-wrapper .loginbox .login-right .dont-have a {
	color: #333;
}
.login-wrapper .loginbox .login-right .dont-have a:hover {
	text-decoration: underline;
}
.social-login {
	text-align: center;
}
.social-login > span {
	color: #a0a0a0;
	margin-right: 8px;
}
.social-login > a {
	background-color: #ccc;
	border-radius: 4px;
	color: #fff;
	display: inline-block;
	font-size: 18px;
	height: 32px;
	line-height: 32px;
	margin-right: 6px;
	text-align: center;
	width: 32px;
}
.social-login > a:last-child {
	margin-right: 0;
}
.social-login > a.facebook {
	background-color: #4b75bd;
}
.social-login > a.google {
	background-color: #fe5240;
}
.login-or {
	color: #a0a0a0;
	margin-bottom: 20px;
	margin-top: 20px;
	padding-bottom: 10px;
	padding-top: 10px;
	position: relative;
}
.or-line {
	background-color: #e5e5e5;
	height: 1px;
	margin-bottom: 0;
	margin-top: 0;
	display: block;
}
.span-or {
	background-color: #fff;
	display: block;
	left: 50%;
	margin-left: -20px;
	position: absolute;
	text-align: center;
	text-transform: uppercase;
	top: 0;
	width: 42px;
}

/*-----------------
	12. Lock Screen
-----------------------*/

.lock-user {
    margin-bottom: 20px;
    text-align: center;
}
.lock-user img {
    margin-bottom: 15px;
    width: 100px;
}

/*-----------------
	13. Notifications
-----------------------*/

.notifications {
	padding: 0;
}
.notifications .notification-time {
	font-size: 12px;
	line-height: 1.35;
	color: #bdbdbd;
}
.notifications .media {
	margin-top: 0;
	border-bottom: 1px solid #f5f5f5;
}
.notifications .media:last-child {
	border-bottom: none;
}
.notifications .media a {
	display: block;
	padding: 10px 15px;
	border-radius: 2px;
}
.notifications .media a:hover {
	background-color: #fafafa;
}
.notifications .media > .avatar {
	margin-right: 10px;
}
.notifications .media-list .media-left {
	padding-right: 8px;
}
.topnav-dropdown-header {
	border-bottom: 1px solid #eee;
	text-align: center;
}
.topnav-dropdown-header, 
.topnav-dropdown-footer {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    padding-right: 15px;
}
.topnav-dropdown-footer {
	border-top: 1px solid #eee;
}
.topnav-dropdown-footer a {
	display: block;
	text-align: center;
	color: #333;
}
.user-menu.nav > li > a .badge {
	background-color: #1b5a90;
    display: block;
    font-size: 10px;
    font-weight: bold;
    min-height: 15px;
    min-width: 15px;
    position: absolute;
    right: 3px;
    color: #fff;
    top: 6px;
}
.user-menu.nav > li > a > i {
	font-size: 1.5rem;
	line-height: 60px;
}
.noti-details {
	color: #989c9e;
    margin-bottom: 0;
}
.noti-title {
	color: #333;
}
.notifications .noti-content {
	height: 290px;
	width: 350px;
	overflow-y: auto;
	position: relative;
}
.notification-list {
	list-style: none;
	padding: 0;
	margin: 0;
}
.notifications ul.notification-list > li{
	margin-top: 0;
	border-bottom: 1px solid #f5f5f5;
}
.notifications ul.notification-list > li:last-child {
	border-bottom: none;
}
.notifications ul.notification-list > li a {
	display: block;
	padding: 10px 15px;
	border-radius: 2px;
}
.notifications ul.notification-list > li a:hover {
	background-color: #fafafa;
}
.notifications ul.notification-list > li .list-item {
    border: 0;
    padding: 0;
    position: relative;
}
.topnav-dropdown-header .notification-title {
    color: #333;
    display: block;
    float: left;
    font-size: 14px;
}
.topnav-dropdown-header .clear-noti {
    color: #f83f37;
    float: right;
    font-size: 12px;
    text-transform: uppercase;
}
.noti-time {
    margin: 0;
}

/*-----------------
	14. Dashboard
-----------------------*/

.dash-widget-icon {
    align-items: center;
    display: inline-flex;
    font-size: 1.875rem;
    height: 50px;
    justify-content: center;
    line-height: 48px;
    text-align: center;
    width: 50px;
	border: 3px solid;
    border-radius: 50px;
    padding: 28px;
}
.dash-count {
    font-size: 18px;
    margin-left: auto;
}
.dash-widget-info h3 {
    margin-bottom: 10px;
}
.dash-widget-header {
    align-items: center;
    display: flex;
    margin-bottom: 15px;
}
.card-chart .card-body {
	padding: 8px;
}
#morrisArea > svg, #morrisLine > svg  {
	width: 100%;
}
.activity-feed {
    list-style: none;
    margin-bottom: 0;
    margin-left: 5px;
    padding: 0;
}
.activity-feed .feed-item {
    border-left: 2px solid #e4e8eb;
    padding-bottom: 19px;
    padding-left: 20px;
    position: relative;
}
.activity-feed .feed-item:last-child {
	border-color: transparent;
	padding-bottom: 0;
}
.activity-feed .feed-item:after {
	content: "";
	display: block;
	position: absolute;
	top: 0;
	left: -7px;
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: #177dff;
}
.activity-feed .feed-item .feed-date {
	display: block;
	position: relative;
	color: #777;
	text-transform: uppercase;
	font-size: 13px;
 }
.activity-feed .feed-item .feed-text {
	color: #777;
	position: relative;
}
.activity-feed .feed-item .feed-text a {
    color: #333;
    font-weight: 600;
}

/*-----------------
	15. Invoice
-----------------------*/

.add-btn {
    border: 1px solid transparent;
    border-radius: 20px;
    color: #666;
    display: inline-block;
    padding: .375rem .75rem;
}
.add-btn:hover,
.add-btn:active,
.add-btn:focus {
	background-color: #fff;
	border-color: #ddd;
	color: #666;
}
.add-btn span {
    align-items: center;
    background-color: #ffc107;
    border-radius: 50%;
    color: #fff;
    display: inline-flex;
    font-size: 14px;
    height: 22px;
    justify-content: center;
    margin-right: 3px;
    width: 22px;
}
.invoice-details h4 {
	color: #666;
	font-size: 16px;
	font-weight: 400;
	margin-bottom: 1.875rem;
	text-transform: uppercase;
}
.inv-badge {
	color: #fff;
	display: inline-flex;
	font-size: 11px;
	justify-content: center;
	min-width: 80px;
}
.inv-logo {
    max-height: 80px;
}
.invoice-container {
    background-color: #fff;
	border: 1px solid #f0f0f0;
    margin: 0 auto 1.875rem;
    max-width: 900px;
    padding: 1.5rem;
}
.invoice-details,
.invoice-payment-details > li span {
	float: right;
	text-align: right;
}
.inv-logo {
	height: auto;
	max-height: 100px;
	width: auto;
}

/*-----------------
	16. Calendar
-----------------------*/

.calendar-events {
    border: 1px solid transparent;
    cursor: move;
    padding: 10px 15px;
}
.calendar-events:hover {
	border-color: #e9e9e9;
    background-color: #fff;
}
.calendar-events i {
    margin-right: 8px;
}
.calendar {
	float: left;
	margin-bottom: 0;
}
.fc-toolbar.fc-header-toolbar {
    margin-bottom: 1.5rem;
}
.none-border .modal-footer {
	border-top: none;
}
.fc-toolbar h2 {
	font-size: 18px;
	font-weight: 600;
	font-family: 'Roboto', sans-serif;
	line-height: 30px;
	text-transform: uppercase;
}
.fc-day-grid-event .fc-time {
	font-family: 'Roboto', sans-serif;
}
.fc-day {
	background: #fff;
}
.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
	z-index: 0;
}
.fc th.fc-widget-header {
	background: #eeeeee;
	font-size: 14px;
	line-height: 20px;
	padding: 10px 0;
	text-transform: uppercase;
}
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
	border-color: #f3f3f3;
}
.fc-basic-view .fc-day-number, 
.fc-basic-view .fc-week-number {
    padding: 2px 5px;
}
.fc-button {
	background: #f1f1f1;
	border: none;
	color: #797979;
	text-transform: capitalize;
	box-shadow: none !important;
	border-radius: 3px !important;
	margin: 0 3px !important;
	padding: 6px 12px !important;
	height: auto !important;
}
.fc-text-arrow {
	font-family: inherit;
	font-size: 16px;
}
.fc-state-hover {
	background: #f3f3f3;
}
.fc-state-highlight {
	background: #f0f0f0;
}
.fc-state-down,
.fc-state-active,
.fc-state-disabled {
	background-color: #00d0f1 !important;
	color: #fff !important;
	text-shadow: none !important;
}
.fc-cell-overlay {
	background: #f0f0f0;
}
.fc-unthemed .fc-today {
	background: #fff;
}
.fc-event {
	border-radius: 2px;
	border: none;
	color: #fff !important;
	cursor: move;
	font-size: 13px;
	margin: 1px 7px;
	padding: 5px 5px;
	text-align: center;
}
.fc-basic-view td.fc-week-number span {
	padding-right: 8px;
	font-weight: 700;
	font-family: 'Roboto', sans-serif;
}
.fc-basic-view td.fc-day-number {
	padding-right: 8px;
	font-weight: 700;
	font-family: 'Roboto', sans-serif;
}
.event-form .input-group .form-control {
	height: 40px;
}
.submit-section {
	text-align: center;
	margin-top: 40px;
}
.submit-btn {
    border-radius: 50px;
    font-size: 18px;
    font-weight: 600;
    min-width: 200px;
    padding: 10px 20px;
}

/*-----------------
	17. Inbox
-----------------------*/

.dropdown-action {
	margin-bottom: 5px;
}
.dropdown-action .dropdown-toggle:after {
	display: none;
}
.table-inbox input[type="radio"],
.table-inbox input[type="checkbox"] {
	cursor: pointer;
}
.mail-list {
	list-style: none;
	padding: 0;
}
.mail-list > li > a {
	color: #333;
	display: block;
	padding: 10px;
}
.mail-list > li.active > a {
	color: #00d0f1;
	font-weight: bold;
}
.unread .name,
.unread .subject,
.unread .mail-date {
	color: #000;
	font-weight: 600;
}
.table-inbox .fa-star {
	color: #ffd200;
}
.table-inbox .starred.fa-star {
	color: #ffd200;
}
.table.table-inbox > tbody > tr > td,
.table.table-inbox > tbody > tr > th,
.table.table-inbox > tfoot > tr > td,
.table.table-inbox > tfoot > tr > th,
.table.table-inbox > thead > tr > td,
.table.table-inbox > thead > tr > th {
    border-bottom: 1px solid #f2f2f2;
    border-top: 0;
}
.table-inbox {
	font-size: 15px;
	margin-bottom: 0;
}
.table.table-inbox thead {
	background-color: #fff;
}
.note-editor.note-frame {
	border: 1px solid #ddd;
	box-shadow: inherit;
}
.note-editor.note-frame .note-statusbar {
	background-color: #fff;
}
.note-editor.note-frame.fullscreen {
	top: 60px;
}
.note-editor.note-frame .btn-light {
    background-color: #f9f9f9;
    box-shadow: unset;
    color: #333;
}
.mail-title {
	font-weight: bold;
	text-transform: uppercase;
}
.form-control.search-message {
    border-color: #ccc;
    border-radius: 4px;
    height: 38px;
    width: 180px;
}
.table-inbox tr {
	cursor: pointer;
}
table.table-inbox tbody tr.checked {
	background-color: #ffffcc;
}
.mail-label {
    font-size: 16px !important;
    margin-right: 5px;
}

/*-----------------
	18. Mail View
-----------------------*/

.attachments {
	list-style: none;
	margin: 0;
	padding: 0;
}
.attachments li {
	border: 1px solid #eee;
	float: left;
	margin-bottom: 10px;
	margin-right: 10px;
	width: 180px;
}
.attach-info {
	background-color: #f4f4f4;
	padding: 10px;
}
.attach-file {
    color: #777;
    font-size: 70px;
    padding: 10px;
    min-height: 138px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.attach-file img {
	height: auto;
	max-width: 100%;
}
.mailview-header {
	border-bottom: 1px solid #ddd;
	margin-bottom: 20px;
	padding-bottom: 15px;
}
.mailview-footer {
	border-top: 1px solid #ddd;
	margin-top: 20px;
	padding-top: 15px;
}
.mailview-footer .btn-white {
    margin-top: 10px;
    min-width: 102px;
}
.sender-img {
	float: left;
	margin-right: 10px;
	width: 40px;
}
.sender-name {
	display: block;
}
.receiver-name {
	color: #777;
}
.right-action {
	text-align: right;
}
.mail-view-title {
	font-weight: 500;
	font-size: 24px;
	margin: 0;
}
.mail-view-action {
	float: right;
}
.mail-sent-time {
	float: right;
}
.inbox-menu {
	display: inline-block;
	margin: 0 0 1.875rem;
	padding: 0;
	width: 100%;
}
.inbox-menu li {
	display: inline-block;
	width: 100%;
}
.inbox-menu li + li {
	margin-top: 2px;
}
.inbox-menu li a {
	color: #333;
	display: inline-block;
	padding: 10px 15px;
	width: 100%;
	text-transform: capitalize;
	-webkit-transition: 0.3s ease;
	-moz-transition: 0.3s ease;
	transition: 0.3s ease;
}
.inbox-menu li a i {
	font-size: 16px;
	padding-right: 10px;
	color: #878787;
}
.inbox-menu li a:hover, .inbox-menu li.active a, .inbox-menu li a:focus {
	background: rgba(33, 33, 33, 0.05);
}
.compose-btn {
	margin-bottom: 1.875rem;
}
.compose-btn a {
    font-weight: 600;
    padding: 8px 15px;
}

/*-----------------
	19. Error
-----------------------*/

.error-page {
    align-items: center;
    color: #1f1f1f;
    display: flex;
}
.error-page .main-wrapper {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    justify-content: center;
    width: 100%;
	min-height: unset;
}
.error-box {
    margin: 0 auto;
    max-width: 480px;
    padding: 1.875rem 0;
    text-align: center;
    width: 100%;
}
.error-box h1 {
    color: #00d0f1;
    font-size: 10em;
}
.error-box p {
    margin-bottom: 1.875rem;
}
.error-box .btn {
    border-radius: 50px;
    font-size: 18px;
    font-weight: 600;
    min-width: 200px;
    padding: 10px 20px;
}

/*-----------------
	20. Chat
-----------------------*/

.chat-window {
    border: 1px solid #e0e3e4;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    margin-bottom: 1.875rem;
}
.chat-window .chat-cont-left {
    border-right: 1px solid #e0e3e4;
    flex: 0 0 35%;
    left: 0;
    max-width: 35%;
    position: relative;
    z-index: 4;
}
.chat-window .chat-cont-left .chat-header {
    align-items: center;
    background-color: #fff;
    border-bottom: 1px solid #e0e3e4;
    color: #324148;
    display: flex;
    height: 72px;
    justify-content: space-between;
    padding: 0 15px;
}
.chat-window .chat-cont-left .chat-header span {
    font-size: 20px;
    font-weight: 600;
    text-transform: capitalize;
}
.chat-window .chat-cont-left .chat-header .chat-compose {
    color: #8a8a8a;
    display: inline-flex;
}
.chat-window .chat-cont-left .chat-search {
    background-color: #f5f5f6;
    border-bottom: 1px solid #e5e5e5;
    padding: 10px 15px;
    width: 100%;
}
.chat-window .chat-cont-left .chat-search .input-group {
    width: 100%;
}
.chat-window .chat-cont-left .chat-search .input-group .form-control {
    background-color: #fff;
    border-radius: 50px;
    padding-left: 36px;
}
.chat-window .chat-cont-left .chat-search .input-group .form-control:focus {
    border-color: #ccc;
    box-shadow: none;
}
.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend {
    align-items: center;
    bottom: 0;
    color: #666;
    display: flex;
    left: 15px;
    pointer-events: none;
    position: absolute;
    top: 0;
    z-index: 4;
}
.chat-window .chat-scroll {
    max-height: calc(100vh - 285px);
    overflow-y: auto;
}
.chat-window .chat-cont-left .chat-users-list {
    background-color: #fff;
}
.chat-window .chat-cont-left .chat-users-list a.media {
    border-bottom: 1px solid #e5e5e5;
    padding: 10px 15px;
    transition: all 0.2s ease 0s;
}
.chat-window .chat-cont-left .chat-users-list a.media:last-child {
	border-bottom: 0;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap {
    margin-right: 15px;
    position: relative;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {
    height: 45px;
    width: 45px;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .status {
	bottom: 7px;
	height: 10px;
	right: 4px;
	position: absolute;
	width: 10px;
	border: 2px solid #fff;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body {
    display: flex;
    justify-content: space-between;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, 
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
    max-width: 250px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {
    color: #333;
    text-transform: capitalize;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
    color: #8a8a8a;
    font-size: 14px;
    line-height: 24px;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child {
    text-align: right;
}
.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {
    color: #8a8a8a;
    font-size: 13px;
}
.chat-window .chat-cont-left .chat-users-list a.media:hover {
	background-color: #f5f5f6;
}
.chat-window .chat-cont-left .chat-users-list a.media.read-chat .media-body > div:last-child .last-chat-time {
	color: #8a8a8a;
}
.chat-window .chat-cont-left .chat-users-list a.media.active {
	background-color: #f5f5f6;
}
.chat-window .chat-cont-right {
    flex: 0 0 65%;
    max-width: 65%;
}
.chat-window .chat-cont-right .chat-header {
    align-items: center;
    background-color: #fff;
    border-bottom: 1px solid #e0e3e4;
    display: flex;
    height: 72px;
    justify-content: space-between;
    padding: 0 15px;
}
.chat-window .chat-cont-right .chat-header .back-user-list {
    display: none;
    margin-right: 5px;
    margin-left: -7px;
}
.chat-window .chat-cont-right .chat-header .media {
	align-items: center;
}
.chat-window .chat-cont-right .chat-header .media .media-img-wrap {
	position: relative;
	display: flex;
	align-items: center;
	margin-right: 15px;
}
.chat-window .chat-cont-right .chat-header .media .media-img-wrap .avatar {
	height: 50px;
	width: 50px;
}
.chat-window .chat-cont-right .chat-header .media .media-img-wrap .status {
    border: 2px solid #fff;
    bottom: 0;
    height: 10px;
    position: absolute;
    right: 3px;
    width: 10px;
}
.chat-window .chat-cont-right .chat-header .media .media-body .user-name {
    color: #333;
    font-size: 16px;
    font-weight: 600;
    text-transform: capitalize;
}
.chat-window .chat-cont-right .chat-header .media .media-body .user-status {
    color: #666;
    font-size: 14px;
}
.chat-window .chat-cont-right .chat-header .chat-options {
    display: flex;
}
.chat-window .chat-cont-right .chat-header .chat-options > a {
    align-items: center;
    border-radius: 50%;
    color: #8a8a8a;
    display: inline-flex;
    height: 30px;
    justify-content: center;
    margin-left: 10px;
    width: 30px;
}
.chat-window .chat-cont-right .chat-body {
    background-color: #f5f5f6;
}
.chat-window .chat-cont-right .chat-body ul.list-unstyled {
    margin: 0 auto;
    padding: 15px;
    width: 100%;
}
.chat-window .chat-cont-right .chat-body .media .avatar {
    height: 30px;
    width: 30px;
}
.chat-window .chat-cont-right .chat-body .media .media-body {
	margin-left: 20px;
}
.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div {
	padding: 10px 15px;
	border-radius: .25rem;
	display: inline-block;
	position: relative;
}
.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div p {
    color: #333;
    margin-bottom: 0;
}
.chat-window .chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {
	margin-top: 5px;
}
.chat-window .chat-cont-right .chat-body .media.received {
	margin-bottom: 20px;
}
.chat-window .chat-cont-right .chat-body .media:last-child {
	margin-bottom: 0;
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div {
	background-color: #fff;
}
.chat-window .chat-cont-right .chat-body .media.sent {
    margin-bottom: 20px;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body {
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-left: 0;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div {
    background-color: #e3e3e3;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {
    color: #333;
}
.chat-window .chat-cont-right .chat-body .chat-date {
    font-size: 14px;
    margin: 1.875rem 0;
    overflow: hidden;
    position: relative;
    text-align: center;
    text-transform: capitalize;
}
.chat-window .chat-cont-right .chat-body .chat-date:before {
    background-color: #e0e3e4;
    content: "";
    height: 1px;
    margin-right: 28px;
    position: absolute;
    right: 50%;
    top: 50%;
    width: 100%;
}
.chat-window .chat-cont-right .chat-body .chat-date:after {
    background-color: #e0e3e4;
    content: "";
    height: 1px;
    left: 50%;
    margin-left: 28px;
    position: absolute;
    top: 50%;
    width: 100%;
}
.chat-window .chat-cont-right .chat-footer {
    background-color: #fff;
    border-top: 1px solid #e0e3e4;
    padding: 10px 15px;
    position: relative;
}
.chat-window .chat-cont-right .chat-footer .input-group {
    width: 100%;
}
.chat-window .chat-cont-right .chat-footer .input-group .form-control {
    background-color: #f5f5f6;
    border: none;
    border-radius: 50px;
}
.chat-window .chat-cont-right .chat-footer .input-group .form-control:focus {
    background-color: #f5f5f6;
    border: none;
    box-shadow: none;
}
.chat-window .chat-cont-right .chat-footer .input-group .input-group-prepend .btn, 
.chat-window .chat-cont-right .chat-footer .input-group .input-group-append .btn {
    background-color: transparent;
    border: none;
    color: #9f9f9f;
}
.chat-window .chat-cont-right .chat-footer .input-group .input-group-append .btn.msg-send-btn {
    background-color: #00d0f1;
    border-color: #00d0f1;
    border-radius: 50%;
    color: #fff;
    margin-left: 10px;
}
.msg-typing {
	width: auto;
	height: 24px;
	padding-top: 8px
}
.msg-typing span {
	height: 8px;
	width: 8px;
	float: left;
	margin: 0 1px;
	background-color: #a0a0a0;
	display: block;
	border-radius: 50%;
	opacity: .4
}
.msg-typing span:nth-of-type(1) {
	animation: 1s blink infinite .33333s
}

.msg-typing span:nth-of-type(2) {
	animation: 1s blink infinite .66666s
}

.msg-typing span:nth-of-type(3) {
	animation: 1s blink infinite .99999s
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box {
	position: relative;
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {
    border-bottom: 6px solid transparent;
    border-right: 6px solid #fff;
    border-top: 6px solid transparent;
    content: "";
    height: 0;
    left: -6px;
    position: absolute;
    right: auto;
    top: 8px;
    width: 0;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box {
    padding-left: 50px;
    position: relative;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {
	border-bottom: 6px solid transparent;
	border-left: 6px solid #e3e3e3;
	border-top: 6px solid transparent;
    content: "";
    height: 0;
    left: auto;
    position: absolute;
    right: -6px;
    top: 8px;
    width: 0;
}
.chat-msg-info {
    align-items: center;
    display: flex;
    clear: both;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 5px 0 0;
}
.chat-msg-info li {
    font-size: 13px;
    padding-right: 16px;
    position: relative;
}
.chat-msg-info li:not(:last-child):after {
	position: absolute;
	right: 8px;
	top: 50%;
	content: '';
	height: 4px;
	width: 4px;
	background: #d2dde9;
	border-radius: 50%;
	transform: translate(50%, -50%)
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box .chat-msg-info li:not(:last-child)::after {
    right: auto;
    left: 8px;
    transform: translate(-50%, -50%);
    background: #aaa;
}
.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {
    color: rgba(50, 65, 72, 0.4);
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {
    color: rgba(50, 65, 72, 0.4);
}
.chat-msg-info li a {
	color: #777;
}
.chat-msg-info li a:hover {
	color: #2c80ff
}
.chat-seen i {
	color: #00d285;
	font-size: 16px;
}
.chat-msg-attachments {
	padding: 4px 0;
	display: flex;
	width: 100%;
	margin: 0 -1px
}
.chat-msg-attachments > div {
	margin: 0 1px
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {
    flex-direction: row-reverse;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-attachments {
	flex-direction: row-reverse
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {
    padding-left: 16px;
    padding-right: 0;
    position: relative;
}
.chat-attachment img {
    max-width: 100%;
}
.chat-attachment {
	position: relative;
	max-width: 130px;
	overflow: hidden;
}
.chat-attachment {
	border-radius: .25rem;
}
.chat-attachment:before {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: #000;
	content: "";
	opacity: 0.4;
	transition: all .4s;
}
.chat-attachment:hover:before {
	opacity: 0.6;
}
.chat-attach-caption {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	color: #fff;
	padding: 7px 15px;
	font-size: 13px;
	opacity: 1;
	transition: all .4s;
}
.chat-attach-download {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	opacity: 0;
	transition: all .4s;
	color: #fff;
	width: 32px;
	line-height: 32px;
	background: rgba(255, 255, 255, 0.2);
	text-align: center;
}
.chat-attach-download:hover {
	color: #495463;
	background: #fff;
}
.chat-attachment:hover .chat-attach-caption {
	opacity: 0;
}
.chat-attachment:hover .chat-attach-download {
	opacity: 1;
}
.chat-attachment-list {
	display: flex;
	margin: -5px;
}
.chat-attachment-list li {
	width: 33.33%;
	padding: 5px;
}
.chat-attachment-item {
	border: 5px solid rgba(230, 239, 251, 0.5);
	height: 100%;
	min-height: 60px;
	text-align: center;
	font-size: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div:hover .chat-msg-actions {
	opacity: 1;
}
.chat-msg-actions {
	position: absolute;
	left: -30px;
	top: 50%;
	transform: translateY(-50%);
	opacity: 0;
	transition: all .4s;
	z-index: 2;
}
.chat-msg-actions > a {
    padding: 0 10px;
    color: #495463;
    font-size: 24px;
}
.chat-msg-actions > a:hover {
	color: #2c80ff;
}

@keyframes blink {
	50% {
		opacity: 1
	}
}
.btn-file {
    align-items: center;
    display: inline-flex;
    font-size: 20px;
    justify-content: center;
    overflow: hidden;
    padding: 0 0.75rem;
    position: relative;
    vertical-align: middle;
}
.btn-file input {
    cursor: pointer;
    filter: alpha(opacity=0);
    font-size: 23px;
    height: 100%;
    margin: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
}

/*-----------------
	21. Product
-----------------------*/

.product {
	-moz-transition: all 0.5s;
	-webkit-transition: all 0.5s;
	-o-transition: all 0.5s;
	border: 1px solid #e7e7e7;
	border-radius: 5px;
	padding: 10px;
	background-color: #fff;
	margin-bottom: 1.875rem;
}
.product-inner {
	overflow: hidden;
	position: relative;
	width: 100%;
}
.product-inner img {
	width: 100%;
	height: auto;
}
.product-inner .cart-btns {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	opacity: 0;
	transition: all 0.5s;
	-moz-transition: all 0.5s;
	-webkit-transition: all 0.5s;
	-o-transition: all 0.5s;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.cart-btns .btn {
	width: 120px;
	display: block;
	transition: all 0.5s;
	-moz-transition: all 0.5s;
	-webkit-transition: all 0.5s;
	-o-transition: all 0.5s;
}
.cart-btns .btn + .btn {
	margin-top: 10px;
}
.product .pro-desc {
    margin-top: 10px;
}
.pro-desc .price {
	font-size: 18px;
	line-height: 20px;
	color: #333;
	font-weight: bold;
}
.product:hover .cart-btns {
	opacity: 1;
}
.pro-desc h5 {
	font-size: 1rem;
}
.pro-desc h5 a {
	color: #333;
}
.product-det {
	position: relative;
	display: block;
	float: left;
	width: 100%;
	min-height: 40px;
}
.product-desc {
	padding: 0 0 0 70px;
}
.product-det > img {
	top: 0;
	width: 60px;
	position: absolute;
	left: 0;
}
.product-desc span,
.product-desc a {
	width: 100%;
	margin: 0;
	padding: 0;
	display: block;
}

/*-----------------
	22. Product Details
-----------------------*/

.product-content {
	position: relative;
}
.product-content p {
	color: #333;
	margin: 0 0 20px;
}
.product-content p:last-child {
	margin-bottom: 0;
}
.proimage-thumb {
	float: left;
	list-style: none;
	padding: 0;
}
.proimage-thumb li {
	float: left;
	height: 60px;
	width: 80px;
	text-align: center;
	margin: 13px 12px 0 0;
}
.proimage-thumb li img {
	display: block;
	height: 62px;
	width: 81px;
	border-radius: 3px;
	-moz-border-radius: 3px;
	-webkit-border-radius: 3px;
	position: relative;
}
.rated {
	color: #fc0;
}
.product_price {
	font-size: 30px;
	font-weight: bold;
}
.review-list {
	list-style: none;
	margin: 0;
	padding: 0;
}
.review-list li {
	clear: both;
	padding-left: 80px;
}
.review-list li .review {
	margin-bottom: 1.875rem;
}
.review-list li .review-author {
	margin-left: -80px;
	position: absolute;
}
.review-list li img.avatar {
	height: 58px;
	width: 58px;
	border-radius: 58px;
}
.review-by {
	display: block;
	font-size: 14px;
	line-height: 21px;
	margin: 0 0 10px;
}
.review-list .review-block p {
	line-height: 20px;
	margin: 0;
	text-align: justify;
}
.new-review label {
	font-size: 14px;
	font-weight: 500;
}
.new-review input.form-control {
	border: 1px solid #e5e5e5;
	border-radius: 0;
	box-shadow: inherit;
	height: 40px;
}
.new-review textarea.form-control {
	border: 1px solid #e5e5e5;
	border-radius: 0;
	box-shadow: inherit;
}
.new-review .form-group {
	margin-bottom: 20px;
}
.review-submit .btn {
	background-color: #00bf6f;
	border-color: #00bf6f;
	border-radius: 0;
	font-size: 18px;
	padding: 8px 26px;
	color: #fff;
}
.review-date {
	color: #999;
}
.review-author-name {
    font-size: 18px;
    margin-bottom: 0.5rem;
    display: inline-block;
}
.product-reviews {
	margin-bottom: 1.875rem;
}
.rating {
    display: flex;
}
.rating i + i {
    margin-left: 2px;
}

/*-----------------
	23. Profile
-----------------------*/

.profile-header {
    background-color: #fff;
    border: 1px solid #f0f0f0;
    padding: 1.5rem;
}
.profile-menu {
    background-color: #fff;
	border: 1px solid #f0f0f0;
    padding: 0.9375rem 1.5rem;
}
.profile-menu .nav-tabs.nav-tabs-solid {
	background-color: transparent;
}
.profile-header img {
    height: auto;
    max-width: 120px;
    width: 120px;
}
.profile-tab-cont {
	padding-top: 1.875rem;
}
.about-text {
    max-width: 500px;
}
.skill-tags span {
    background-color: #f4f4f5;
    border-radius: 4px;
    color: #66676b;
    display: inline-block;
    font-size: 15px;
    line-height: 22px;
    margin: 2px 0;
    padding: 5px 15px;
}
.edit-link {
    color: #66676b;
    font-size: 16px;
    margin-top: 4px;
}
.cal-icon {
	position: relative;
	width: 100%;
}
.cal-icon:after {
	color: #979797;
	content: "\\f073";
	display: block;
	font-family: "FontAwesome";
    font-size: 15px;
    margin: auto;
    position: absolute;
    right: 15px;
    top: 10px;
}
.form-title {
    width: 100%;
    max-width: 100%;
    padding: 0;
    font-size: 1.25rem;
	font-weight: 500;
    line-height: inherit;
    color: #333;
    white-space: normal;
    position: relative;
    display: block;
    margin-bottom: 20px;
}
.form-title:before {
    content: "";
    position: absolute;
    left: 0px;
    right: 0px;
    height: 1px;
    top: 50%;
    background-color: rgba(0, 0, 0, 0.1);
}
.form-title span {
    padding: 0px 0.5rem 0 0;
    background-color: #fff;
    display: inline-block;
    z-index: 2;
    position: relative;
}

/*-----------------
	24. Template Options
-----------------------*/

.skin-settings {
	z-index: 999;
	position: fixed;
	top: 50%;
	width: 190px;
	border: 0;
	box-shadow: none;
	padding: 0;
	border-bottom-left-radius: 2px;
	right: -190px;
	background: #fff;
	transition: all 0.4s ease;
}
.skin-settings.active {
	right: 0;
	transition: all 0.4s ease;
}
.skin-settings .skin-sett-icon {
    background-color: #fff;
    border-bottom-left-radius: 2px;
    border-color: #e0e0e0;
    border-style: solid;
    border-top-left-radius: 2px;
    border-width: 1px 0 1px 1px;
    color: #666;
    cursor: pointer;
    display: inline-block;
    font-size: 20px;
    height: 48px;
    left: -47px;
    line-height: 48px;
    position: absolute;
    text-align: center;
    top: 0;
    width: 48px;
}
.skin-settings .skin-sett-body {
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
    color: #616161;
    padding: 14px 10px;
}
.skin-sett-body h4 {
    color: #666;
    font-size: 1.125rem;
}
.skin-settings .skin-colors {
    font-size: 0;
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
}
.skin-settings .skin-colors > li {
    display: inline-block;
}
.skin-settings .skin-colors li a {
    border-radius: 2px;
	cursor: pointer;
    display: block;
    height: 36px;
    margin: 0 3px;
	position: relative;
    width: 36px;
}
.skin-settings .skin-colors .skin-red {
    background-color: #c12942;
}
.skin-settings .skin-colors .skin-orange {
	background-color: #ff7000;
}
.skin-settings .skin-colors .skin-teal {
	background: linear-gradient(to right, #00a0b0 0%, #00d2e6 100%);
}
.skin-settings .skin-colors .skin-purple {
	background-color: #00d0f1;
}
.skin-settings .skin-colors li a.active:after {
    color: #fff;
	content: "\\f00c";
    display: block;
    font-family: "FontAwesome";
    font-size: 15px;
    left: 50%;
    margin: auto;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
}

/*-----------------
	25. Blog
-----------------------*/

.blog {
	border: 1px solid #f0f0f0;
	background-color: #fff;
	border-radius: 4px;
	margin-bottom: 30px;
	padding: 1.5rem;
	position: relative;
}
.blog-image {
	overflow: hidden;
}
.blog-image,
.blog-image > a,
.blog-image img {
	display: block;
	position: relative;
	width: 100%;
	height: auto;
}
.blog-image img {
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
	transform: translateZ(0);
	-moz-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	-ms-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	-o-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	-webkit-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
}
.blog-image a:hover img {
    -webkit-transform: scale(1.15);
    -moz-transform: scale(1.15);
    transform: scale(1.15);
}
.blog-image {
	margin-bottom: 30px;
}
.blog-content {
	position: relative;
}
.blog-title {
	font-size: 22px;
	margin: 0 0 10px;
}
.blog-title a {
	color: #272b41;
}
.blog-title a:hover {
	color: #20c0f3;
}
.blog-content p {
	color: #666;
	font-size: 14px;
	margin: 0 0 30px;
}
.read-more {
    display: inline-block;
    font-size: 16px;
    padding: 0;
    color: #20c0f3;
    text-decoration: underline;
    font-weight: bold;
}
.blog-info {
    color: #757575;
    font-size: 14px;
    margin-bottom: 15px;
}
.blog-info a {
	color: #757575;
}
.blog-info a:hover {
	color: #757575;
}
.blog-info i {
	color: #20c0f3;
	font-size: 14px;
	margin-right: 5px;
}
.entry-meta {
	color: #757575;
	font-size: 14px;
	list-style: none;
	margin-bottom: 15px;
	padding: 0;
}
.entry-meta li {
    display: inline-block;
    margin-right: 15px;
}
.entry-meta li:last-child {
	margin-right: 0;
}
.blog-pagination .pagination {
	margin-bottom: 30px;
}
.blog-pagination .pagination li a {
    padding: 12px 20px;
    font-weight: 600;
    color: #2E3842;
    margin-right: 10px;
    border-radius: inherit !important;
	border-color: #f0f0f0;
}
.blog-pagination .pagination li.disabled a {
	border-color: #f0f0f0;
}
.blog-pagination .pagination li.active a {
	background: #20c0f3;
	border-color: transparent;
	color: #ffffff;
}
.post-left ul {
	margin: 0;
	padding-left: 0;
	list-style: none;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
}
.post-left ul li {
	margin-bottom: 5px;
	margin-right: 20px;
}
.post-left ul li:last-child {
	margin-right: 0;
}
.post-author a {
	display: flex;
	align-items: center;
}
.video {
	position: relative;
	padding-bottom: 56%;
	height: 0;
	overflow: hidden;
}
.video iframe,
.video object,
.video embed {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: none;
}
.latest-posts {
	margin: 0;
	padding: 0;
}
.latest-posts li {
	display: table;
	width: 100%;
	margin-bottom: 20px;
}
.latest-posts li:last-child {
	padding-bottom: 0px;
	margin-bottom: 0px;
	border-bottom: none;
}
.post-thumb {
	border-radius: 4px;
	width: 80px;
	float: left;
	overflow: hidden;
}
.post-thumb a img {
	border-radius: 4px;
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
	transform: translateZ(0);
	-moz-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	-ms-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	-o-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	-webkit-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
	transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;
}
.post-thumb a:hover img {
    -webkit-transform: scale(1.15);
    -moz-transform: scale(1.15);
    transform: scale(1.15);
}
.post-info {
	margin-left: 95px;
}
.post-info h4 {
	font-size: 15px;
	margin: 0 0 5px;
}
.post-info h4 a {
	color: #272b41;
}
.post-info h4 a:hover {
	color: #20c0f3;
}
.post-info p {
	color: #757575;
	font-size: 12px;
	margin: 0;
}
.post-info p i {
	color: #20c0f3;
	font-size: 14px;
	margin-right: 4px;
}
.category-widget .categories {
	list-style: none;
	margin: 0;
	padding: 0;
}
.category-widget .categories li {
    margin-bottom: 20px;
}
.category-widget .categories li:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
}
.category-widget .categories li a {
    color: #2E3842;
    font-size: 15px;
    font-weight: 500;
}
.category-widget .categories li a span {
    float: right;
    color: #757575;
}
.category-widget .categories li a:hover {
	color: #20c0f3;
}
.category-widget .categories > li > a > i {
	color: #20c0f3;
	font-size: 18px;
	margin-right: 10px;
}
.tags-widget .card-body {
	padding-bottom: 1rem;
}
.tags {
	list-style: none;
	margin: 0;
	overflow: hidden;
	padding: 0;
}
.tags li {
	float: left;
}
.tag {
	background-color: #fff;
	border-radius: 4px;
	color: #272b41;
	padding: 5px 10px;
	position: relative;
	margin: 0 .5rem .5rem 0;
	font-size: 14px;
	border: 1px solid #ccc;
	display: inline-block;
}
.tag:hover {
	background-color: #20c0f3;
	border-color: #20c0f3;
	color: #fff;
}
.comment-by {
	display: block;
	font-size: 14px;
	line-height: 21px;
	margin: 0 0 10px;
}
.comments-list .comment-block p {
    font-size: 14px;
    margin-bottom: 5px;
}

/*-----------------
	26. Blog Details
-----------------------*/

.blog-view .blog-title {
	font-size: 24px;
}
.blog-content p:last-child {
	margin-bottom: 0;
}
.blog-view .blog-info {
	border: 0;
	margin-bottom: 20px;
	padding: 0;
}
.social-share {
	float: left;
	list-style: none;
	margin: 0;
	padding: 0;
}
.social-share > li {
	display: inline-block;
	float: left;
	margin-left: 10px;
	text-align: center;
}
.social-share > li:first-child {
	margin-left: 0;
}
.social-share > li > a {
	border: 1px solid #dfdfdf;
	color: #666;
	display: inline-block;
	font-size: 22px;
	height: 40px;
	line-height: 40px;
	width: 40px;
}
.social-share > li > a:hover {
	background-color: #20c0f3;
	color: #fff;
	border-color: #20c0f3;
}
.blog-reply > a {
	color: #999;
	font-size: 12px;
	font-weight: 500;
}
.blog-date {
	color: #999;
	font-size: 12px;
}
.blog-comments .comments-list {
	list-style: none;
	margin: 0;
	padding: 0;
	position: relative;
}
.blog-comments .comments-list li {
	clear: both;
	padding-left: 80px;
}
.blog-comments .comments-list li .comment {
	margin-bottom: 20px;
}
.blog-comments .comments-list li .comment-author {
	left: 0;
	position: absolute;
}
.blog-comments .comments-list li img.avatar {
	height: 58px;
	width: 58px;
	border-radius: 58px;
}
.blog-comments .comment-btn {
    color: #20c0f3;
    display: inline-block;
    font-weight: 500;
    font-size: 15px;
}
.blog-author-name {
    color: #272b41;
    font-size: 16px;
    font-weight: 600;
}
.new-comment label {
	font-weight: 500;
}
.comment-submit .btn {
	background-color: #20c0f3;
	border-color: #20c0f3;
	border-radius: 0;
	font-size: 18px;
	padding: 8px 26px;
	color: #fff;
}
.about-author-img {
	background-color: #fff;
	height: 100px;
	overflow: hidden;
	position: absolute;
	width: 100px;
}
.author-details {
	margin-left: 120px;
}
.about-author {
	min-height: 100px;
}
.author-details .blog-author-name {
	display: inline-block;
	margin-bottom: 10px;
}
.post-author img {
    border-radius: 100%;
    width: 28px;
    margin-right: 5px;
}
.custom-edit-service textarea.form-control{
	min-height: 200px;
}
.custom-edit-service .service-upload {
    border: 1px solid #dcdcdc;
    border-radius: .25rem;
    text-align: center;
    padding: 70px 0;
    margin-bottom: 30px;
    background-color: #fff;
    position: relative;
}
.custom-edit-service .service-upload input[type="file"] {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}
.custom-edit-service .service-upload i{
	font-size: 50px;
    color: #858585;
}
.custom-edit-service .service-upload span {
    font-size: 15px;
    color: #858585;
    margin-top: 14px;
    display: block;
}
.custom-edit-service .upload-wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
}
.custom-edit-service .upload-wrap li {
    margin: 10px;
}
.custom-edit-service .upload-wrap li:first-child{
	margin-left: 0;
}
.custom-edit-service .upload-wrap li .upload-images{
	width: 80px;
	position: relative;
}
.custom-edit-service .upload-wrap li img{
	max-width: 100%;
}
/*-----------------
	27. Blog Grid
-----------------------*/

.grid-blog .blog-title {
    font-size: 18px;
    margin: 0 0 5px;
    min-height: 43px;
}
.grid-blog .blog-content p {
	margin: 0 0 15px;
}
.grid-blog .blog-info {
	margin-bottom: 15px;
}
.grid-blog .blog-image {
	margin-bottom: 20px;
}
.blog.grid-blog {
	padding: 20px;
}
.grid-blog .entry-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: 0;
}
.grid-blog .entry-meta li {
	margin-bottom: 10px;
}
.grid-blog .entry-meta li:last-child {
	flex: 0 0 100px;
	max-width: 100px;
}
.grid-blog .post-author {
    width: 189px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.grid-blog .post-author a:hover {
	color: #20c0f3
}

/*-----------------
	28. Responsive
-----------------------*/

@media only screen and (min-width:768px) {
	.avatar-xxl {
		width: 8rem;
		height: 8rem;
	}
	.avatar-xxl .border {
		border-width: 4px !important;
	}
	.avatar-xxl .rounded {
		border-radius: 12px !important;
	}
	.avatar-xxl .avatar-title {
		font-size: 42px;
	}
	.avatar-xxl.avatar-away:before,
	.avatar-xxl.avatar-offline:before,
	.avatar-xxl.avatar-online:before {
		border-width: 4px;
	}
}

@media only screen and (min-width: 992px) {
	#toggle_btn {
		align-items: center;
		color: #333;
		display: inline-flex;
		float: left;
		font-size: 30px;
		height: 60px;
		justify-content: center;
		margin-left: 15px;
		padding: 0 15px;
	}
	.mini-sidebar .header-left .logo img {
		height: auto;
		max-height: 40px;
		width: auto;
	}
	.mini-sidebar .header .header-left .logo {
		display: none;
	}
	.mini-sidebar .header-left .logo.logo-small {
		display: block;
	}
	.mini-sidebar .header .header-left {
		padding: 0 5px;
		width: 78px;
	}
	.mini-sidebar .sidebar {
		width: 78px;
	}
	.mini-sidebar.expand-menu .sidebar {
		width: 240px;
	}
	.mini-sidebar .menu-title {
		visibility: hidden;
		white-space: nowrap;
	}
	.mini-sidebar.expand-menu .menu-title {
		visibility: visible;
	}
	.mini-sidebar .menu-title a {
		visibility: hidden;
	}
	.mini-sidebar.expand-menu .menu-title a {
		visibility: visible;
	}
	.modal-open.mini-sidebar .sidebar {
		z-index: 1051;
	}
	.mini-sidebar .sidebar .sidebar-menu ul > li > a span {
		display: none;
		transition: all 0.2s ease-in-out;
		opacity: 0;
	}
	.mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a span {
		display: inline;
		opacity: 1;
	}
	.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li > a i {
		font-size: 24px;
		width: 20px;
	}
	.mini-sidebar .page-wrapper {
		margin-left: 78px;
	}
}

@media only screen and (max-width: 1400px) {
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, 
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 180px;
	}
}
@media only screen and (max-width: 1199px) {
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, 
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 150px;
	}
	.chat-window .chat-cont-left {
		flex: 0 0 40%;
		max-width: 40%;
	}
	.chat-window .chat-cont-right {
		flex: 0 0 60%;
		max-width: 60%;
	}
}
@media only screen and (max-width: 991.98px) {
	.header .header-left {
		position: absolute;
		width: 100%;
	}
	.mobile_btn {
		color: #333 !important;
		cursor: pointer;
		display: block;
		font-size: 24px;
		height: 60px;
		left: 0;
		line-height: 60px;
		padding: 0 15px;
		position: absolute;
		text-align: center;
		top: 0;
		z-index: 10;
	}
	#toggle_btn {
		display: none;
	}
	.top-nav-search {
		display: none;
	}
	.login-wrapper .loginbox .login-left {
		padding: 80px 50px;
		width: 50%;
	}
	.login-wrapper .loginbox .login-right {
		padding: 50px;
		width: 50%;
	}
	.sidebar {
		margin-left: -225px;
		width: 225px;
		-webkit-transition: all 0.4s ease;
		-moz-transition: all 0.4s ease;
		transition: all 0.4s ease;
		z-index: 1041;
	}
	.page-wrapper {
		margin-left: 0;
		padding-left: 0;
		padding-right: 0;
		-webkit-transition: all 0.4s ease;
		-moz-transition: all 0.4s ease;
		transition: all 0.4s ease;
	}
	.chat-window .chat-scroll {
		max-height: calc(100vh - 285px);
	}
	.chat-window .chat-cont-left, .chat-window .chat-cont-right {
		flex: 0 0 100%;
		max-width: 100%;
		transition: left 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s;
		width: 100%;
	}
	.chat-window .chat-cont-left {
		border-right: 0;
	}
	.chat-window .chat-cont-right {
		position: absolute;
		right: calc(-100% + -1.875rem);
		top: 0;
	}
	.chat-window .chat-cont-right .chat-header {
		justify-content: start;
	}
	.chat-window .chat-cont-right .chat-header .back-user-list {
		display: block;
	}
	.chat-window .chat-cont-right .chat-header .chat-options {
		margin-left: auto;
	}
	.chat-window.chat-slide .chat-cont-left {
		left: calc(-100% + -1.875rem);
	}
	.chat-window.chat-slide .chat-cont-right {
		right: 0;
	}
	.sidebar-overlay.opened {
		display: block;
	}
}

@media only screen and (max-width: 767.98px) {
	body {
		font-size: 0.9375rem;
	}
	h1, .h1 {
		font-size: 2rem;
	}
	h2, .h2 {
		font-size: 1.75rem;
	}
	h3, .h3 {
		font-size: 1.5rem;
	}
	h4, .h4 {
		font-size: 1.125rem;
	}
	h5, .h5 {
		font-size: 1rem;
	}
	h6, .h6 {
		font-size: 0.875rem;
	}
	.header .has-arrow .dropdown-toggle:after {
		display: none;
	}
	.user-menu.nav > li > a > span:not(.user-img) {
		display: none;
	}
	.navbar-nav .open .dropdown-menu {
		float: left;
		position: absolute;
	}
	.navbar-nav.user-menu .open .dropdown-menu {
		left: auto;
		right: 0;
	}
	.header .header-left {
		padding: 0 15px;
	}
	.header .header-left .logo {
		display: none;
	}
	.header-left .logo.logo-small {
		display: inline-block;
	}
	.login-wrapper .loginbox .login-left {
		display: none;
	}
	.login-wrapper .loginbox {
		max-width: 450px;
		min-height: unset;
	}
	.login-wrapper .loginbox .login-right {
		float: none;
		padding: 1.875rem;
		width: 100%;
	}
	.invoice-container {
		padding: 20px;
	}
	.left-action {
		text-align: center;
		margin-bottom: 15px;
	}
	.right-action {
		text-align: center;
	}
	.top-action-left .float-left {
		float: none !important;
	}
	.top-action-left .btn-group {
		margin-bottom: 15px;
	}
	.top-action-right {
		text-align: center;
	}
	.top-action-right a.btn.btn-white {
		margin-bottom: 15px;
	}
	.mail-sent-time {
		float: left;
		margin-top: 10px;
		width: 100%;
	}
	.profile-btn {
		flex: 0 0 100%;
		margin-top: 20px;
	}
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, 
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 250px;
	}
	.app-dropdown {
		display: none;
	}
	.edit-link {
		font-size: 0.875rem;
		margin-top: 0;
	}
	.product_price {
		font-size: 1.5rem;
	}
	.login-wrapper .loginbox .login-right h1 {
		font-size: 22px;
	}
	.error-box h1 {
		font-size: 6em;
	}
	.error-box .btn {
		font-size: 15px;
		min-width: 150px;
		padding: 8px 20px;
	}
	.dash-count {
		font-size: 16px;
	}
}

@media only screen and (max-width: 575.98px) {
	.card {
		margin-bottom: 0.9375rem;
	}
	.page-wrapper > .content {
		padding: 0.9375rem 0.9375rem 0;
	}
	.chat-window {
		margin-bottom: 0.9375rem;
	}
	.card-body {
		padding: 1.25rem;
	}
	.card-header {
		padding: .75rem 1.25rem;
	}
	.card-footer {
		padding: .75rem 1.25rem;
	}
	.card-chart .card-body {
		padding: 5px;
	}
	.page-header {
		margin-bottom: 0.9375rem;
	}
	.account-wrapper {
		padding: 0.9375rem;
	}
	.pagination-lg .page-link {
		font-size: 1.2rem;
		padding: 0.5rem 0.625rem;
	}
	.profile-image {
		flex: 0 0 100%;
		margin-bottom: 20px;
		text-align: center;
	}
	.profile-user-info {
		text-align: center;
	}
	.profile-btn {
		text-align: center;
	}
	.invoice-details, .invoice-payment-details > li span {
		float: left;
		text-align: left;
	}
	.fc-toolbar .fc-right {
		display: inline-block;
		float: none;
		margin: 10px auto 0;
		width: 200px;
		clear: both;
	}
	.fc-toolbar .fc-left {
		float: none;
		margin: 0 auto;
		width: 200px;
	}
	.fc-toolbar .fc-center {
		display: inline-block;
		width: 100%;
		text-align: center;
	}
	.fc-toolbar .fc-center h2 {
		width: 100%;
	}
	.profile-tab-cont {
		padding-top: 1.25rem;
	}
	.chat-window .chat-cont-right .chat-header .media .media-body {
		display: none;
	}
}

@media only screen and (max-width: 479px) {
	.add-btn {
		font-size: 14px;
		padding: 6px 7px;
	}
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, 
	.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {
		max-width: 160px;
	}
	.page-header .breadcrumb {
		display: none;
	}
}
i.fa.fa-edit {
    font-size: 12px;
}
i.fa.fa-trash {
    font-size: 12px;
}
.table-rating i:not(:last-child) {
    margin-right: 3px;

}`, "",{"version":3,"sources":["webpack://./assets/PharmacyAdminStyle.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;yCAgCyC;;AAEzC;;wBAEwB;AAGxB;CACC,6BAA6B;CAC7B,kBAAkB;CAClB,gBAAgB;CAChB,4CAAmD,EAAE,cAAc;CACnE;;;;2DAIiE;AAClE;AACA;CACC,YAAY;AACb;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,+BAA+B;CAC/B,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;;CAEC;CACA,+BAA+B;CAC/B,aAAa;CACb;;AAED;;;CAGC,aAAa;CACb,qBAAqB;CACrB,cAAc;AACf;AACA;;;IAGI,yDAAyD;AAC7D;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,YAAY;AAChB;AACA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;AAChB;AACA;CACC,iCAAiC;AAClC;;AAEA;CACC,gCAAgC;AACjC;AACA;CACC,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;AAClC;AACA;;CAEC,aAAa;AACd;AACA;IACI,YAAY;IACZ,sCAAsC;AAC1C;AACA;;CAEC,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,sBAAsB;AACvB;AACA;CACC,YAAY;AACb;AACA;;;CAGC,oCAAoC;CACpC,gCAAgC;AACjC;AACA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf,qBAAqB;CACrB,cAAc;CACd,oBAAoB;CACpB,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;CACnB,cAAc;CACd,mCAAmC;CACnC,kCAAkC;CAClC,kCAAkC;CAClC,6BAA6B;AAC9B;AACA;CACC,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,yBAAyB;AAC1B;AACA;;;;;;CAMC,aAAa;CACb,iBAAiB;AAClB;AACA;;CAEC;AACD;AACA;CACC,oCAAoC;AACrC;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,sBAAsB;CACzB,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf,eAAe;AAChB;AACA;CACC,yBAAyB;CACzB,4CAA4C;AAC7C;AACA;CACC,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,4CAA4C;AAC7C;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC,0CAA0C;AAC3C;AACA;CACC,gDAAgD;AACjD;AACA;;CAEC,iCAAiC;AAClC;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;AACjB;AACA;;IAEI,oBAAoB;AACxB;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;;wBAEwB;;AAExB;CACC,wBAAwB;AACzB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,oBAAoB;AACrB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,wBAAwB;AACzB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,0BAA0B;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;;wBAEwB;;AAExB;IACI,iBAAiB;AACrB;AACA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;;CAEC,oCAAoC;AACrC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,oCAAoC;AACrC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,oCAAoC;AACrC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,oCAAoC;AACrC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,oCAAoC;AACrC;AACA;;;;IAII,oCAAoC;AACxC;AACA;CACC,sBAAsB;AACvB;AACA;;IAEI,oCAAoC;AACxC;AACA;;CAEC;AACD;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,+BAA+B;AACnC;AACA;CACC,yBAAyB;IACtB,yBAAyB;AAC7B;AACA;;;;;CAKC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;IACI,WAAW;IACX,yBAAyB;AAC7B;AACA;;;;;;;;;CASC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,yBAAyB;CACzB;AACD;AACA;;;;;CAKC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;AACZ;AACA;;;;;;;;;CASC,yBAAyB;CACzB;AACD;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,yBAAyB;CACzB;AACD;AACA;;;;;CAKC,yBAAyB;CACzB;AACD;AACA;;;;;;;;;CASC,yBAAyB;CACzB;AACD;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,yBAAyB;CACzB;AACD;AACA;;;;;CAKC,yBAAyB;CACzB;AACD;AACA;;;;;;;;;CASC,yBAAyB;CACzB;AACD;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;;;;CAKC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;;;;;;;;CASC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;;;IAGI,iBAAiB;AACrB;AACA;;;IAGI,iBAAiB;AACrB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,4BAA4B;CAC5B,mBAAmB;CACnB,sBAAsB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;CACC,SAAS;CACT,uCAAuC;CACvC,sBAAsB;AACvB;AACA;CACC,eAAe;AAChB;AACA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;AACA;CACC,eAAe;AAChB;AACA;CACC,gCAAgC;CAChC,oBAAoB;AACrB;AACA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,oBAAoB;AACrB;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,gBAAgB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,kDAAkD;CAClD,wBAAwB;AACzB;AACA;CACC,mDAAmD;CACnD,wBAAwB;AACzB;AACA;CACC,kDAAkD;CAClD,wBAAwB;AACzB;AACA;CACC,kDAAkD;CAClD,wBAAwB;AACzB;AACA;CACC,mDAAmD;CACnD,wBAAwB;AACzB;AACA;CACC,oDAAoD;CACpD,wBAAwB;AACzB;AACA;CACC,iDAAiD;CACjD,wBAAwB;AACzB;;AAEA;;wBAEwB;;AAExB;CACC,sBAAsB;CACtB,YAAY;AACb;AACA;CACC,YAAY;CACZ,UAAU;AACX;AACA;CACC,0CAA0C;CAC1C,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;CACT,SAAS;CACT,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,QAAQ;CACR,QAAQ;AACT;AACA;CACC,0CAA0C;CAC1C,uBAAuB;AACxB;AACA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,gCAAgC;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,sBAAsB;IACtB,yBAAyB;CAC5B,WAAW;AACZ;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;AACZ;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;;;CAGC,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,6BAA6B;AAC9B;AACA;;;CAGC,uBAAuB;AACxB;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,uBAAuB;AACxB;AACA;;;CAGC,sBAAsB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;;;CAGC,wBAAwB;CACxB,yBAAyB;CACzB,4BAA4B;CAC5B,6BAA6B;CAC7B,2BAA2B;CAC3B,gCAAgC;CAChC,8BAA8B;CAC9B,+BAA+B;CAC/B,mCAAmC;AACpC;AACA;CACC,yBAAyB;CACzB,SAAS;AACV;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,6BAA6B;AAC9B;AACA;;;CAGC,uBAAuB;AACxB;;AAEA;;wBAEwB;;AAExB;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,WAAW;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA,WAAW;;AAEX;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX;AACD;AACA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;;;CAGC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,cAAc;AACf;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,UAAU;AACX;;AAEA;;wBAEwB;;AAExB;CACC,gBAAgB;CAChB,gCAAgC;CAChC,OAAO;CACP,eAAe;CACf,QAAQ;CACR,MAAM;CACN,aAAa;CACb,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,gCAAgC;AACjC;AACA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,cAAc;CACd,6BAA6B;CAC7B,4BAA4B;CAC5B,WAAW;CACX,WAAW;CACX,qBAAqB;CACrB,oBAAoB;CACpB,iCAAiC;CACjC,6BAA6B;CAC7B,yBAAyB;CACzB,gCAAgC;CAChC,4BAA4B;CAC5B,wBAAwB;CACxB,yCAAyC;CACzC,iCAAiC;CACjC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,kCAAkC;CAClC,8BAA8B;CAC9B,0BAA0B;AAC3B;AACA;IACI,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;AACA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,YAAY;AACb;AACA;;CAEC,oCAAoC;AACrC;AACA;;CAEC,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT;AACD;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;CACC,WAAW;IACR,mBAAmB;AACvB;AACA;;CAEC,yBAAyB;CACzB,WAAW;AACZ;AACA;;CAEC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;AACA;;CAEC,WAAW;AACZ;AACA;CACC,aAAa;CACb,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;IACI,UAAU;IACV,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;;;;CAIC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;AACA;CACC,iBAAiB;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,OAAO;IACP,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA,WAAW;;AAEX;IACI,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;CACnB,kBAAkB;IACf,YAAY;AAChB;AACA;;IAEI,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;IACI,cAAc;IACd,OAAO;IACP,kBAAkB;AACtB;;AAEA;;wBAEwB;;AAExB;IACI,yBAAyB;GAC1B,4CAA4C;IAC3C,SAAS;IACT,OAAO;IACP,aAAa;IACb,eAAe;IACf,SAAS;IACT,mCAAmC;IACnC,YAAY;IACZ,aAAa;AACjB;AACA;CACC,iCAAiC;CACjC,8BAA8B;CAC9B,yBAAyB;AAC1B;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,mCAAmC;AACpC;AACA;IACI,aAAa;AACjB;AACA;CACC,eAAe;CACf,qBAAqB;CACrB,SAAS;CACT,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf,YAAY;CACZ,eAAe;AAChB;AACA;IACI,cAAc;AAClB;AACA;CACC,yBAAyB;IACtB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;CACC,cAAc;CACd,0BAA0B;AAC3B;AACA;CACC,aAAa;CACb,WAAW;AACZ;AACA;CACC,mCAAmC;CACnC,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;CACC,iBAAiB;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;CACC,2CAA2C;CAC3C,iCAAiC;CACjC,0BAA0B;CAC1B,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,0BAA0B;CAC1B,oBAAoB;CACpB,iBAAiB;CACjB,eAAe;CACf,mCAAmC;CACnC,kCAAkC;CAClC,kCAAkC;CAClC,8BAA8B;CAC9B,6BAA6B;CAC7B,0BAA0B;CAC1B,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,gBAAgB;AACjB;AACA;CACC,4BAA4B;CAC5B,gCAAgC;CAChC,2BAA2B;CAC3B,wBAAwB;AACzB;AACA;CACC,SAAS;AACV;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;CACtC,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,WAAW;CACX,mCAAmC;AACpC;AACA;CACC,0BAA0B;CAC1B,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;AACA;IACI,WAAW;AACf;AACA;;wBAEwB;;AAExB;CACC,cAAc;CACd,SAAS;CACT,UAAU;CACV,QAAQ;CACR,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,oBAAoB;CACpB,kBAAkB;AACnB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;CACC,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,+BAA+B;CAC/B,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,iDAAiD;AAClD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,UAAU;CACV,6CAA6C;AAC9C;AACA;CACC,iBAAiB;IACd,kBAAkB;CACrB,WAAW;IACR,wBAAwB;CAC3B,qBAAqB;CACrB,qBAAqB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;CACjB,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,cAAc;IACX,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,UAAU;AACd;AACA;CACC,yBAAyB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,cAAc;CACjB,YAAY;IACT,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;;AAEA;;wBAEwB;;AAExB;CACC,WAAW;CACX,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,uBAAuB;AACxB;AACA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;AACA;CACC,WAAW;AACZ;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;;wBAEwB;;AAExB;IACI,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;AACvB;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;CAC1C,aAAa;IACV,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,qDAAqD;IACrD,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,eAAe;AAChB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,cAAc;AACf;AACA;CACC,sBAAsB;CACtB,cAAc;CACd,SAAS;CACT,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,MAAM;CACN,WAAW;AACZ;;AAEA;;wBAEwB;;AAExB;IACI,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;wBAEwB;;AAExB;CACC,UAAU;AACX;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;AACA;CACC,aAAa;CACb,gCAAgC;AACjC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,6BAA6B;CAC7B,kBAAkB;AACnB;AACA;;IAEI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,yBAAyB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;AACZ;AACA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,cAAc;IACX,gBAAgB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,SAAS;AACV;AACA;CACC,aAAa;CACb,gCAAgC;AACjC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;IACI,SAAS;IACT,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;AACnB;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,SAAS;AACb;;AAEA;;wBAEwB;;AAExB;IACI,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;CACd,iBAAiB;IACd,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,eAAe;CACf;AACD;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;;wBAEwB;;AAExB;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,uBAAuB;AAC3B;AACA;;;CAGC,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;AACZ;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;AACf;AACA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,uBAAuB;CACvB,eAAe;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;CACzB,yBAAyB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;AACA;;CAEC,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,WAAW;AACZ;;AAEA;;wBAEwB;;AAExB;IACI,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;AACtB;AACA;CACC,qBAAqB;IAClB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,iCAAiC;CACjC,iBAAiB;CACjB,yBAAyB;AAC1B;AACA;CACC,iCAAiC;AAClC;AACA;CACC,gBAAgB;AACjB;AACA;;;;;CAKC,UAAU;AACX;AACA;CACC,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,yBAAyB;AAC1B;AACA;;;;;;;CAOC,qBAAqB;AACtB;AACA;;IAEI,gBAAgB;AACpB;AACA;CACC,mBAAmB;CACnB,YAAY;CACZ,cAAc;CACd,0BAA0B;CAC1B,2BAA2B;CAC3B,6BAA6B;CAC7B,wBAAwB;CACxB,4BAA4B;CAC5B,uBAAuB;AACxB;AACA;CACC,oBAAoB;CACpB,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;;;CAGC,oCAAoC;CACpC,sBAAsB;CACtB,4BAA4B;AAC7B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;CACtB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iCAAiC;AAClC;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iCAAiC;AAClC;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;wBAEwB;;AAExB;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;;CAEC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,WAAW;CACX,cAAc;CACd,aAAa;AACd;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;;;CAGC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;;;;;;IAMI,gCAAgC;IAChC,aAAa;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,SAAS;AACV;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,WAAW;AACf;AACA;CACC,iBAAiB;CACjB,yBAAyB;AAC1B;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,yBAAyB;AAC1B;AACA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;;wBAEwB;;AAExB;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,yBAAyB;CACzB,aAAa;AACd;AACA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;CACC,YAAY;CACZ,eAAe;AAChB;AACA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,oBAAoB;AACrB;AACA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,iBAAiB;AAClB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,eAAe;CACf,SAAS;AACV;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,UAAU;CACV,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,0BAA0B;CAC1B,6BAA6B;CAC7B,0BAA0B;CAC1B,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,kCAAkC;AACnC;AACA;CACC,uBAAuB;AACxB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;wBAEwB;;AAExB;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;AACA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,WAAW;CACd,iBAAiB;AAClB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;wBAEwB;;AAExB;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,+BAA+B;IAC/B,aAAa;IACb,OAAO;IACP,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;IACd,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,oBAAoB;AACxB;AACA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,UAAU;AACd;AACA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;AAChC;AACA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,UAAU;CACV,kBAAkB;CAClB,WAAW;CACX,sBAAsB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,aAAa;IACb,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,qBAAqB;CACrB,kBAAkB;AACnB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,sBAAsB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;AACA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;AACA;CACC,WAAW;CACX,YAAY;CACZ;AACD;AACA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,aAAa;CACb,yBAAyB;CACzB,cAAc;CACd,kBAAkB;CAClB;AACD;AACA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;AACA;CACC,kBAAkB;AACnB;AACA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,iCAAiC;IACjC,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;CACC,oCAAoC;CACpC,8BAA8B;CAC9B,iCAAiC;IAC9B,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,WAAW;CACX,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,kBAAkB;CAClB;AACD;AACA;IACI,WAAW;IACX,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;CACC,WAAW;AACZ;AACA;CACC;AACD;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,cAAc;CACd,aAAa;CACb,WAAW;CACX;AACD;AACA;CACC;AACD;AACA;IACI,2BAA2B;AAC/B;AACA;CACC;AACD;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,OAAO;CACP,QAAQ;CACR,gBAAgB;CAChB,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,SAAS;CACT,WAAW;CACX,iBAAiB;CACjB,eAAe;CACf,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,UAAU;CACV,mBAAmB;CACnB,WAAW;CACX,WAAW;CACX,iBAAiB;CACjB,oCAAoC;CACpC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,aAAa;CACb,YAAY;AACb;AACA;CACC,aAAa;CACb,YAAY;AACb;AACA;CACC,0CAA0C;CAC1C,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,2BAA2B;CAC3B,UAAU;CACV,mBAAmB;CACnB,UAAU;AACX;AACA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;AACA;CACC,cAAc;AACf;;AAEA;CACC;EACC;CACD;AACD;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;AACf;;AAEA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,8BAA8B;CAC9B,UAAU;CACV,oBAAoB;CACpB,yBAAyB;CACzB,4BAA4B;CAC5B,uBAAuB;CACvB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,cAAc;CACd,oBAAoB;CACpB,yBAAyB;CACzB,4BAA4B;CAC5B,uBAAuB;AACxB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,UAAU;AACX;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,MAAM;CACN,WAAW;CACX,kBAAkB;CAClB,OAAO;AACR;AACA;;CAEC,WAAW;CACX,SAAS;CACT,UAAU;CACV,cAAc;AACf;;AAEA;;wBAEwB;;AAExB;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,WAAW;CACX,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;CAC1B,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,SAAS;CACT,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,qBAAqB;AACzB;AACA;CACC,uBAAuB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;;AAEA;;wBAEwB;;AAExB;IACI,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,sBAAsB;CACzB,yBAAyB;IACtB,yBAAyB;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;AACA;CACC,qBAAqB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;AACA;CACC,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,cAAc;CACd,0BAA0B;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;AACA;IACI,WAAW;IACX,eAAe;IACf,UAAU;IACV,kBAAkB;CACrB,gBAAgB;IACb,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,QAAQ;IACR,oCAAoC;AACxC;AACA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,UAAU;IACV,kBAAkB;AACtB;;AAEA;;wBAEwB;;AAExB;CACC,YAAY;CACZ,eAAe;CACf,QAAQ;CACR,YAAY;CACZ,SAAS;CACT,gBAAgB;CAChB,UAAU;CACV,8BAA8B;CAC9B,aAAa;CACb,gBAAgB;CAChB,yBAAyB;AAC1B;AACA;CACC,QAAQ;CACR,yBAAyB;AAC1B;AACA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,MAAM;IACN,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,8BAA8B;IAC9B,6BAA6B;IAC7B,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;CACrB,eAAe;IACZ,cAAc;IACd,YAAY;IACZ,aAAa;CAChB,kBAAkB;IACf,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,+DAA+D;AAChE;AACA;CACC,yBAAyB;AAC1B;AACA;IACI,WAAW;CACd,gBAAgB;IACb,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;AACpC;;AAEA;;wBAEwB;;AAExB;CACC,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,cAAc;CACd,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;AACA;IACI,gCAAgC;IAChC,6BAA6B;CAChC,wBAAwB;CACxB,yDAAyD;CACzD,wDAAwD;CACxD,uDAAuD;CACvD,4DAA4D;CAC5D,oDAAoD;AACrD;AACA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;AACX;AACA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;AACA;CACC,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,iCAAiC;CACpC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,SAAS;CACT,gBAAgB;AACjB;AACA;;;CAGC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,YAAY;AACb;AACA;CACC,SAAS;CACT,UAAU;AACX;AACA;CACC,cAAc;CACd,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,kBAAkB;IACf,gCAAgC;IAChC,6BAA6B;CAChC,wBAAwB;CACxB,yDAAyD;CACzD,wDAAwD;CACxD,uDAAuD;CACvD,4DAA4D;CAC5D,oDAAoD;AACrD;AACA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,eAAe;CACf,SAAS;AACV;AACA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,cAAc;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,SAAS;CACT,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,WAAW;AACZ;AACA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;CACvB,eAAe;CACf,sBAAsB;CACtB,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;;wBAEwB;;AAExB;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,SAAS;CACT,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,OAAO;CACP,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,sBAAsB;CACtB,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,qBAAqB;CACrB,mBAAmB;AACpB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;AACA;CACC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;AACA;CACC,eAAe;IACZ,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;;wBAEwB;;AAExB;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;CACjC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;CACC;AACD;;AAEA;;wBAEwB;;AAExB;CACC;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,eAAe;CAChB;CACA;;;EAGC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;CAChB;CACA;EACC,YAAY;EACZ,gBAAgB;EAChB,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,cAAc;CACf;CACA;EACC,cAAc;EACd,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,YAAY;CACb;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;EACb,gCAAgC;EAChC,UAAU;CACX;CACA;EACC,eAAe;EACf,UAAU;CACX;CACA;EACC,eAAe;EACf,WAAW;CACZ;CACA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;;EAEC,gBAAgB;CACjB;AACD;AACA;CACC;;EAEC,gBAAgB;CACjB;CACA;EACC,aAAa;EACb,cAAc;CACf;CACA;EACC,aAAa;EACb,cAAc;CACf;AACD;AACA;CACC;EACC,kBAAkB;EAClB,WAAW;CACZ;CACA;EACC,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,eAAe;EACf,YAAY;EACZ,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,UAAU;CACX;CACA;EACC,aAAa;EACb,UAAU;CACX;CACA;EACC,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;CACd;CACA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;CAC1B;CACA;EACC,+BAA+B;CAChC;CACA;EACC,cAAc;EACd,eAAe;EACf,+DAA+D;EAC/D,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,8BAA8B;EAC9B,MAAM;CACP;CACA;EACC,sBAAsB;CACvB;CACA;EACC,cAAc;CACf;CACA;EACC,iBAAiB;CAClB;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,QAAQ;CACT;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,WAAW;EACX,kBAAkB;CACnB;CACA;EACC,UAAU;EACV,QAAQ;CACT;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,qBAAqB;CACtB;CACA;EACC,aAAa;CACd;CACA;EACC,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,WAAW;EACX,iBAAiB;EACjB,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,WAAW;EACX,gBAAgB;EAChB,WAAW;CACZ;CACA;EACC,cAAc;EACd,gBAAgB;CACjB;CACA;;EAEC,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;EACnB,aAAa;CACd;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,wBAAwB;CACzB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,YAAY;CACb;CACA;EACC,wBAAwB;CACzB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,wBAAwB;CACzB;CACA;EACC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,WAAW;EACX,gBAAgB;CACjB;CACA;EACC,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,WAAW;CACZ;CACA;EACC,WAAW;EACX,cAAc;EACd,YAAY;CACb;CACA;EACC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;CACnB;CACA;EACC,WAAW;CACZ;CACA;EACC,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;CACA;;EAEC,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;AACD;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;;AAErB","sourcesContent":["/*\nAuthor       : Dreamguys\nTemplate Name: Doccure - Bootstrap Admin Template\nVersion      : 1.3\n*/\n\n/*============================\n [Table of CSS]\n\n1. General\n2. Table\n3. Helper Class\n4. Bootstrap Classes\n5. Select2\n6. Nav Tabs\n7. Components\n8. Header\n9. Sidebar\n10. Content\n11. Login\n12. Lock Screen\n13. Notifications\n14. Dashboard\n15. Invoice\n16. Calendar\n17. Inbox\n18. Mail View\n19. Error\n20. Chat\n21. Product\n22. Product Details\n23. Profile\n24. Template Options\n25. Blog\n26. Blog Details\n27. Blog Grid\n28. Responsive\n\n========================================*/\n\n/*-----------------\n\t1. General\n-----------------------*/\n\n@import url('https://fonts.googleapis.com/css?family=Mada:400,500,600,700&display=swap');\n@font-face {\n\tfont-family: 'Material Icons';\n\tfont-style: normal;\n\tfont-weight: 400;\n\tsrc: url(../assets/fonts/MaterialIcons-Regular.eot); /* For IE6-8 */\n\tsrc: local('Material Icons'),\n\tlocal('MaterialIcons-Regular'),\n\turl(../assets/fonts/MaterialIcons-Regular.woff2) format('woff2'),\n\turl(../assets/fonts/MaterialIcons-Regular.woff) format('woff'),\n\turl(../assets/fonts/MaterialIcons-Regular.ttf) format('truetype');\n}\nhtml {\n\theight: 100%;\n}\nbody {\n\tbackground-color: #f8f9fa;\n\tcolor: #333;\n\tfont-family: 'Mada', sans-serif;\n\tfont-size: 1rem;\n\theight: 100%;\n\tline-height: 1.5;\n\toverflow-x: hidden;\n}\n\n h1, h2,  h3,  h4,  h5, h6 {\n\tfont-family: 'Mada', sans-serif;\n\tmargin-top: 0;\n\t}\n\na:hover,\na:active,\na:focus {\n\toutline: none;\n\ttext-decoration: none;\n\tcolor: #00d0f1;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n    -webkit-box-shadow: 0 0 0px 1000px white inset !important;\n}\n.form-control {\n    border: 1px solid #ddd;\n    box-shadow: none;\n    color: #333;\n    font-size: 15px;\n    height: 40px;\n}\n.form-control:focus {\n\tborder-color: #00d0f1;\n\tbox-shadow: none;\n\toutline: 0 none;\n}\n.form-control.form-control-sm {\n\theight: calc(1.5em + .5rem + 2px);\n}\n\n.form-control.form-control-lg {\n\theight: calc(1.5em + 1rem + 2px);\n}\na {\n\tcolor: #0dd9f9;\n}\ninput,\nbutton,\na {\n\ttransition: all 0.4s ease;\n\t-moz-transition: all 0.4s ease;\n\t-o-transition: all 0.4s ease;\n\t-ms-transition: all 0.4s ease;\n\t-webkit-transition: all 0.4s ease;\n}\ninput, input:focus,\nbutton, button:focus {\n\toutline: none;\n}\ninput[type=\"file\"] {\n    height: auto;\n    min-height: calc(1.5em + .75rem + 2px);\n}\ninput[type=text],\ninput[type=password] {\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n\tappearance: none;\n}\ntextarea.form-control {\n\tresize: vertical;\n}\n.navbar-nav > li {\n\tfloat: left;\n}\n.form-group {\n\tmargin-bottom: 1.25rem;\n}\n.input-group .form-control {\n\theight: 40px;\n}\n.nav .open > a,\n.nav .open > a:focus,\n.nav .open > a:hover {\n\tbackground-color: rgba(0, 0, 0, 0.1);\n\tborder-color: rgba(0, 0, 0, 0.1);\n}\n.material-icons {\n\tfont-family: 'Material Icons';\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-size: 24px;\n\tdisplay: inline-block;\n\tline-height: 1;\n\ttext-transform: none;\n\tletter-spacing: normal;\n\tword-wrap: normal;\n\twhite-space: nowrap;\n\tdirection: ltr;\n\t-webkit-font-smoothing: antialiased;\n\ttext-rendering: optimizeLegibility;\n\t-moz-osx-font-smoothing: grayscale;\n\tfont-feature-settings: 'liga';\n}\n.font-weight-600 {\n\tfont-weight: 600;\n}\n\n/*-----------------\n\t2. Table\n-----------------------*/\n\n.table {\n\tcolor: #333;\n\tmax-width: 100%;\n\tmargin-bottom: 0;\n\twidth: 100%;\n}\n.table-striped > tbody > tr:nth-of-type(2n+1) {\n\tbackground-color: #f8f9fa;\n}\n.table.no-border > tbody > tr > td,\n.table > tbody > tr > th,\n.table.no-border > tfoot > tr > td,\n.table.no-border > tfoot > tr > th,\n.table.no-border > thead > tr > td,\n.table.no-border > thead > tr > th {\n\tborder-top: 0;\n\tpadding: 10px 8px;\n}\n.table-nowrap td,\n.table-nowrap th {\n\twhite-space: nowrap\n}\n.table.dataTable {\n\tborder-collapse: collapse !important;\n}\ntable.table td h2 {\n\tdisplay: inline-block;\n\tfont-size: inherit;\n\tfont-weight: 400;\n\tmargin: 0;\n\tpadding: 0;\n\tvertical-align: middle;\n}\ntable.table td h2.table-avatar {\n    align-items: center;\n    display: inline-flex;\n    font-size: inherit;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n    vertical-align: middle;\n\twhite-space: nowrap;\n}\ntable.table td h2 a {\n\tcolor: #333;\n}\ntable.table td h2 a:hover {\n\tcolor: #00d0f1;\n}\ntable.table td h2 span {\n\tcolor: #888;\n\tdisplay: block;\n\tfont-size: 12px;\n\tmargin-top: 3px;\n}\n.table thead {\n\tbackground-color: #f8f9fa;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.03);\n}\n.table thead tr th {\n\tfont-weight: 600;\n\tborder: 0;\n}\n.table tbody tr {\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.table tbody tr:last-child {\n\tborder-color: transparent;\n}\n.table.table-center td,\n.table.table-center th {\n\tvertical-align: middle;\n}\n.table-hover tbody tr:hover {\n\tbackground-color: #f7f7f7;\n}\n.table-hover tbody tr:hover td {\n\tcolor: #474648;\n}\n.table-striped thead tr {\n\tborder-color: transparent;\n}\n.table-striped tbody tr {\n\tborder-color: transparent;\n}\n.table-striped tbody tr:nth-of-type(even) {\n\tbackground-color: rgba(255, 255, 255, 0.3);\n}\n.table-striped tbody tr:nth-of-type(odd) {\n\tbackground-color: rgba(235, 235, 235, 0.4);\n}\n.table-bordered {\n\tborder: 1px solid rgba(0, 0, 0, 0.05) !important;\n}\n.table-bordered th,\n.table-bordered td {\n\tborder-color: rgba(0, 0, 0, 0.05);\n}\n.card-table .card-body {\n    padding: 0;\n}\n.card-table .card-body .table > thead > tr > th {\n    border-top: 0;\n}\n.card-table .card-body .table tr td:first-child,\n.card-table .card-body .table tr th:first-child {\n    padding-left: 1.5rem;\n}\n.card-table .card-body .table tr td:last-child,\n.card-table .card-body .table tr th:last-child {\n    padding-right: 1.5rem;\n}\n.card-table .table td, .card-table .table th {\n    border-top: 1px solid #e2e5e8;\n    padding: 1rem 0.75rem;\n    white-space: nowrap;\n}\n#delete_modal .modal-content {\n\ttext-align: center;\n}\n/*-----------------\n\t3. Helper Class\n-----------------------*/\n\n.p-20 {\n\tpadding: 20px !important;\n}\n.p-t-0 {\n\tpadding-top: 0 !important;\n}\n.m-0 {\n\tmargin: 0 !important;\n}\n.m-r-5 {\n\tmargin-right: 5px !important;\n}\n.m-r-10 {\n\tmargin-right: 10px !important;\n}\n.m-l-5 {\n\tmargin-left: 5px !important;\n}\n.m-l-15 {\n\tmargin-left: 15px !important;\n}\n.m-t-5 {\n\tmargin-top: 5px !important;\n}\n.m-t-0 {\n\tmargin-top: 0 !important;\n}\n.m-t-10 {\n\tmargin-top: 10px !important;\n}\n.m-t-15 {\n\tmargin-top: 15px !important;\n}\n.m-t-20 {\n\tmargin-top: 20px !important;\n}\n.m-t-30 {\n\tmargin-top: 30px !important;\n}\n.m-t-50 {\n\tmargin-top: 50px !important;\n}\n.m-b-5 {\n\tmargin-bottom: 5px !important;\n}\n.m-b-10 {\n\tmargin-bottom: 10px !important;\n}\n.m-b-15 {\n\tmargin-bottom: 15px !important;\n}\n.m-b-20 {\n\tmargin-bottom: 20px !important;\n}\n.m-b-30 {\n\tmargin-bottom: 30px !important;\n}\n.block {\n\tdisplay: block !important;\n}\n.cal-icon {\n\tposition: relative;\n\twidth: 100%;\n}\n.cal-icon:after {\n\tcolor: #979797;\n\tcontent: \"\\f073\";\n\tdisplay: block;\n\tfont-family: \"FontAwesome\";\n    font-size: 15px;\n    margin: auto;\n    position: absolute;\n    right: 15px;\n    top: 10px;\n}\n\n/*-----------------\n\t4. Bootstrap Classes\n-----------------------*/\n\n.btn.focus, .btn:focus {\n    box-shadow: unset;\n}\n.btn-white {\n\tbackground-color: #fff;\n\tborder: 1px solid #ccc;\n\tcolor: #333;\n}\n.btn.btn-rounded {\n\tborder-radius: 50px;\n}\n.bg-primary,\n.badge-primary {\n\tbackground-color: #00d0f1 !important;\n}\na.bg-primary:focus, \na.bg-primary:hover, \nbutton.bg-primary:focus, \nbutton.bg-primary:hover {\n    background-color: #19c1dc !important;\n}\n.bg-success,\n.badge-success {\n\tbackground-color: #7bb13c !important;\n}\na.bg-success:focus, \na.bg-success:hover, \nbutton.bg-success:focus, \nbutton.bg-success:hover {\n    background-color: #699834 !important;\n}\n.bg-info,\n.badge-info {\n\tbackground-color: #009efb !important;\n}\na.bg-info:focus, \na.bg-info:hover, \nbutton.bg-info:focus, \nbutton.bg-info:hover {\n    background-color: #028ee1 !important;\n}\n.bg-warning,\n.badge-warning {\n\tbackground-color: #ffbc34 !important;\n}\na.bg-warning:focus, \na.bg-warning:hover, \nbutton.bg-warning:focus, \nbutton.bg-warning:hover {\n    background-color: #e9ab2e !important;\n}\n.bg-danger,\n.badge-danger {\n\tbackground-color: #e84646 !important;\n}\na.bg-danger:focus, \na.bg-danger:hover, \nbutton.bg-danger:focus, \nbutton.bg-danger:hover {\n    background-color: #e63333 !important;\n}\n.bg-white {\n\tbackground-color: #fff;\n}\n.bg-purple,\n.badge-purple {\n    background-color: #9368e9 !important;\n}\n.text-primary,\n.dropdown-menu > li > a.text-primary {\n\tcolor: #00d0f1 !important\n}\n.text-success,\n.dropdown-menu > li > a.text-success {\n\tcolor: #699834 !important;\n}\n.text-danger,\n.dropdown-menu > li > a.text-danger {\n\tcolor: #e84646 !important;\n}\n.text-info,\n.dropdown-menu > li > a.text-info {\n\tcolor: #009efb !important;\n}\n.text-warning,\n.dropdown-menu > li > a.text-warning {\n\tcolor: #ffbc34 !important;\n}\n.text-purple,\n.dropdown-menu > li > a.text-purple {\n\tcolor: #7460ee !important;\n}\n.text-muted {\n    color: #757575 !important;\n}\n.text-secondary {\n    color: #b8bdc1!important;\n}\n.border-primary {\n    border-color: #00d0f1!important;\n}\n.btn-primary {\n\tbackground-color: #00d0f1;\n    border: 1px solid #00d0f1;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary.active,\n.btn-primary:active,\n.open > .dropdown-toggle.btn-primary {\n\tbackground-color: #19c1dc;\n\tborder: 1px solid #19c1dc;\n}\n.nav-pills .nav-link.active, .nav-pills .show>.nav-link {\n    color: #fff;\n    background-color: #00d0f1;\n}\n.btn-primary.active.focus,\n.btn-primary.active:focus,\n.btn-primary.active:hover,\n.btn-primary.focus:active,\n.btn-primary:active:focus,\n.btn-primary:active:hover,\n.open > .dropdown-toggle.btn-primary.focus,\n.open > .dropdown-toggle.btn-primary:focus,\n.open > .dropdown-toggle.btn-primary:hover {\n\tbackground-color: #19c1dc;\n\tborder: 1px solid #19c1dc;\n}\n.btn-primary.active:not(:disabled):not(.disabled),\n.btn-primary:active:not(:disabled):not(.disabled),\n.show > .btn-primary.dropdown-toggle {\n\tbackground-color: #19c1dc;\n\tborder-color: #19c1dc;\n\tcolor: #fff;\n}\n.btn-primary.active:focus:not(:disabled):not(.disabled), \n.btn-primary:active:focus:not(:disabled):not(.disabled), \n.show > .btn-primary.dropdown-toggle:focus {\n\tbox-shadow: unset;\n}\n.btn-primary.disabled, .btn-primary:disabled {\n    background-color: #00d0f1;\n    border-color: #00d0f1;\n    color: #fff;\n}\n.btn-secondary.active:focus:not(:disabled):not(.disabled), \n.btn-secondary:active:focus:not(:disabled):not(.disabled), \n.show > .btn-secondary.dropdown-toggle:focus {\n\tbox-shadow: unset;\n}\n.btn-success {\n\tbackground-color: #7bb13c;\n\tborder: 1px solid #7bb13c\n}\n.btn-success:hover,\n.btn-success:focus,\n.btn-success.active,\n.btn-success:active,\n.open > .dropdown-toggle.btn-success {\n\tbackground-color: #699834;\n\tborder: 1px solid #699834;\n\tcolor: #fff;\n}\n.btn-success.active.focus,\n.btn-success.active:focus,\n.btn-success.active:hover,\n.btn-success.focus:active,\n.btn-success:active:focus,\n.btn-success:active:hover,\n.open > .dropdown-toggle.btn-success.focus,\n.open > .dropdown-toggle.btn-success:focus,\n.open > .dropdown-toggle.btn-success:hover {\n\tbackground-color: #699834;\n\tborder: 1px solid #699834\n}\n.btn-success.active:not(:disabled):not(.disabled),\n.btn-success:active:not(:disabled):not(.disabled),\n.show > .btn-success.dropdown-toggle {\n\tbackground-color: #699834;\n\tborder-color: #699834;\n\tcolor: #fff;\n}\n.btn-success.active:focus:not(:disabled):not(.disabled), \n.btn-success:active:focus:not(:disabled):not(.disabled), \n.show > .btn-success.dropdown-toggle:focus {\n\tbox-shadow: unset;\n}\n.btn-success.disabled, .btn-success:disabled {\n    background-color: #7bb13c;\n    border-color: #7bb13c;\n    color: #fff;\n}\n.btn-info {\n\tbackground-color: #009efb;\n\tborder: 1px solid #009efb\n}\n.btn-info:hover,\n.btn-info:focus,\n.btn-info.active,\n.btn-info:active,\n.open > .dropdown-toggle.btn-info {\n\tbackground-color: #028ee1;\n\tborder: 1px solid #028ee1\n}\n.btn-info.active.focus,\n.btn-info.active:focus,\n.btn-info.active:hover,\n.btn-info.focus:active,\n.btn-info:active:focus,\n.btn-info:active:hover,\n.open > .dropdown-toggle.btn-info.focus,\n.open > .dropdown-toggle.btn-info:focus,\n.open > .dropdown-toggle.btn-info:hover {\n\tbackground-color: #028ee1;\n\tborder: 1px solid #028ee1\n}\n.btn-info.active:not(:disabled):not(.disabled),\n.btn-info:active:not(:disabled):not(.disabled),\n.show > .btn-info.dropdown-toggle {\n\tbackground-color: #028ee1;\n\tborder-color: #028ee1;\n\tcolor: #fff;\n}\n.btn-info.active:focus:not(:disabled):not(.disabled), \n.btn-info:active:focus:not(:disabled):not(.disabled), \n.show > .btn-info.dropdown-toggle:focus {\n\tbox-shadow: unset;\n}\n.btn-info.disabled, .btn-info:disabled {\n    background-color: #009efb;\n    border-color: #009efb;\n    color: #fff;\n}\n.btn-warning {\n\tbackground-color: #ffbc34;\n\tborder: 1px solid #ffbc34\n}\n.btn-warning:hover,\n.btn-warning:focus,\n.btn-warning.active,\n.btn-warning:active,\n.open > .dropdown-toggle.btn-warning {\n\tbackground-color: #e9ab2e;\n\tborder: 1px solid #e9ab2e\n}\n.btn-warning.active.focus,\n.btn-warning.active:focus,\n.btn-warning.active:hover,\n.btn-warning.focus:active,\n.btn-warning:active:focus,\n.btn-warning:active:hover,\n.open > .dropdown-toggle.btn-warning.focus,\n.open > .dropdown-toggle.btn-warning:focus,\n.open > .dropdown-toggle.btn-warning:hover {\n\tbackground-color: #e9ab2e;\n\tborder: 1px solid #e9ab2e\n}\n.btn-warning.active:not(:disabled):not(.disabled),\n.btn-warning:active:not(:disabled):not(.disabled),\n.show > .btn-danger.dropdown-toggle {\n\tbackground-color: #e9ab2e;\n\tborder-color: #e9ab2e;\n\tcolor: #fff;\n}\n.btn-warning.active:focus:not(:disabled):not(.disabled), \n.btn-warning:active:focus:not(:disabled):not(.disabled), \n.show > .btn-warning.dropdown-toggle:focus {\n\tbox-shadow: unset;\n}\n.btn-warning.disabled, .btn-warning:disabled {\n    background-color: #ffbc34;\n    border-color: #ffbc34;\n    color: #fff;\n}\n.btn-danger {\n\tbackground-color: #e84646;\n\tborder: 1px solid #e84646;\n}\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger.active,\n.btn-danger:active,\n.open > .dropdown-toggle.btn-danger {\n\tbackground-color: #e63333;\n\tborder: 1px solid #e63333;\n}\n.btn-danger.active.focus,\n.btn-danger.active:focus,\n.btn-danger.active:hover,\n.btn-danger.focus:active,\n.btn-danger:active:focus,\n.btn-danger:active:hover,\n.open > .dropdown-toggle.btn-danger.focus,\n.open > .dropdown-toggle.btn-danger:focus,\n.open > .dropdown-toggle.btn-danger:hover {\n\tbackground-color: #e63333;\n\tborder: 1px solid #e63333;\n}\n.btn-danger.active:not(:disabled):not(.disabled),\n.btn-danger:active:not(:disabled):not(.disabled),\n.show > .btn-danger.dropdown-toggle {\n\tbackground-color: #e63333;\n\tborder-color: #e63333;\n\tcolor: #fff;\n}\n.btn-danger.active:focus:not(:disabled):not(.disabled), \n.btn-danger:active:focus:not(:disabled):not(.disabled), \n.show > .btn-danger.dropdown-toggle:focus {\n\tbox-shadow: unset;\n}\n.btn-danger.disabled, .btn-danger:disabled {\n    background-color: #f62d51;\n    border-color: #f62d51;\n    color: #fff;\n}\n.btn-light.active:focus:not(:disabled):not(.disabled), \n.btn-light:active:focus:not(:disabled):not(.disabled), \n.show > .btn-light.dropdown-toggle:focus {\n    box-shadow: unset;\n}\n.btn-dark.active:focus:not(:disabled):not(.disabled), \n.btn-dark:active:focus:not(:disabled):not(.disabled), \n.show > .btn-dark.dropdown-toggle:focus {\n    box-shadow: unset;\n}\n.btn-outline-primary {\n\tcolor: #00d0f1;\n\tborder-color: #00d0f1;\n}\n.btn-outline-primary:hover {\n\tbackground-color: #00d0f1;\n\tborder-color: #00d0f1;\n}\n.btn-outline-primary:focus, \n.btn-outline-primary.focus {\n\tbox-shadow: none;\n}\n.btn-outline-primary.disabled, \n.btn-outline-primary:disabled {\n\tcolor: #00d0f1;\n\tbackground-color: transparent;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active, \n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-primary.dropdown-toggle {\n\tbackground-color: #00d0f1;\n\tborder-color: #00d0f1;\n}\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, \n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-primary.dropdown-toggle:focus {\n\tbox-shadow: none;\n}\n.btn-outline-success {\n\tcolor: #7bb13c;\n\tborder-color: #7bb13c;\n}\n.btn-outline-success:hover {\n\tbackground-color: #7bb13c;\n\tborder-color: #7bb13c;\n}\n.btn-outline-success:focus, .btn-outline-success.focus {\n\tbox-shadow: none;\n}\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n\tcolor: #7bb13c;\n\tbackground-color: transparent;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active, \n.btn-outline-success:not(:disabled):not(.disabled).active,\n.show > .btn-outline-success.dropdown-toggle {\n\tbackground-color: #7bb13c;\n\tborder-color: #7bb13c;\n}\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, \n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-success.dropdown-toggle:focus {\n\tbox-shadow: none;\n}\n.btn-outline-info {\n\tcolor: #009efb;\n\tborder-color: #009efb;\n}\n.btn-outline-info:hover {\n\tcolor: #fff;\n\tbackground-color: #009efb;\n\tborder-color: #009efb;\n}\n.btn-outline-info:focus, .btn-outline-info.focus {\n\tbox-shadow: none;\n}\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n\tbackground-color: transparent;\n\tcolor: #009efb;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active, \n.btn-outline-info:not(:disabled):not(.disabled).active,\n.show > .btn-outline-info.dropdown-toggle {\n\tbackground-color: #009efb;\n\tborder-color: #009efb;\n}\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, \n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-info.dropdown-toggle:focus {\n\tbox-shadow: none;\n}\n.btn-outline-warning {\n\tcolor: #ffbc34;\n\tborder-color: #ffbc34;\n}\n.btn-outline-warning:hover {\n\tcolor: #212529;\n\tbackground-color: #ffbc34;\n\tborder-color: #ffbc34;\n}\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n\tbox-shadow: none;\n}\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n\tbackground-color: transparent;\n\tcolor: #ffbc34;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active, \n.btn-outline-warning:not(:disabled):not(.disabled).active,\n.show > .btn-outline-warning.dropdown-toggle {\n\tcolor: #212529;\n\tbackground-color: #ffbc34;\n\tborder-color: #ffbc34;\n}\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, \n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-warning.dropdown-toggle:focus {\n\tbox-shadow: none;\n}\n.btn-outline-danger {\n\tcolor: #e84646;\n\tborder-color: #e84646;\n}\n.btn-outline-danger:hover {\n\tcolor: #fff;\n\tbackground-color: #e84646;\n\tborder-color: #e84646;\n}\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n\tbox-shadow: none;\n}\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n\tbackground-color: transparent;\n\tcolor: #e84646;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active, \n.btn-outline-danger:not(:disabled):not(.disabled).active,\n.show > .btn-outline-danger.dropdown-toggle {\n\tbackground-color: #e84646;\n\tborder-color: #e84646;\n}\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, \n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-danger.dropdown-toggle:focus {\n\tbox-shadow: none;\n}\n.btn-outline-light {\n    color: #ababab;\n    border-color: #e6e6e6;\n}\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n    color: #ababab;\n}\n.pagination > .active > a, \n.pagination > .active > a:focus,\n.pagination > .active > a:hover,\n.pagination > .active > span,\n.pagination > .active > span:focus,\n.pagination > .active > span:hover {\n\tbackground-color: #00d0f1;\n\tborder-color: #00d0f1;\n}\n.pagination > li > a, \n.pagination > li > span {\n\tcolor: #00d0f1;\n}\n.page-link:hover {\n\tcolor: #00d0f1;\n}\n.page-link:focus {\n\tbox-shadow: unset;\n}\n.page-item.active .page-link {\n\tbackground-color: #00d0f1;\n\tborder-color: #00d0f1;\n}\n.dropdown-menu {\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\tborder-radius: 3px;\n\ttransform-origin: left top 0;\n\tbox-shadow: inherit;\n\tbackground-color: #fff;\n}\n.dropdown-item.active, .dropdown-item:active {\n    background-color: #00d0f1;\n}\n.navbar-nav .open .dropdown-menu {\n\tborder: 0;\n\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n\tbackground-color: #fff;\n}\n.dropdown-menu {\n\tfont-size: 14px;\n}\n.card {\n    border: 1px solid #f0f0f0;\n    margin-bottom: 1.875rem;\n}\n.card-body {\n\tpadding: 1.5rem;\n}\n.card-header {\n\tborder-bottom: 1px solid #e6e6e6;\n\tpadding: 1rem 1.5rem;\n}\n.card-footer {\n\tbackground-color: #fff;\n\tborder-top: 1px solid #e6e6e6;\n\tpadding: 1rem 1.5rem;\n}\n.card .card-header {\n    background-color: #fff;\n    border-bottom: 1px solid #eaeaea;\n}\n.card .card-header .card-title {\n    margin-bottom: 0;\n}\n.modal-footer.text-left {\n\ttext-align: left;\n}\n.modal-footer.text-center {\n\ttext-align: center;\n}\n.btn-light {\n\tborder-color: #e6e6e6;\n\tcolor: #a6a6a6;\n}\n.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td.active:hover {\n\tbackground-color: #00d0f1;\n\ttext-shadow: unset;\n}\n.bootstrap-datetimepicker-widget table td.today:before{\n\tborder-bottom-color:#00d0f1;\n}\n.bg-info-light{\n\tbackground-color:rgba(2, 182, 179,0.12) !important;\n\tcolor:#1db9aa !important;\n}\n.bg-primary-light{\n\tbackground-color:rgba(17, 148, 247,0.12) !important;\n\tcolor:#2196f3 !important;\n}\n.bg-danger-light{\n\tbackground-color:rgba(242, 17, 54,0.12) !important;\n\tcolor:#e63c3c !important;\n}\n.bg-warning-light{\n\tbackground-color:rgba(255, 152, 0,0.12) !important;\n\tcolor:#f39c12 !important;\n}\n.bg-success-light{\n\tbackground-color:rgba(15, 183, 107,0.12) !important;\n\tcolor:#26af48 !important;\n}\n.bg-purple-light{\n\tbackground-color:rgba(197, 128, 255,0.12) !important;\n\tcolor:#c580ff !important;\n}\n.bg-default-light{\n\tbackground-color:rgba(40, 52, 71,0.12) !important;\n\tcolor:#283447 !important;\n}\n\n/*-----------------\n\t5. Select2\n-----------------------*/\n\n.select2-container .select2-selection--single {\n\tborder: 1px solid #ddd;\n\theight: 40px;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n\theight: 38px;\n\tright: 7px;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n\tborder-color: #ddd transparent transparent;\n\tborder-style: solid;\n\tborder-width: 6px 6px 0;\n\theight: 0;\n\tleft: 50%;\n\tmargin-left: -10px;\n\tmargin-top: -2px;\n\tposition: absolute;\n\ttop: 50%;\n\twidth: 0;\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n\tborder-color: transparent transparent #ddd;\n\tborder-width: 0 6px 6px;\n}\n.select2-container .select2-selection--single .select2-selection__rendered {\n\tpadding-right: 30px;\n\tpadding-left: 15px;\n}\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n\tcolor: #333;\n\tfont-size: 15px;\n\tfont-weight: normal;\n\tline-height: 38px;\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n\tbackground-color: #00d0f1;\n}\n.select2-container--default .select2-selection--multiple {\n\tborder: 1px solid #ddd;\n\tmin-height: 40px;\n}\n\n/*-----------------\n\t6. Nav Tabs\n-----------------------*/\n\n.nav-tabs {\n\tborder-bottom: 1px solid #e6e6e6;\n}\n.card-header-tabs {\n    border-bottom: 0;\n}\n.nav-tabs > li > a {\n\tmargin-right: 0;\n\tcolor: #888;\n\tborder-radius: 0;\n}\n.nav-tabs > li > a:hover,\n.nav-tabs > li > a:focus {\n\tborder-color: transparent;\n\tcolor: #333;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n\tcolor: #333;\n}\n.nav-tabs.nav-tabs-solid > .active > a,\n.nav-tabs.nav-tabs-solid > .active > a:hover,\n.nav-tabs.nav-tabs-solid > .active > a:focus {\n\tbackground-color: #00d0f1;\n\tborder-color: #00d0f1;\n\tcolor: #fff;\n}\n.tab-content {\n\tpadding-top: 20px;\n}\n.nav-tabs .nav-link {\n\tborder-radius: 0;\n}\n.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {\n    background-color: #eee;\n    border-color: transparent;\n\tcolor: #333;\n}\n.nav-tabs.nav-justified > li > a {\n\tborder-radius: 0;\n\tmargin-bottom: 0;\n}\n.nav-tabs.nav-justified > li > a:hover,\n.nav-tabs.nav-justified > li > a:focus {\n\tborder-bottom-color: #ddd;\n}\n.nav-tabs.nav-justified.nav-tabs-solid > li > a {\n\tborder-color: transparent;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n\tcolor: #333;\n}\n.nav-tabs.nav-tabs-solid > li > a.active,\n.nav-tabs.nav-tabs-solid > li > a.active:hover,\n.nav-tabs.nav-tabs-solid > li > a.active:focus {\n\tbackground-color: #00d0f1;\n\tborder-color: #00d0f1;\n\tcolor: #fff;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded {\n\tborder-radius: 50px;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {\n\tborder-radius: 50px;\n}\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\n\tborder-radius: 50px;\n}\n.nav-tabs-justified > li > a {\n\tborder-radius: 0;\n\tmargin-bottom: 0;\n}\n.nav-tabs-justified > li > a:hover,\n.nav-tabs-justified > li > a:focus {\n\tborder-bottom-color: #ddd;\n}\n.nav-tabs-justified.nav-tabs-solid > li > a {\n\tborder-color: transparent;\n}\n.nav-tabs.nav-justified.nav-tabs-top {\n\tborder-bottom: 1px solid #ddd;\n}\n.nav-tabs.nav-justified.nav-tabs-top > li > a,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {\n\tborder-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-top > li {\n\tmargin-bottom: 0;\n}\n.nav-tabs.nav-tabs-top > li > a,\n.nav-tabs.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-tabs-top > li > a:focus {\n\tborder-width: 2px 0 0 0;\n}\n.nav-tabs.nav-tabs-top > li.open > a,\n.nav-tabs.nav-tabs-top > li > a:hover,\n.nav-tabs.nav-tabs-top > li > a:focus {\n\tborder-top-color: #ddd;\n}\n.nav-tabs.nav-tabs-top > li+li > a {\n\tmargin-left: 1px;\n}\n.nav-tabs.nav-tabs-top > li > a.active,\n.nav-tabs.nav-tabs-top > li > a.active:hover,\n.nav-tabs.nav-tabs-top > li > a.active:focus {\n\tborder-top-color: #00d0f1;\n}\n.nav-tabs.nav-tabs-bottom > li {\n\tmargin-bottom: -1px;\n}\n.nav-tabs.nav-tabs-bottom > li > a.active, \n.nav-tabs.nav-tabs-bottom > li > a.active:hover, \n.nav-tabs.nav-tabs-bottom > li > a.active:focus {\n\tborder-bottom-width: 2px;\n\tborder-color: transparent;\n\tborder-bottom-color: #00d0f1;\n\tbackground-color: transparent;\n\ttransition: none 0s ease 0s; \n\t-moz-transition: none 0s ease 0s; \n\t-o-transition: none 0s ease 0s; \n\t-ms-transition: none 0s ease 0s; \n\t-webkit-transition: none 0s ease 0s;\n}\n.nav-tabs.nav-tabs-solid {\n\tbackground-color: #fafafa;\n\tborder: 0;\n}\n.nav-tabs.nav-tabs-solid > li {\n\tmargin-bottom: 0;\n}\n.nav-tabs.nav-tabs-solid > li > a {\n\tborder-color: transparent;\n}\n.nav-tabs.nav-tabs-solid > li > a:hover,\n.nav-tabs.nav-tabs-solid > li > a:focus {\n\tbackground-color: #f5f5f5;\n}\n.nav-tabs.nav-tabs-solid > .open:not(.active) > a {\n\tbackground-color: #f5f5f5;\n\tborder-color: transparent;\n}\n.nav-tabs-justified.nav-tabs-top {\n\tborder-bottom: 1px solid #ddd;\n}\n.nav-tabs-justified.nav-tabs-top > li > a,\n.nav-tabs-justified.nav-tabs-top > li > a:hover,\n.nav-tabs-justified.nav-tabs-top > li > a:focus {\n\tborder-width: 2px 0 0 0;\n}\n\n/*-----------------\n\t7. Components\n-----------------------*/\n\n.section-header {\n    margin-bottom: 1.875rem;\n}\n.section-header .section-title {\n    color: #333;\n}\n.line {\n    background-color: #00d0f1;\n    height: 2px;\n    margin: 0;\n    width: 60px;\n}\n.comp-buttons .btn {\n\tmargin-bottom: 5px;\n}\n.pagination-box .pagination {\n\tmargin-top: 0;\n}\n.comp-dropdowns .btn-group {\n\tmargin-bottom: 5px;\n}\n.progress-example .progress {\n\tmargin-bottom: 1.5rem;\n}\n.progress-xs {\n\theight: 4px;\n}\n.progress-sm {\n\theight: 15px;\n}\n.progress.progress-sm {\n\theight: 6px;\n}\n.progress.progress-md {\n\theight: 8px;\n}\n.progress.progress-lg {\n\theight: 18px;\n}\n.row.row-sm {\n    margin-left: -3px;\n    margin-right: -3px;\n}\n.row.row-sm > div {\n    padding-left: 3px;\n    padding-right: 3px;\n}\n.table-responsive {\n\twhite-space: nowrap;\n}\n\n/* Avatar */\n\n.avatar {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 3rem;\n\theight: 3rem\n}\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\t-o-object-fit: contain;\n\tobject-fit: contain;\n}\n.avatar-title {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: #00d0f1;\n\tcolor: #fff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.avatar-away:before,\n.avatar-offline:before,\n.avatar-online:before {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: 25%;\n\theight: 25%;\n\tborder-radius: 50%;\n\tcontent: '';\n\tborder: 2px solid #fff;\n}\n.avatar-online:before {\n\tbackground-color: #7bb13c;\n}\n.avatar-offline:before {\n\tbackground-color: #e84646;\n}\n.avatar-away:before {\n\tbackground-color: #ffbc34;\n}\n.avatar .border {\n\tborder-width: 3px !important;\n}\n.avatar .rounded {\n\tborder-radius: 6px !important;\n}\n.avatar .avatar-title {\n\tfont-size: 18px;\n}\n.avatar-xs {\n\twidth: 1.65rem;\n\theight: 1.65rem;\n}\n.avatar-xs .border {\n\tborder-width: 2px !important;\n}\n.avatar-xs .rounded {\n\tborder-radius: 4px !important;\n}\n.avatar-xs .avatar-title {\n\tfont-size: 12px;\n}\n.avatar-xs.avatar-away:before,\n.avatar-xs.avatar-offline:before,\n.avatar-xs.avatar-online:before {\n\tborder-width: 1px;\n}\n.avatar-sm {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n}\n.avatar-sm .border {\n\tborder-width: 3px !important;\n}\n.avatar-sm .rounded {\n\tborder-radius: 4px !important;\n}\n.avatar-sm .avatar-title {\n\tfont-size: 15px;\n}\n.avatar-sm.avatar-away:before,\n.avatar-sm.avatar-offline:before,\n.avatar-sm.avatar-online:before {\n\tborder-width: 2px;\n}\n.avatar-lg {\n\twidth: 3.75rem;\n\theight: 3.75rem;\n}\n.avatar-lg .border {\n\tborder-width: 3px !important;\n}\n.avatar-lg .rounded {\n\tborder-radius: 8px !important;\n}\n.avatar-lg .avatar-title {\n\tfont-size: 24px;\n}\n.avatar-lg.avatar-away:before,\n.avatar-lg.avatar-offline:before,\n.avatar-lg.avatar-online:before {\n\tborder-width: 3px;\n}\n.avatar-xl {\n\twidth: 5rem;\n\theight: 5rem;\n}\n.avatar-xl .border {\n\tborder-width: 4px !important;\n}\n.avatar-xl .rounded {\n\tborder-radius: 8px !important;\n}\n.avatar-xl .avatar-title {\n\tfont-size: 28px;\n}\n.avatar-xl.avatar-away:before,\n.avatar-xl.avatar-offline:before,\n.avatar-xl.avatar-online:before {\n\tborder-width: 4px;\n}\n.avatar-xxl {\n\twidth: 5.125rem;\n\theight: 5.125rem;\n}\n.avatar-xxl .border {\n\tborder-width: 6px !important;\n}\n.avatar-xxl .rounded {\n\tborder-radius: 8px !important;\n}\n.avatar-xxl .avatar-title {\n\tfont-size: 30px;\n}\n.avatar-xxl.avatar-away:before,\n.avatar-xxl.avatar-offline:before,\n.avatar-xxl.avatar-online:before {\n\tborder-width: 4px;\n}\n.avatar-group {\n\tdisplay: inline-flex;\n}\n.avatar-group .avatar + .avatar {\n\tmargin-left: -.75rem;\n}\n.avatar-group .avatar-xs + .avatar-xs {\n\tmargin-left: -.40625rem;\n}\n.avatar-group .avatar-sm+.avatar-sm {\n\tmargin-left: -.625rem;\n}\n.avatar-group .avatar-lg + .avatar-lg {\n\tmargin-left: -1rem;\n}\n.avatar-group .avatar-xl + .avatar-xl {\n\tmargin-left: -1.28125rem;\n}\n.avatar-group .avatar:hover {\n\tz-index: 1;\n}\n\n/*-----------------\n\t8. Header\n-----------------------*/\n\n.header {\n\tbackground: #fff;\n\tborder-bottom: 1px solid #f0f0f0;\n\tleft: 0;\n\tposition: fixed;\n\tright: 0;\n\ttop: 0;\n\tz-index: 1001;\n\theight: 60px;\n}\n.header .header-left {\n\tfloat: left;\n\theight: 60px;\n\tpadding: 0 20px;\n\tposition: relative;\n\ttext-align: center;\n\twidth: 240px;\n\tz-index: 1;\n\ttransition: all 0.2s ease-in-out;\n}\n.header .header-left .logo {\n\tdisplay: inline-block;\n\tline-height: 60px;\n}\n.header .header-left .logo img {\n    max-height: 40px;\n    width: auto;\n}\n.header-left .logo.logo-small {\n    display: none;\n}\n.header .dropdown-menu > li > a {\n\tposition: relative;\n}\n.header .dropdown-toggle:after {\n\tdisplay: none;\n}\n.header .has-arrow .dropdown-toggle:after {\n\tborder-top: 0;\n\tborder-left: 0;\n\tborder-bottom: 2px solid #333;\n\tborder-right: 2px solid #333;\n\tcontent: '';\n\theight: 8px;\n\tdisplay: inline-block;\n\tpointer-events: none;\n\t-webkit-transform-origin: 66% 66%;\n\t-ms-transform-origin: 66% 66%;\n\ttransform-origin: 66% 66%;\n\t-webkit-transform: rotate(45deg);\n\t-ms-transform: rotate(45deg);\n\ttransform: rotate(45deg);\n\t-webkit-transition: all 0.15s ease-in-out;\n\ttransition: all 0.15s ease-in-out;\n\twidth: 8px;\n\tvertical-align: 2px;\n}\n.header .has-arrow .dropdown-toggle[aria-expanded=\"true\"]:after {\n\t-webkit-transform: rotate(-135deg);\n\t-ms-transform: rotate(-135deg);\n\ttransform: rotate(-135deg);\n}\n.user-menu {\n    float: right;\n    margin: 0;\n    position: relative;\n    z-index: 99;\n}\n.user-menu.nav > li > a {\n\tcolor: #333;\n\tfont-size: 14px;\n\tline-height: 58px;\n\tpadding: 0 15px;\n\theight: 60px;\n}\n.user-menu.nav > li > a:hover,\n.user-menu.nav > li > a:focus {\n\tbackground-color: rgba(0, 0, 0, 0.2);\n}\n.user-menu.nav > li > a:hover i,\n.user-menu.nav > li > a:focus i {\n\tcolor: #333;\n}\n.user-img {\n\tdisplay: inline-block;\n\tmargin-right: 3px;\n\tposition: relative;\n}\n.user-menu.nav > li > a.mobile_btn {\n\tborder: 0;\n\tposition: relative;\n\tpadding: 0;\n\tmargin: 0;\n\tcursor: pointer\n}\n.user-menu .dropdown-menu {\n    min-width: 200px;\n    padding: 0;\n}\n.user-menu .dropdown-menu .dropdown-item {\n    padding: 7px 15px;\n}\n.user-menu .dropdown-menu .dropdown-item {\n    display: flex;\n    align-items: center;\n    border-top: 1px solid #e3e3e3;\n    padding: 10px 15px;\n}\n.user-menu .dropdown-menu .dropdown-item:hover {\n\tcolor: #fff;\n    background: #00d0f1;\n}\n.header .dropdown-menu > li > a:focus,\n.header .dropdown-menu > li > a:hover {\n\tbackground-color: #00d0f1;\n\tcolor: #fff;\n}\n.header .dropdown-menu > li > a:focus i,\n.header .dropdown-menu > li > a:hover i {\n\tcolor: #fff;\n}\n.header .dropdown-menu > li > a {\n\tpadding: 10px 18px;\n}\n.header .dropdown-menu > li > a i {\n\tcolor: #00d0f1;\n\tmargin-right: 10px;\n\ttext-align: center;\n\twidth: 18px;\n}\n.header .user-menu .dropdown-menu > li > a i {\n\tcolor: #00d0f1;\n\tfont-size: 16px;\n\tmargin-right: 10px;\n\tmin-width: 18px;\n\ttext-align: center;\n}\n.header .user-menu .dropdown-menu > li > a:focus i,\n.header .user-menu .dropdown-menu > li > a:hover i {\n\tcolor: #fff;\n}\n.mobile_btn {\n\tdisplay: none;\n\tfloat: left;\n}\n.slide-nav .sidebar {\n\tmargin-left: 0;\n}\n.app-dropdown .dropdown-menu {\n    padding: 0;\n    width: 300px;\n}\n.app-dropdown-menu .app-list {\n    padding: 15px;\n}\n.app-dropdown-menu .app-item {\n    border: 1px solid transparent;\n    border-radius: 3px;\n    color: #737373;\n    display: block;\n    padding: 10px 0;\n    text-align: center;\n}\n.app-dropdown-menu .app-item i {\n    font-size: 20px;\n    height: 24px;\n}\n.app-dropdown-menu .app-item span {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.app-dropdown-menu .app-item:hover,\n.app-dropdown-menu .app-item:focus,\n.app-dropdown-menu .app-item:active, \n.app-dropdown-menu .app-item.active {\n\tbackground-color: #f9f9f9;\n\tborder-color: #e3e3e3;\n}\n.app-list > div + div {\n\tmargin-top: 5px;\n}\n.app-list > .row {\n\tmargin-left: -5px;\n\tmargin-right: -5px;\n}\n.app-list > .row > .col {\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n}\n.user-header {\n    background-color: #f9f9f9;\n    display: flex;\n    padding: 10px 15px;\n}\n.user-header .user-text {\n\tmargin-left: 10px;\n}\n.user-header .user-text h6 {\n    margin-bottom: 2px;\n}\n.menu-title {\n    color: #a3a3a3;\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    padding: 0 25px;\n}\n.sidebar-overlay {\n    background-color: rgba(0, 0, 0, 0.6);\n    display: none;\n    height: 100%;\n    left: 0;\n    position: fixed;\n    top: 60px;\n    width: 100%;\n    z-index: 1000;\n}\nhtml.menu-opened {\n\toverflow: hidden;\n}\nhtml.menu-opened body {\n\toverflow: hidden;\n}\n\n/* Search */\n\n.top-nav-search {\n    float: left;\n    margin-left: 15px;\n}\n.top-nav-search form {\n    margin-top: 10px;\n\tposition: relative;\n    width: 230px;\n}\n.top-nav-search .form-control {\n  \n    border-color: rgba(0, 0, 0, 0.1);\n    border-radius: 50px;\n    color: #333;\n    height: 40px;\n    padding: 10px 50px 10px 15px;\n}\n.top-nav-search .btn {\n    background-color: transparent;\n    border-color: transparent;\n    color: #333;\n    min-height: 40px;\n    padding: 7px 15px;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n.top-nav-search .form-control::-webkit-input-placeholder {\n\tcolor: #333;\n}\n.top-nav-search .form-control::-moz-placeholder {\n\tcolor: #333;\n}\n.top-nav-search .form-control:-ms-input-placeholder {\n\tcolor: #333;\n}\n.top-nav-search .form-control::-ms-input-placeholder {\n\tcolor: #333;\n}\n.top-nav-search .form-control::placeholder {\n\tcolor: #333;\n}\n.top-nav-search.active form {\n    display: block;\n    left: 0;\n    position: absolute;\n}\n\n/*-----------------\n\t9. Sidebar\n-----------------------*/\n\n.sidebar {\n    background-color: #1b5a90;\n   /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);*/\n    bottom: 0;\n    left: 0;\n    margin-top: 0;\n    position: fixed;\n    top: 60px;\n    transition: all 0.2s ease-in-out 0s;\n    width: 240px;\n    z-index: 1001;\n}\n.sidebar.opened {\n\t-webkit-transition: all 0.4s ease;\n\t-moz-transition: all 0.4s ease;\n\ttransition: all 0.4s ease;\n}\n.sidebar-inner {\n\theight: 100%;\n\tmin-height: 100%;\n\ttransition: all 0.2s ease-in-out 0s;\n}\n.sidebar-menu {\n    padding: 15px;\n}\n.sidebar-menu ul {\n\tfont-size: 15px;\n\tlist-style-type: none;\n\tmargin: 0;\n\tpadding: 0;\n\tposition: relative;\n}\n.sidebar-menu li a {\n\tcolor: #fff;\n\tdisplay: block;\n\tfont-size: 16px;\n\theight: auto;\n\tpadding: 0 20px;\n}\n.sidebar-menu li a:hover {\n    color: #5ae8ff;\n}\n.sidebar-menu > ul > li > a:hover {\n\tbackground-color: #19c1dc;\n    color: #fff;\n}\n.sidebar-menu > ul > li.active > a:hover {\n    background-color: #19c1dc;\n    color: #fff;\n}\n.sidebar-menu li.active a {\n    background-color: #00d0f1;\n    color: #fff;\n}\n.menu-title {\n    color: #ebebeb;\n    display: flex;\n    font-size: 14px;\n    opacity: 1;\n    padding: 5px 15px;\n    white-space: nowrap;\n}\n.menu-title > i {\n\tfloat: right;\n\tline-height: 40px;\n}\n.sidebar-menu li.menu-title a {\n    color: #ff9b44;\n    display: inline-block;\n    margin-left: auto;\n    padding: 0;\n}\n.sidebar-menu li.menu-title a.btn {\n    color: #fff;\n    display: block;\n    float: none;\n    font-size: 15px;\n    margin-bottom: 15px;\n    padding: 10px 15px;\n}\n.sidebar-menu ul ul a.active {\n\tcolor: #20e3ff;\n\ttext-decoration: underline;\n}\n.mobile_btn {\n\tdisplay: none;\n\tfloat: left;\n}\n.sidebar .sidebar-menu > ul > li > a span {\n\ttransition: all 0.2s ease-in-out 0s;\n\tdisplay: inline-block;\n\tmargin-left: 10px;\n\twhite-space: nowrap;\n}\n.sidebar .sidebar-menu > ul > li > a span.chat-user {\n    margin-left: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.sidebar .sidebar-menu > ul > li > a span.badge {\n\tmargin-left: auto;\n}\n.sidebar-menu ul ul a {\n    display: block;\n    font-size: 15px;\n    padding: 7px 10px 7px 45px;\n    position: relative;\n}\n.sidebar-menu ul ul {\n\tdisplay: none;\n}\n.sidebar-menu ul ul ul a {\n\tpadding-left: 65px;\n}\n.sidebar-menu ul ul ul ul a {\n\tpadding-left: 85px;\n}\n.sidebar-menu > ul > li {\n    margin-bottom: 3px;\n    position: relative;\n}\n.sidebar-menu > ul > li:last-child {\n    margin-bottom: 0;\n}\n.sidebar-menu .menu-arrow {\n\t-webkit-transition: -webkit-transform 0.15s;\n\t-o-transition: -o-transform 0.15s;\n\ttransition: transform .15s;\n\tposition: absolute;\n\tright: 15px;\n\tdisplay: inline-block;\n\tfont-family: 'FontAwesome';\n\ttext-rendering: auto;\n\tline-height: 40px;\n\tfont-size: 16px;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\t-webkit-transform: translate(0, 0);\n\t-ms-transform: translate(0, 0);\n\t-o-transform: translate(0, 0);\n\ttransform: translate(0, 0);\n\tline-height: 18px;\n\ttop: 11px;\n}\n.sidebar-menu .menu-arrow:before {\n\tcontent: \"\\f105\";\n}\n.sidebar-menu li a.subdrop .menu-arrow {\n\t-ms-transform: rotate(90deg);\n\t-webkit-transform: rotate(90deg);\n\t-o-transform: rotate(90deg);\n\ttransform: rotate(90deg);\n}\n.sidebar-menu ul ul a .menu-arrow {\n\ttop: 10px;\n}\n.sidebar-menu > ul > li > a {\n    align-items: center;\n    border-radius: 3px;\n    display: flex;\n    justify-content: flex-start;\n    padding: 8px 15px;\n    position: relative;\n    transition: all 0.2s ease-in-out 0s;\n\tcolor: #f1f1f1;\n}\n.sidebar-menu ul li a i {\n\tdisplay: inline-block;\n\tfont-size: 24px;\n\tline-height: 24px;\n\ttext-align: left;\n\tvertical-align: middle;\n\twidth: 20px;\n\ttransition: all 0.2s ease-in-out 0s;\n}\n.sidebar-menu ul li.menu-title a i {\n\tfont-size: 16px !important;\n\tmargin-right: 0;\n\ttext-align: right;\n\twidth: auto;\n}\n.sidebar-menu li a > .badge {\n    color: #fff;\n}\n/*-----------------\n\t6. Toggle Button\n-----------------------*/\n\n.check {\n\tdisplay: block;\n\tmargin: 0;\n\tpadding: 0;\n\twidth: 0;\n\theight: 0;\n\tvisibility: hidden;\n\topacity: 0;\n\tpointer-events: none;\n\tposition: absolute;\n}\n.checktoggle {\n    background-color: #e0001a;\n    border-radius: 12px;\n    cursor: pointer;\n    display: block;\n    font-size: 0;\n    height: 24px;\n    margin-bottom: 0;\n    position: relative;\n    width: 48px;\n}\n.checktoggle:after {\n\tcontent: ' ';\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\ttransform: translate(5px, -50%);\n\twidth: 16px;\n\theight: 16px;\n\tbackground-color: #fff;\n\tborder-radius: 50%;\n\ttransition: left 300ms ease, transform 300ms ease;\n}\n.check:checked + .checktoggle {\n\tbackground-color: #55ce63;\n}\n.check:checked + .checktoggle:after {\n\tleft: 100%;\n\ttransform: translate(calc(-100% - 5px), -50%);\n}\n.onoffswitch {\n\tmargin-left: auto;\n    position: relative;\n\twidth: 73px;\n    -webkit-user-select:none;\n\t-moz-user-select:none;\n\t-ms-user-select: none;\n}\n.onoffswitch-checkbox {\n    display: none;\n}\n.onoffswitch-label {\n    display: block; \n\toverflow: hidden; \n\tcursor: pointer;\n\tborder-radius: 20px;\n\tmargin-bottom: 0;\n}\n.onoffswitch-inner {\n\tdisplay: block;\n    margin-left: -100%;\n    transition: margin 0.3s ease-in 0s;\n    width: 200%;\n}\n.onoffswitch-inner:before, .onoffswitch-inner:after {\n    box-sizing: border-box;\n    color: #fff;\n    display: block;\n    float: left;\n    font-size: 16px;\n    height: 30px;\n    line-height: 32px;\n    padding: 0;\n    width: 50%;\n}\n.onoffswitch-inner:before {\n\tbackground-color: #55ce63;\n    color: #fff;\n    content: \"ON\";\n    padding-left: 14px;\n}\n.onoffswitch-inner:after {\n    content: \"OFF\";\n    padding-right: 14px;\n    background-color: #ccc;\n    color: #fff;\n    text-align: right;\n}\n.onoffswitch-switch {\n    background: #fff;\n    border-radius: 20px;\n    bottom: 0;\n    display: block;\n\theight: 20px;\n    margin: 5px;\n    position: absolute;\n    right: 43px;\n    top: 0;\n    transition: all 0.3s ease-in 0s;\n    width: 20px;\n}\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {\n    margin-left: 0;\n}\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {\n    right: 0px; \n}\n\n/*-----------------\n\t10. Content\n-----------------------*/\n\n.main-wrapper {\n\twidth: 100%;\n\theight: 100vh;\n\tmin-height: 100vh;\n}\n.page-wrapper {\n\tmargin-left: 240px;\n\tpadding-top: 60px;\n\tposition: relative;\n\ttransition: all 0.4s ease;\n}\n.page-wrapper > .content {\n\tpadding: 1.875rem 1.875rem 0;\n}\n.page-header {\n\tmargin-bottom: 1.875rem;\n}\n.page-header .breadcrumb {\n    background-color: transparent;\n    color: #6c757d;\n    font-size: 1rem;\n    font-weight: 500;\n    margin-bottom: 0;\n    padding: 0;\n}\n.page-header .breadcrumb a {\n\tcolor: #333;\n}\n.page-title {\n    color: #333;\n    margin-bottom: 5px;\n}\n\n/*-----------------\n\t11. Login\n-----------------------*/\n\n.login-body {\n    display: table;\n    height: 100vh;\n    min-height: 100vh;\n}\n.login-wrapper {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n.login-wrapper .loginbox {\n    background-color: #fff;\n    border-radius: 6px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n\tdisplay: flex;\n    margin: 1.875rem auto;\n    max-width: 800px;\n    min-height: 500px;\n    width: 100%;\n}\n.login-wrapper .loginbox .login-left {\n    align-items: center;\n    background: linear-gradient(180deg, #1b5a90, #00d0f1);\n    border-radius: 6px 0 0 6px;\n    flex-direction: column;\n    justify-content: center;\n    padding: 80px;\n    width: 400px;\n    display: flex;\n}\n.login-wrapper .loginbox .login-right {\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    padding: 40px;\n    width: 400px;\n}\n.login-wrapper .loginbox .login-right .login-right-wrap {\n    max-width: 100%;\n    flex: 0 0 100%;\n}\n.login-wrapper .loginbox .login-right h1 {\n    font-size: 26px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    text-align: center;\n}\n.account-subtitle {\n    color: #4c4c4c;\n    font-size: 17px;\n    margin-bottom: 1.875rem;\n    text-align: center;\n}\n.login-wrapper .loginbox .login-right .forgotpass a {\n\tcolor: #a0a0a0;\n}\n.login-wrapper .loginbox .login-right .forgotpass a:hover {\n\tcolor: #333;\n\ttext-decoration: underline;\n}\n.login-wrapper .loginbox .login-right .dont-have {\n\tcolor: #a0a0a0;\n\tmargin-top: 1.875rem;\n}\n.login-wrapper .loginbox .login-right .dont-have a {\n\tcolor: #333;\n}\n.login-wrapper .loginbox .login-right .dont-have a:hover {\n\ttext-decoration: underline;\n}\n.social-login {\n\ttext-align: center;\n}\n.social-login > span {\n\tcolor: #a0a0a0;\n\tmargin-right: 8px;\n}\n.social-login > a {\n\tbackground-color: #ccc;\n\tborder-radius: 4px;\n\tcolor: #fff;\n\tdisplay: inline-block;\n\tfont-size: 18px;\n\theight: 32px;\n\tline-height: 32px;\n\tmargin-right: 6px;\n\ttext-align: center;\n\twidth: 32px;\n}\n.social-login > a:last-child {\n\tmargin-right: 0;\n}\n.social-login > a.facebook {\n\tbackground-color: #4b75bd;\n}\n.social-login > a.google {\n\tbackground-color: #fe5240;\n}\n.login-or {\n\tcolor: #a0a0a0;\n\tmargin-bottom: 20px;\n\tmargin-top: 20px;\n\tpadding-bottom: 10px;\n\tpadding-top: 10px;\n\tposition: relative;\n}\n.or-line {\n\tbackground-color: #e5e5e5;\n\theight: 1px;\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tdisplay: block;\n}\n.span-or {\n\tbackground-color: #fff;\n\tdisplay: block;\n\tleft: 50%;\n\tmargin-left: -20px;\n\tposition: absolute;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\ttop: 0;\n\twidth: 42px;\n}\n\n/*-----------------\n\t12. Lock Screen\n-----------------------*/\n\n.lock-user {\n    margin-bottom: 20px;\n    text-align: center;\n}\n.lock-user img {\n    margin-bottom: 15px;\n    width: 100px;\n}\n\n/*-----------------\n\t13. Notifications\n-----------------------*/\n\n.notifications {\n\tpadding: 0;\n}\n.notifications .notification-time {\n\tfont-size: 12px;\n\tline-height: 1.35;\n\tcolor: #bdbdbd;\n}\n.notifications .media {\n\tmargin-top: 0;\n\tborder-bottom: 1px solid #f5f5f5;\n}\n.notifications .media:last-child {\n\tborder-bottom: none;\n}\n.notifications .media a {\n\tdisplay: block;\n\tpadding: 10px 15px;\n\tborder-radius: 2px;\n}\n.notifications .media a:hover {\n\tbackground-color: #fafafa;\n}\n.notifications .media > .avatar {\n\tmargin-right: 10px;\n}\n.notifications .media-list .media-left {\n\tpadding-right: 8px;\n}\n.topnav-dropdown-header {\n\tborder-bottom: 1px solid #eee;\n\ttext-align: center;\n}\n.topnav-dropdown-header, \n.topnav-dropdown-footer {\n    font-size: 14px;\n    height: 40px;\n    line-height: 40px;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n.topnav-dropdown-footer {\n\tborder-top: 1px solid #eee;\n}\n.topnav-dropdown-footer a {\n\tdisplay: block;\n\ttext-align: center;\n\tcolor: #333;\n}\n.user-menu.nav > li > a .badge {\n\tbackground-color: #1b5a90;\n    display: block;\n    font-size: 10px;\n    font-weight: bold;\n    min-height: 15px;\n    min-width: 15px;\n    position: absolute;\n    right: 3px;\n    color: #fff;\n    top: 6px;\n}\n.user-menu.nav > li > a > i {\n\tfont-size: 1.5rem;\n\tline-height: 60px;\n}\n.noti-details {\n\tcolor: #989c9e;\n    margin-bottom: 0;\n}\n.noti-title {\n\tcolor: #333;\n}\n.notifications .noti-content {\n\theight: 290px;\n\twidth: 350px;\n\toverflow-y: auto;\n\tposition: relative;\n}\n.notification-list {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n.notifications ul.notification-list > li{\n\tmargin-top: 0;\n\tborder-bottom: 1px solid #f5f5f5;\n}\n.notifications ul.notification-list > li:last-child {\n\tborder-bottom: none;\n}\n.notifications ul.notification-list > li a {\n\tdisplay: block;\n\tpadding: 10px 15px;\n\tborder-radius: 2px;\n}\n.notifications ul.notification-list > li a:hover {\n\tbackground-color: #fafafa;\n}\n.notifications ul.notification-list > li .list-item {\n    border: 0;\n    padding: 0;\n    position: relative;\n}\n.topnav-dropdown-header .notification-title {\n    color: #333;\n    display: block;\n    float: left;\n    font-size: 14px;\n}\n.topnav-dropdown-header .clear-noti {\n    color: #f83f37;\n    float: right;\n    font-size: 12px;\n    text-transform: uppercase;\n}\n.noti-time {\n    margin: 0;\n}\n\n/*-----------------\n\t14. Dashboard\n-----------------------*/\n\n.dash-widget-icon {\n    align-items: center;\n    display: inline-flex;\n    font-size: 1.875rem;\n    height: 50px;\n    justify-content: center;\n    line-height: 48px;\n    text-align: center;\n    width: 50px;\n\tborder: 3px solid;\n    border-radius: 50px;\n    padding: 28px;\n}\n.dash-count {\n    font-size: 18px;\n    margin-left: auto;\n}\n.dash-widget-info h3 {\n    margin-bottom: 10px;\n}\n.dash-widget-header {\n    align-items: center;\n    display: flex;\n    margin-bottom: 15px;\n}\n.card-chart .card-body {\n\tpadding: 8px;\n}\n#morrisArea > svg, #morrisLine > svg  {\n\twidth: 100%;\n}\n.activity-feed {\n    list-style: none;\n    margin-bottom: 0;\n    margin-left: 5px;\n    padding: 0;\n}\n.activity-feed .feed-item {\n    border-left: 2px solid #e4e8eb;\n    padding-bottom: 19px;\n    padding-left: 20px;\n    position: relative;\n}\n.activity-feed .feed-item:last-child {\n\tborder-color: transparent;\n\tpadding-bottom: 0;\n}\n.activity-feed .feed-item:after {\n\tcontent: \"\";\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tleft: -7px;\n\twidth: 12px;\n\theight: 12px;\n\tborder-radius: 50%;\n\tbackground-color: #177dff;\n}\n.activity-feed .feed-item .feed-date {\n\tdisplay: block;\n\tposition: relative;\n\tcolor: #777;\n\ttext-transform: uppercase;\n\tfont-size: 13px;\n }\n.activity-feed .feed-item .feed-text {\n\tcolor: #777;\n\tposition: relative;\n}\n.activity-feed .feed-item .feed-text a {\n    color: #333;\n    font-weight: 600;\n}\n\n/*-----------------\n\t15. Invoice\n-----------------------*/\n\n.add-btn {\n    border: 1px solid transparent;\n    border-radius: 20px;\n    color: #666;\n    display: inline-block;\n    padding: .375rem .75rem;\n}\n.add-btn:hover,\n.add-btn:active,\n.add-btn:focus {\n\tbackground-color: #fff;\n\tborder-color: #ddd;\n\tcolor: #666;\n}\n.add-btn span {\n    align-items: center;\n    background-color: #ffc107;\n    border-radius: 50%;\n    color: #fff;\n    display: inline-flex;\n    font-size: 14px;\n    height: 22px;\n    justify-content: center;\n    margin-right: 3px;\n    width: 22px;\n}\n.invoice-details h4 {\n\tcolor: #666;\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tmargin-bottom: 1.875rem;\n\ttext-transform: uppercase;\n}\n.inv-badge {\n\tcolor: #fff;\n\tdisplay: inline-flex;\n\tfont-size: 11px;\n\tjustify-content: center;\n\tmin-width: 80px;\n}\n.inv-logo {\n    max-height: 80px;\n}\n.invoice-container {\n    background-color: #fff;\n\tborder: 1px solid #f0f0f0;\n    margin: 0 auto 1.875rem;\n    max-width: 900px;\n    padding: 1.5rem;\n}\n.invoice-details,\n.invoice-payment-details > li span {\n\tfloat: right;\n\ttext-align: right;\n}\n.inv-logo {\n\theight: auto;\n\tmax-height: 100px;\n\twidth: auto;\n}\n\n/*-----------------\n\t16. Calendar\n-----------------------*/\n\n.calendar-events {\n    border: 1px solid transparent;\n    cursor: move;\n    padding: 10px 15px;\n}\n.calendar-events:hover {\n\tborder-color: #e9e9e9;\n    background-color: #fff;\n}\n.calendar-events i {\n    margin-right: 8px;\n}\n.calendar {\n\tfloat: left;\n\tmargin-bottom: 0;\n}\n.fc-toolbar.fc-header-toolbar {\n    margin-bottom: 1.5rem;\n}\n.none-border .modal-footer {\n\tborder-top: none;\n}\n.fc-toolbar h2 {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tfont-family: 'Roboto', sans-serif;\n\tline-height: 30px;\n\ttext-transform: uppercase;\n}\n.fc-day-grid-event .fc-time {\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-day {\n\tbackground: #fff;\n}\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 0;\n}\n.fc th.fc-widget-header {\n\tbackground: #eeeeee;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tpadding: 10px 0;\n\ttext-transform: uppercase;\n}\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #f3f3f3;\n}\n.fc-basic-view .fc-day-number, \n.fc-basic-view .fc-week-number {\n    padding: 2px 5px;\n}\n.fc-button {\n\tbackground: #f1f1f1;\n\tborder: none;\n\tcolor: #797979;\n\ttext-transform: capitalize;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n\tmargin: 0 3px !important;\n\tpadding: 6px 12px !important;\n\theight: auto !important;\n}\n.fc-text-arrow {\n\tfont-family: inherit;\n\tfont-size: 16px;\n}\n.fc-state-hover {\n\tbackground: #f3f3f3;\n}\n.fc-state-highlight {\n\tbackground: #f0f0f0;\n}\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n\tbackground-color: #00d0f1 !important;\n\tcolor: #fff !important;\n\ttext-shadow: none !important;\n}\n.fc-cell-overlay {\n\tbackground: #f0f0f0;\n}\n.fc-unthemed .fc-today {\n\tbackground: #fff;\n}\n.fc-event {\n\tborder-radius: 2px;\n\tborder: none;\n\tcolor: #fff !important;\n\tcursor: move;\n\tfont-size: 13px;\n\tmargin: 1px 7px;\n\tpadding: 5px 5px;\n\ttext-align: center;\n}\n.fc-basic-view td.fc-week-number span {\n\tpadding-right: 8px;\n\tfont-weight: 700;\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-basic-view td.fc-day-number {\n\tpadding-right: 8px;\n\tfont-weight: 700;\n\tfont-family: 'Roboto', sans-serif;\n}\n.event-form .input-group .form-control {\n\theight: 40px;\n}\n.submit-section {\n\ttext-align: center;\n\tmargin-top: 40px;\n}\n.submit-btn {\n    border-radius: 50px;\n    font-size: 18px;\n    font-weight: 600;\n    min-width: 200px;\n    padding: 10px 20px;\n}\n\n/*-----------------\n\t17. Inbox\n-----------------------*/\n\n.dropdown-action {\n\tmargin-bottom: 5px;\n}\n.dropdown-action .dropdown-toggle:after {\n\tdisplay: none;\n}\n.table-inbox input[type=\"radio\"],\n.table-inbox input[type=\"checkbox\"] {\n\tcursor: pointer;\n}\n.mail-list {\n\tlist-style: none;\n\tpadding: 0;\n}\n.mail-list > li > a {\n\tcolor: #333;\n\tdisplay: block;\n\tpadding: 10px;\n}\n.mail-list > li.active > a {\n\tcolor: #00d0f1;\n\tfont-weight: bold;\n}\n.unread .name,\n.unread .subject,\n.unread .mail-date {\n\tcolor: #000;\n\tfont-weight: 600;\n}\n.table-inbox .fa-star {\n\tcolor: #ffd200;\n}\n.table-inbox .starred.fa-star {\n\tcolor: #ffd200;\n}\n.table.table-inbox > tbody > tr > td,\n.table.table-inbox > tbody > tr > th,\n.table.table-inbox > tfoot > tr > td,\n.table.table-inbox > tfoot > tr > th,\n.table.table-inbox > thead > tr > td,\n.table.table-inbox > thead > tr > th {\n    border-bottom: 1px solid #f2f2f2;\n    border-top: 0;\n}\n.table-inbox {\n\tfont-size: 15px;\n\tmargin-bottom: 0;\n}\n.table.table-inbox thead {\n\tbackground-color: #fff;\n}\n.note-editor.note-frame {\n\tborder: 1px solid #ddd;\n\tbox-shadow: inherit;\n}\n.note-editor.note-frame .note-statusbar {\n\tbackground-color: #fff;\n}\n.note-editor.note-frame.fullscreen {\n\ttop: 60px;\n}\n.note-editor.note-frame .btn-light {\n    background-color: #f9f9f9;\n    box-shadow: unset;\n    color: #333;\n}\n.mail-title {\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n}\n.form-control.search-message {\n    border-color: #ccc;\n    border-radius: 4px;\n    height: 38px;\n    width: 180px;\n}\n.table-inbox tr {\n\tcursor: pointer;\n}\ntable.table-inbox tbody tr.checked {\n\tbackground-color: #ffffcc;\n}\n.mail-label {\n    font-size: 16px !important;\n    margin-right: 5px;\n}\n\n/*-----------------\n\t18. Mail View\n-----------------------*/\n\n.attachments {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.attachments li {\n\tborder: 1px solid #eee;\n\tfloat: left;\n\tmargin-bottom: 10px;\n\tmargin-right: 10px;\n\twidth: 180px;\n}\n.attach-info {\n\tbackground-color: #f4f4f4;\n\tpadding: 10px;\n}\n.attach-file {\n    color: #777;\n    font-size: 70px;\n    padding: 10px;\n    min-height: 138px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.attach-file img {\n\theight: auto;\n\tmax-width: 100%;\n}\n.mailview-header {\n\tborder-bottom: 1px solid #ddd;\n\tmargin-bottom: 20px;\n\tpadding-bottom: 15px;\n}\n.mailview-footer {\n\tborder-top: 1px solid #ddd;\n\tmargin-top: 20px;\n\tpadding-top: 15px;\n}\n.mailview-footer .btn-white {\n    margin-top: 10px;\n    min-width: 102px;\n}\n.sender-img {\n\tfloat: left;\n\tmargin-right: 10px;\n\twidth: 40px;\n}\n.sender-name {\n\tdisplay: block;\n}\n.receiver-name {\n\tcolor: #777;\n}\n.right-action {\n\ttext-align: right;\n}\n.mail-view-title {\n\tfont-weight: 500;\n\tfont-size: 24px;\n\tmargin: 0;\n}\n.mail-view-action {\n\tfloat: right;\n}\n.mail-sent-time {\n\tfloat: right;\n}\n.inbox-menu {\n\tdisplay: inline-block;\n\tmargin: 0 0 1.875rem;\n\tpadding: 0;\n\twidth: 100%;\n}\n.inbox-menu li {\n\tdisplay: inline-block;\n\twidth: 100%;\n}\n.inbox-menu li + li {\n\tmargin-top: 2px;\n}\n.inbox-menu li a {\n\tcolor: #333;\n\tdisplay: inline-block;\n\tpadding: 10px 15px;\n\twidth: 100%;\n\ttext-transform: capitalize;\n\t-webkit-transition: 0.3s ease;\n\t-moz-transition: 0.3s ease;\n\ttransition: 0.3s ease;\n}\n.inbox-menu li a i {\n\tfont-size: 16px;\n\tpadding-right: 10px;\n\tcolor: #878787;\n}\n.inbox-menu li a:hover, .inbox-menu li.active a, .inbox-menu li a:focus {\n\tbackground: rgba(33, 33, 33, 0.05);\n}\n.compose-btn {\n\tmargin-bottom: 1.875rem;\n}\n.compose-btn a {\n    font-weight: 600;\n    padding: 8px 15px;\n}\n\n/*-----------------\n\t19. Error\n-----------------------*/\n\n.error-page {\n    align-items: center;\n    color: #1f1f1f;\n    display: flex;\n}\n.error-page .main-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    height: auto;\n    justify-content: center;\n    width: 100%;\n\tmin-height: unset;\n}\n.error-box {\n    margin: 0 auto;\n    max-width: 480px;\n    padding: 1.875rem 0;\n    text-align: center;\n    width: 100%;\n}\n.error-box h1 {\n    color: #00d0f1;\n    font-size: 10em;\n}\n.error-box p {\n    margin-bottom: 1.875rem;\n}\n.error-box .btn {\n    border-radius: 50px;\n    font-size: 18px;\n    font-weight: 600;\n    min-width: 200px;\n    padding: 10px 20px;\n}\n\n/*-----------------\n\t20. Chat\n-----------------------*/\n\n.chat-window {\n    border: 1px solid #e0e3e4;\n    display: flex;\n    flex-wrap: wrap;\n    position: relative;\n    margin-bottom: 1.875rem;\n}\n.chat-window .chat-cont-left {\n    border-right: 1px solid #e0e3e4;\n    flex: 0 0 35%;\n    left: 0;\n    max-width: 35%;\n    position: relative;\n    z-index: 4;\n}\n.chat-window .chat-cont-left .chat-header {\n    align-items: center;\n    background-color: #fff;\n    border-bottom: 1px solid #e0e3e4;\n    color: #324148;\n    display: flex;\n    height: 72px;\n    justify-content: space-between;\n    padding: 0 15px;\n}\n.chat-window .chat-cont-left .chat-header span {\n    font-size: 20px;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n.chat-window .chat-cont-left .chat-header .chat-compose {\n    color: #8a8a8a;\n    display: inline-flex;\n}\n.chat-window .chat-cont-left .chat-search {\n    background-color: #f5f5f6;\n    border-bottom: 1px solid #e5e5e5;\n    padding: 10px 15px;\n    width: 100%;\n}\n.chat-window .chat-cont-left .chat-search .input-group {\n    width: 100%;\n}\n.chat-window .chat-cont-left .chat-search .input-group .form-control {\n    background-color: #fff;\n    border-radius: 50px;\n    padding-left: 36px;\n}\n.chat-window .chat-cont-left .chat-search .input-group .form-control:focus {\n    border-color: #ccc;\n    box-shadow: none;\n}\n.chat-window .chat-cont-left .chat-search .input-group .input-group-prepend {\n    align-items: center;\n    bottom: 0;\n    color: #666;\n    display: flex;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    z-index: 4;\n}\n.chat-window .chat-scroll {\n    max-height: calc(100vh - 285px);\n    overflow-y: auto;\n}\n.chat-window .chat-cont-left .chat-users-list {\n    background-color: #fff;\n}\n.chat-window .chat-cont-left .chat-users-list a.media {\n    border-bottom: 1px solid #e5e5e5;\n    padding: 10px 15px;\n    transition: all 0.2s ease 0s;\n}\n.chat-window .chat-cont-left .chat-users-list a.media:last-child {\n\tborder-bottom: 0;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap {\n    margin-right: 15px;\n    position: relative;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .avatar {\n    height: 45px;\n    width: 45px;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-img-wrap .status {\n\tbottom: 7px;\n\theight: 10px;\n\tright: 4px;\n\tposition: absolute;\n\twidth: 10px;\n\tborder: 2px solid #fff;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body {\n    display: flex;\n    justify-content: space-between;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, \n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\n    max-width: 250px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name {\n    color: #333;\n    text-transform: capitalize;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\n    color: #8a8a8a;\n    font-size: 14px;\n    line-height: 24px;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child {\n    text-align: right;\n}\n.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:last-child .last-chat-time {\n    color: #8a8a8a;\n    font-size: 13px;\n}\n.chat-window .chat-cont-left .chat-users-list a.media:hover {\n\tbackground-color: #f5f5f6;\n}\n.chat-window .chat-cont-left .chat-users-list a.media.read-chat .media-body > div:last-child .last-chat-time {\n\tcolor: #8a8a8a;\n}\n.chat-window .chat-cont-left .chat-users-list a.media.active {\n\tbackground-color: #f5f5f6;\n}\n.chat-window .chat-cont-right {\n    flex: 0 0 65%;\n    max-width: 65%;\n}\n.chat-window .chat-cont-right .chat-header {\n    align-items: center;\n    background-color: #fff;\n    border-bottom: 1px solid #e0e3e4;\n    display: flex;\n    height: 72px;\n    justify-content: space-between;\n    padding: 0 15px;\n}\n.chat-window .chat-cont-right .chat-header .back-user-list {\n    display: none;\n    margin-right: 5px;\n    margin-left: -7px;\n}\n.chat-window .chat-cont-right .chat-header .media {\n\talign-items: center;\n}\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 15px;\n}\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap .avatar {\n\theight: 50px;\n\twidth: 50px;\n}\n.chat-window .chat-cont-right .chat-header .media .media-img-wrap .status {\n    border: 2px solid #fff;\n    bottom: 0;\n    height: 10px;\n    position: absolute;\n    right: 3px;\n    width: 10px;\n}\n.chat-window .chat-cont-right .chat-header .media .media-body .user-name {\n    color: #333;\n    font-size: 16px;\n    font-weight: 600;\n    text-transform: capitalize;\n}\n.chat-window .chat-cont-right .chat-header .media .media-body .user-status {\n    color: #666;\n    font-size: 14px;\n}\n.chat-window .chat-cont-right .chat-header .chat-options {\n    display: flex;\n}\n.chat-window .chat-cont-right .chat-header .chat-options > a {\n    align-items: center;\n    border-radius: 50%;\n    color: #8a8a8a;\n    display: inline-flex;\n    height: 30px;\n    justify-content: center;\n    margin-left: 10px;\n    width: 30px;\n}\n.chat-window .chat-cont-right .chat-body {\n    background-color: #f5f5f6;\n}\n.chat-window .chat-cont-right .chat-body ul.list-unstyled {\n    margin: 0 auto;\n    padding: 15px;\n    width: 100%;\n}\n.chat-window .chat-cont-right .chat-body .media .avatar {\n    height: 30px;\n    width: 30px;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body {\n\tmargin-left: 20px;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div {\n\tpadding: 10px 15px;\n\tborder-radius: .25rem;\n\tdisplay: inline-block;\n\tposition: relative;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box > div p {\n    color: #333;\n    margin-bottom: 0;\n}\n.chat-window .chat-cont-right .chat-body .media .media-body .msg-box + .msg-box {\n\tmargin-top: 5px;\n}\n.chat-window .chat-cont-right .chat-body .media.received {\n\tmargin-bottom: 20px;\n}\n.chat-window .chat-cont-right .chat-body .media:last-child {\n\tmargin-bottom: 0;\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div {\n\tbackground-color: #fff;\n}\n.chat-window .chat-cont-right .chat-body .media.sent {\n    margin-bottom: 20px;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body {\n    align-items: flex-end;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    margin-left: 0;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div {\n    background-color: #e3e3e3;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div p {\n    color: #333;\n}\n.chat-window .chat-cont-right .chat-body .chat-date {\n    font-size: 14px;\n    margin: 1.875rem 0;\n    overflow: hidden;\n    position: relative;\n    text-align: center;\n    text-transform: capitalize;\n}\n.chat-window .chat-cont-right .chat-body .chat-date:before {\n    background-color: #e0e3e4;\n    content: \"\";\n    height: 1px;\n    margin-right: 28px;\n    position: absolute;\n    right: 50%;\n    top: 50%;\n    width: 100%;\n}\n.chat-window .chat-cont-right .chat-body .chat-date:after {\n    background-color: #e0e3e4;\n    content: \"\";\n    height: 1px;\n    left: 50%;\n    margin-left: 28px;\n    position: absolute;\n    top: 50%;\n    width: 100%;\n}\n.chat-window .chat-cont-right .chat-footer {\n    background-color: #fff;\n    border-top: 1px solid #e0e3e4;\n    padding: 10px 15px;\n    position: relative;\n}\n.chat-window .chat-cont-right .chat-footer .input-group {\n    width: 100%;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .form-control {\n    background-color: #f5f5f6;\n    border: none;\n    border-radius: 50px;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .form-control:focus {\n    background-color: #f5f5f6;\n    border: none;\n    box-shadow: none;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .input-group-prepend .btn, \n.chat-window .chat-cont-right .chat-footer .input-group .input-group-append .btn {\n    background-color: transparent;\n    border: none;\n    color: #9f9f9f;\n}\n.chat-window .chat-cont-right .chat-footer .input-group .input-group-append .btn.msg-send-btn {\n    background-color: #00d0f1;\n    border-color: #00d0f1;\n    border-radius: 50%;\n    color: #fff;\n    margin-left: 10px;\n}\n.msg-typing {\n\twidth: auto;\n\theight: 24px;\n\tpadding-top: 8px\n}\n.msg-typing span {\n\theight: 8px;\n\twidth: 8px;\n\tfloat: left;\n\tmargin: 0 1px;\n\tbackground-color: #a0a0a0;\n\tdisplay: block;\n\tborder-radius: 50%;\n\topacity: .4\n}\n.msg-typing span:nth-of-type(1) {\n\tanimation: 1s blink infinite .33333s\n}\n\n.msg-typing span:nth-of-type(2) {\n\tanimation: 1s blink infinite .66666s\n}\n\n.msg-typing span:nth-of-type(3) {\n\tanimation: 1s blink infinite .99999s\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box {\n\tposition: relative;\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box:first-child:before {\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid #fff;\n    border-top: 6px solid transparent;\n    content: \"\";\n    height: 0;\n    left: -6px;\n    position: absolute;\n    right: auto;\n    top: 8px;\n    width: 0;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box {\n    padding-left: 50px;\n    position: relative;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box:first-child:before {\n\tborder-bottom: 6px solid transparent;\n\tborder-left: 6px solid #e3e3e3;\n\tborder-top: 6px solid transparent;\n    content: \"\";\n    height: 0;\n    left: auto;\n    position: absolute;\n    right: -6px;\n    top: 8px;\n    width: 0;\n}\n.chat-msg-info {\n    align-items: center;\n    display: flex;\n    clear: both;\n    flex-wrap: wrap;\n    list-style: none;\n    padding: 0;\n    margin: 5px 0 0;\n}\n.chat-msg-info li {\n    font-size: 13px;\n    padding-right: 16px;\n    position: relative;\n}\n.chat-msg-info li:not(:last-child):after {\n\tposition: absolute;\n\tright: 8px;\n\ttop: 50%;\n\tcontent: '';\n\theight: 4px;\n\twidth: 4px;\n\tbackground: #d2dde9;\n\tborder-radius: 50%;\n\ttransform: translate(50%, -50%)\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box .chat-msg-info li:not(:last-child)::after {\n    right: auto;\n    left: 8px;\n    transform: translate(-50%, -50%);\n    background: #aaa;\n}\n.chat-window .chat-cont-right .chat-body .media.received .media-body .msg-box > div .chat-time {\n    color: rgba(50, 65, 72, 0.4);\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-time {\n    color: rgba(50, 65, 72, 0.4);\n}\n.chat-msg-info li a {\n\tcolor: #777;\n}\n.chat-msg-info li a:hover {\n\tcolor: #2c80ff\n}\n.chat-seen i {\n\tcolor: #00d285;\n\tfont-size: 16px;\n}\n.chat-msg-attachments {\n\tpadding: 4px 0;\n\tdisplay: flex;\n\twidth: 100%;\n\tmargin: 0 -1px\n}\n.chat-msg-attachments > div {\n\tmargin: 0 1px\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info {\n    flex-direction: row-reverse;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-attachments {\n\tflex-direction: row-reverse\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div .chat-msg-info li {\n    padding-left: 16px;\n    padding-right: 0;\n    position: relative;\n}\n.chat-attachment img {\n    max-width: 100%;\n}\n.chat-attachment {\n\tposition: relative;\n\tmax-width: 130px;\n\toverflow: hidden;\n}\n.chat-attachment {\n\tborder-radius: .25rem;\n}\n.chat-attachment:before {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tbackground: #000;\n\tcontent: \"\";\n\topacity: 0.4;\n\ttransition: all .4s;\n}\n.chat-attachment:hover:before {\n\topacity: 0.6;\n}\n.chat-attach-caption {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tcolor: #fff;\n\tpadding: 7px 15px;\n\tfont-size: 13px;\n\topacity: 1;\n\ttransition: all .4s;\n}\n.chat-attach-download {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\topacity: 0;\n\ttransition: all .4s;\n\tcolor: #fff;\n\twidth: 32px;\n\tline-height: 32px;\n\tbackground: rgba(255, 255, 255, 0.2);\n\ttext-align: center;\n}\n.chat-attach-download:hover {\n\tcolor: #495463;\n\tbackground: #fff;\n}\n.chat-attachment:hover .chat-attach-caption {\n\topacity: 0;\n}\n.chat-attachment:hover .chat-attach-download {\n\topacity: 1;\n}\n.chat-attachment-list {\n\tdisplay: flex;\n\tmargin: -5px;\n}\n.chat-attachment-list li {\n\twidth: 33.33%;\n\tpadding: 5px;\n}\n.chat-attachment-item {\n\tborder: 5px solid rgba(230, 239, 251, 0.5);\n\theight: 100%;\n\tmin-height: 60px;\n\ttext-align: center;\n\tfont-size: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.chat-window .chat-cont-right .chat-body .media.sent .media-body .msg-box > div:hover .chat-msg-actions {\n\topacity: 1;\n}\n.chat-msg-actions {\n\tposition: absolute;\n\tleft: -30px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\topacity: 0;\n\ttransition: all .4s;\n\tz-index: 2;\n}\n.chat-msg-actions > a {\n    padding: 0 10px;\n    color: #495463;\n    font-size: 24px;\n}\n.chat-msg-actions > a:hover {\n\tcolor: #2c80ff;\n}\n\n@keyframes blink {\n\t50% {\n\t\topacity: 1\n\t}\n}\n.btn-file {\n    align-items: center;\n    display: inline-flex;\n    font-size: 20px;\n    justify-content: center;\n    overflow: hidden;\n    padding: 0 0.75rem;\n    position: relative;\n    vertical-align: middle;\n}\n.btn-file input {\n    cursor: pointer;\n    filter: alpha(opacity=0);\n    font-size: 23px;\n    height: 100%;\n    margin: 0;\n    opacity: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 100%;\n}\n\n/*-----------------\n\t21. Product\n-----------------------*/\n\n.product {\n\t-moz-transition: all 0.5s;\n\t-webkit-transition: all 0.5s;\n\t-o-transition: all 0.5s;\n\tborder: 1px solid #e7e7e7;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\tbackground-color: #fff;\n\tmargin-bottom: 1.875rem;\n}\n.product-inner {\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 100%;\n}\n.product-inner img {\n\twidth: 100%;\n\theight: auto;\n}\n.product-inner .cart-btns {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.5);\n\topacity: 0;\n\ttransition: all 0.5s;\n\t-moz-transition: all 0.5s;\n\t-webkit-transition: all 0.5s;\n\t-o-transition: all 0.5s;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n.cart-btns .btn {\n\twidth: 120px;\n\tdisplay: block;\n\ttransition: all 0.5s;\n\t-moz-transition: all 0.5s;\n\t-webkit-transition: all 0.5s;\n\t-o-transition: all 0.5s;\n}\n.cart-btns .btn + .btn {\n\tmargin-top: 10px;\n}\n.product .pro-desc {\n    margin-top: 10px;\n}\n.pro-desc .price {\n\tfont-size: 18px;\n\tline-height: 20px;\n\tcolor: #333;\n\tfont-weight: bold;\n}\n.product:hover .cart-btns {\n\topacity: 1;\n}\n.pro-desc h5 {\n\tfont-size: 1rem;\n}\n.pro-desc h5 a {\n\tcolor: #333;\n}\n.product-det {\n\tposition: relative;\n\tdisplay: block;\n\tfloat: left;\n\twidth: 100%;\n\tmin-height: 40px;\n}\n.product-desc {\n\tpadding: 0 0 0 70px;\n}\n.product-det > img {\n\ttop: 0;\n\twidth: 60px;\n\tposition: absolute;\n\tleft: 0;\n}\n.product-desc span,\n.product-desc a {\n\twidth: 100%;\n\tmargin: 0;\n\tpadding: 0;\n\tdisplay: block;\n}\n\n/*-----------------\n\t22. Product Details\n-----------------------*/\n\n.product-content {\n\tposition: relative;\n}\n.product-content p {\n\tcolor: #333;\n\tmargin: 0 0 20px;\n}\n.product-content p:last-child {\n\tmargin-bottom: 0;\n}\n.proimage-thumb {\n\tfloat: left;\n\tlist-style: none;\n\tpadding: 0;\n}\n.proimage-thumb li {\n\tfloat: left;\n\theight: 60px;\n\twidth: 80px;\n\ttext-align: center;\n\tmargin: 13px 12px 0 0;\n}\n.proimage-thumb li img {\n\tdisplay: block;\n\theight: 62px;\n\twidth: 81px;\n\tborder-radius: 3px;\n\t-moz-border-radius: 3px;\n\t-webkit-border-radius: 3px;\n\tposition: relative;\n}\n.rated {\n\tcolor: #fc0;\n}\n.product_price {\n\tfont-size: 30px;\n\tfont-weight: bold;\n}\n.review-list {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.review-list li {\n\tclear: both;\n\tpadding-left: 80px;\n}\n.review-list li .review {\n\tmargin-bottom: 1.875rem;\n}\n.review-list li .review-author {\n\tmargin-left: -80px;\n\tposition: absolute;\n}\n.review-list li img.avatar {\n\theight: 58px;\n\twidth: 58px;\n\tborder-radius: 58px;\n}\n.review-by {\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 21px;\n\tmargin: 0 0 10px;\n}\n.review-list .review-block p {\n\tline-height: 20px;\n\tmargin: 0;\n\ttext-align: justify;\n}\n.new-review label {\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n.new-review input.form-control {\n\tborder: 1px solid #e5e5e5;\n\tborder-radius: 0;\n\tbox-shadow: inherit;\n\theight: 40px;\n}\n.new-review textarea.form-control {\n\tborder: 1px solid #e5e5e5;\n\tborder-radius: 0;\n\tbox-shadow: inherit;\n}\n.new-review .form-group {\n\tmargin-bottom: 20px;\n}\n.review-submit .btn {\n\tbackground-color: #00bf6f;\n\tborder-color: #00bf6f;\n\tborder-radius: 0;\n\tfont-size: 18px;\n\tpadding: 8px 26px;\n\tcolor: #fff;\n}\n.review-date {\n\tcolor: #999;\n}\n.review-author-name {\n    font-size: 18px;\n    margin-bottom: 0.5rem;\n    display: inline-block;\n}\n.product-reviews {\n\tmargin-bottom: 1.875rem;\n}\n.rating {\n    display: flex;\n}\n.rating i + i {\n    margin-left: 2px;\n}\n\n/*-----------------\n\t23. Profile\n-----------------------*/\n\n.profile-header {\n    background-color: #fff;\n    border: 1px solid #f0f0f0;\n    padding: 1.5rem;\n}\n.profile-menu {\n    background-color: #fff;\n\tborder: 1px solid #f0f0f0;\n    padding: 0.9375rem 1.5rem;\n}\n.profile-menu .nav-tabs.nav-tabs-solid {\n\tbackground-color: transparent;\n}\n.profile-header img {\n    height: auto;\n    max-width: 120px;\n    width: 120px;\n}\n.profile-tab-cont {\n\tpadding-top: 1.875rem;\n}\n.about-text {\n    max-width: 500px;\n}\n.skill-tags span {\n    background-color: #f4f4f5;\n    border-radius: 4px;\n    color: #66676b;\n    display: inline-block;\n    font-size: 15px;\n    line-height: 22px;\n    margin: 2px 0;\n    padding: 5px 15px;\n}\n.edit-link {\n    color: #66676b;\n    font-size: 16px;\n    margin-top: 4px;\n}\n.cal-icon {\n\tposition: relative;\n\twidth: 100%;\n}\n.cal-icon:after {\n\tcolor: #979797;\n\tcontent: \"\\f073\";\n\tdisplay: block;\n\tfont-family: \"FontAwesome\";\n    font-size: 15px;\n    margin: auto;\n    position: absolute;\n    right: 15px;\n    top: 10px;\n}\n.form-title {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    font-size: 1.25rem;\n\tfont-weight: 500;\n    line-height: inherit;\n    color: #333;\n    white-space: normal;\n    position: relative;\n    display: block;\n    margin-bottom: 20px;\n}\n.form-title:before {\n    content: \"\";\n    position: absolute;\n    left: 0px;\n    right: 0px;\n    height: 1px;\n    top: 50%;\n    background-color: rgba(0, 0, 0, 0.1);\n}\n.form-title span {\n    padding: 0px 0.5rem 0 0;\n    background-color: #fff;\n    display: inline-block;\n    z-index: 2;\n    position: relative;\n}\n\n/*-----------------\n\t24. Template Options\n-----------------------*/\n\n.skin-settings {\n\tz-index: 999;\n\tposition: fixed;\n\ttop: 50%;\n\twidth: 190px;\n\tborder: 0;\n\tbox-shadow: none;\n\tpadding: 0;\n\tborder-bottom-left-radius: 2px;\n\tright: -190px;\n\tbackground: #fff;\n\ttransition: all 0.4s ease;\n}\n.skin-settings.active {\n\tright: 0;\n\ttransition: all 0.4s ease;\n}\n.skin-settings .skin-sett-icon {\n    background-color: #fff;\n    border-bottom-left-radius: 2px;\n    border-color: #e0e0e0;\n    border-style: solid;\n    border-top-left-radius: 2px;\n    border-width: 1px 0 1px 1px;\n    color: #666;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 20px;\n    height: 48px;\n    left: -47px;\n    line-height: 48px;\n    position: absolute;\n    text-align: center;\n    top: 0;\n    width: 48px;\n}\n.skin-settings .skin-sett-body {\n    background-color: #fff;\n    border-bottom: 1px solid #e0e0e0;\n    border-left: 1px solid #e0e0e0;\n    border-top: 1px solid #e0e0e0;\n    color: #616161;\n    padding: 14px 10px;\n}\n.skin-sett-body h4 {\n    color: #666;\n    font-size: 1.125rem;\n}\n.skin-settings .skin-colors {\n    font-size: 0;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    text-align: left;\n}\n.skin-settings .skin-colors > li {\n    display: inline-block;\n}\n.skin-settings .skin-colors li a {\n    border-radius: 2px;\n\tcursor: pointer;\n    display: block;\n    height: 36px;\n    margin: 0 3px;\n\tposition: relative;\n    width: 36px;\n}\n.skin-settings .skin-colors .skin-red {\n    background-color: #c12942;\n}\n.skin-settings .skin-colors .skin-orange {\n\tbackground-color: #ff7000;\n}\n.skin-settings .skin-colors .skin-teal {\n\tbackground: linear-gradient(to right, #00a0b0 0%, #00d2e6 100%);\n}\n.skin-settings .skin-colors .skin-purple {\n\tbackground-color: #00d0f1;\n}\n.skin-settings .skin-colors li a.active:after {\n    color: #fff;\n\tcontent: \"\\f00c\";\n    display: block;\n    font-family: \"FontAwesome\";\n    font-size: 15px;\n    left: 50%;\n    margin: auto;\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n/*-----------------\n\t25. Blog\n-----------------------*/\n\n.blog {\n\tborder: 1px solid #f0f0f0;\n\tbackground-color: #fff;\n\tborder-radius: 4px;\n\tmargin-bottom: 30px;\n\tpadding: 1.5rem;\n\tposition: relative;\n}\n.blog-image {\n\toverflow: hidden;\n}\n.blog-image,\n.blog-image > a,\n.blog-image img {\n\tdisplay: block;\n\tposition: relative;\n\twidth: 100%;\n\theight: auto;\n}\n.blog-image img {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n\ttransform: translateZ(0);\n\t-moz-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\t-ms-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\t-o-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\t-webkit-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\ttransition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n}\n.blog-image a:hover img {\n    -webkit-transform: scale(1.15);\n    -moz-transform: scale(1.15);\n    transform: scale(1.15);\n}\n.blog-image {\n\tmargin-bottom: 30px;\n}\n.blog-content {\n\tposition: relative;\n}\n.blog-title {\n\tfont-size: 22px;\n\tmargin: 0 0 10px;\n}\n.blog-title a {\n\tcolor: #272b41;\n}\n.blog-title a:hover {\n\tcolor: #20c0f3;\n}\n.blog-content p {\n\tcolor: #666;\n\tfont-size: 14px;\n\tmargin: 0 0 30px;\n}\n.read-more {\n    display: inline-block;\n    font-size: 16px;\n    padding: 0;\n    color: #20c0f3;\n    text-decoration: underline;\n    font-weight: bold;\n}\n.blog-info {\n    color: #757575;\n    font-size: 14px;\n    margin-bottom: 15px;\n}\n.blog-info a {\n\tcolor: #757575;\n}\n.blog-info a:hover {\n\tcolor: #757575;\n}\n.blog-info i {\n\tcolor: #20c0f3;\n\tfont-size: 14px;\n\tmargin-right: 5px;\n}\n.entry-meta {\n\tcolor: #757575;\n\tfont-size: 14px;\n\tlist-style: none;\n\tmargin-bottom: 15px;\n\tpadding: 0;\n}\n.entry-meta li {\n    display: inline-block;\n    margin-right: 15px;\n}\n.entry-meta li:last-child {\n\tmargin-right: 0;\n}\n.blog-pagination .pagination {\n\tmargin-bottom: 30px;\n}\n.blog-pagination .pagination li a {\n    padding: 12px 20px;\n    font-weight: 600;\n    color: #2E3842;\n    margin-right: 10px;\n    border-radius: inherit !important;\n\tborder-color: #f0f0f0;\n}\n.blog-pagination .pagination li.disabled a {\n\tborder-color: #f0f0f0;\n}\n.blog-pagination .pagination li.active a {\n\tbackground: #20c0f3;\n\tborder-color: transparent;\n\tcolor: #ffffff;\n}\n.post-left ul {\n\tmargin: 0;\n\tpadding-left: 0;\n\tlist-style: none;\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n}\n.post-left ul li {\n\tmargin-bottom: 5px;\n\tmargin-right: 20px;\n}\n.post-left ul li:last-child {\n\tmargin-right: 0;\n}\n.post-author a {\n\tdisplay: flex;\n\talign-items: center;\n}\n.video {\n\tposition: relative;\n\tpadding-bottom: 56%;\n\theight: 0;\n\toverflow: hidden;\n}\n.video iframe,\n.video object,\n.video embed {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n}\n.latest-posts {\n\tmargin: 0;\n\tpadding: 0;\n}\n.latest-posts li {\n\tdisplay: table;\n\twidth: 100%;\n\tmargin-bottom: 20px;\n}\n.latest-posts li:last-child {\n\tpadding-bottom: 0px;\n\tmargin-bottom: 0px;\n\tborder-bottom: none;\n}\n.post-thumb {\n\tborder-radius: 4px;\n\twidth: 80px;\n\tfloat: left;\n\toverflow: hidden;\n}\n.post-thumb a img {\n\tborder-radius: 4px;\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n\ttransform: translateZ(0);\n\t-moz-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\t-ms-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\t-o-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\t-webkit-transition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n\ttransition: all 2000ms cubic-bezier(.19,1,.22,1) 0ms;\n}\n.post-thumb a:hover img {\n    -webkit-transform: scale(1.15);\n    -moz-transform: scale(1.15);\n    transform: scale(1.15);\n}\n.post-info {\n\tmargin-left: 95px;\n}\n.post-info h4 {\n\tfont-size: 15px;\n\tmargin: 0 0 5px;\n}\n.post-info h4 a {\n\tcolor: #272b41;\n}\n.post-info h4 a:hover {\n\tcolor: #20c0f3;\n}\n.post-info p {\n\tcolor: #757575;\n\tfont-size: 12px;\n\tmargin: 0;\n}\n.post-info p i {\n\tcolor: #20c0f3;\n\tfont-size: 14px;\n\tmargin-right: 4px;\n}\n.category-widget .categories {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.category-widget .categories li {\n    margin-bottom: 20px;\n}\n.category-widget .categories li:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n}\n.category-widget .categories li a {\n    color: #2E3842;\n    font-size: 15px;\n    font-weight: 500;\n}\n.category-widget .categories li a span {\n    float: right;\n    color: #757575;\n}\n.category-widget .categories li a:hover {\n\tcolor: #20c0f3;\n}\n.category-widget .categories > li > a > i {\n\tcolor: #20c0f3;\n\tfont-size: 18px;\n\tmargin-right: 10px;\n}\n.tags-widget .card-body {\n\tpadding-bottom: 1rem;\n}\n.tags {\n\tlist-style: none;\n\tmargin: 0;\n\toverflow: hidden;\n\tpadding: 0;\n}\n.tags li {\n\tfloat: left;\n}\n.tag {\n\tbackground-color: #fff;\n\tborder-radius: 4px;\n\tcolor: #272b41;\n\tpadding: 5px 10px;\n\tposition: relative;\n\tmargin: 0 .5rem .5rem 0;\n\tfont-size: 14px;\n\tborder: 1px solid #ccc;\n\tdisplay: inline-block;\n}\n.tag:hover {\n\tbackground-color: #20c0f3;\n\tborder-color: #20c0f3;\n\tcolor: #fff;\n}\n.comment-by {\n\tdisplay: block;\n\tfont-size: 14px;\n\tline-height: 21px;\n\tmargin: 0 0 10px;\n}\n.comments-list .comment-block p {\n    font-size: 14px;\n    margin-bottom: 5px;\n}\n\n/*-----------------\n\t26. Blog Details\n-----------------------*/\n\n.blog-view .blog-title {\n\tfont-size: 24px;\n}\n.blog-content p:last-child {\n\tmargin-bottom: 0;\n}\n.blog-view .blog-info {\n\tborder: 0;\n\tmargin-bottom: 20px;\n\tpadding: 0;\n}\n.social-share {\n\tfloat: left;\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.social-share > li {\n\tdisplay: inline-block;\n\tfloat: left;\n\tmargin-left: 10px;\n\ttext-align: center;\n}\n.social-share > li:first-child {\n\tmargin-left: 0;\n}\n.social-share > li > a {\n\tborder: 1px solid #dfdfdf;\n\tcolor: #666;\n\tdisplay: inline-block;\n\tfont-size: 22px;\n\theight: 40px;\n\tline-height: 40px;\n\twidth: 40px;\n}\n.social-share > li > a:hover {\n\tbackground-color: #20c0f3;\n\tcolor: #fff;\n\tborder-color: #20c0f3;\n}\n.blog-reply > a {\n\tcolor: #999;\n\tfont-size: 12px;\n\tfont-weight: 500;\n}\n.blog-date {\n\tcolor: #999;\n\tfont-size: 12px;\n}\n.blog-comments .comments-list {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tposition: relative;\n}\n.blog-comments .comments-list li {\n\tclear: both;\n\tpadding-left: 80px;\n}\n.blog-comments .comments-list li .comment {\n\tmargin-bottom: 20px;\n}\n.blog-comments .comments-list li .comment-author {\n\tleft: 0;\n\tposition: absolute;\n}\n.blog-comments .comments-list li img.avatar {\n\theight: 58px;\n\twidth: 58px;\n\tborder-radius: 58px;\n}\n.blog-comments .comment-btn {\n    color: #20c0f3;\n    display: inline-block;\n    font-weight: 500;\n    font-size: 15px;\n}\n.blog-author-name {\n    color: #272b41;\n    font-size: 16px;\n    font-weight: 600;\n}\n.new-comment label {\n\tfont-weight: 500;\n}\n.comment-submit .btn {\n\tbackground-color: #20c0f3;\n\tborder-color: #20c0f3;\n\tborder-radius: 0;\n\tfont-size: 18px;\n\tpadding: 8px 26px;\n\tcolor: #fff;\n}\n.about-author-img {\n\tbackground-color: #fff;\n\theight: 100px;\n\toverflow: hidden;\n\tposition: absolute;\n\twidth: 100px;\n}\n.author-details {\n\tmargin-left: 120px;\n}\n.about-author {\n\tmin-height: 100px;\n}\n.author-details .blog-author-name {\n\tdisplay: inline-block;\n\tmargin-bottom: 10px;\n}\n.post-author img {\n    border-radius: 100%;\n    width: 28px;\n    margin-right: 5px;\n}\n.custom-edit-service textarea.form-control{\n\tmin-height: 200px;\n}\n.custom-edit-service .service-upload {\n    border: 1px solid #dcdcdc;\n    border-radius: .25rem;\n    text-align: center;\n    padding: 70px 0;\n    margin-bottom: 30px;\n    background-color: #fff;\n    position: relative;\n}\n.custom-edit-service .service-upload input[type=\"file\"] {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n    cursor: pointer;\n}\n.custom-edit-service .service-upload i{\n\tfont-size: 50px;\n    color: #858585;\n}\n.custom-edit-service .service-upload span {\n    font-size: 15px;\n    color: #858585;\n    margin-top: 14px;\n    display: block;\n}\n.custom-edit-service .upload-wrap {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n}\n.custom-edit-service .upload-wrap li {\n    margin: 10px;\n}\n.custom-edit-service .upload-wrap li:first-child{\n\tmargin-left: 0;\n}\n.custom-edit-service .upload-wrap li .upload-images{\n\twidth: 80px;\n\tposition: relative;\n}\n.custom-edit-service .upload-wrap li img{\n\tmax-width: 100%;\n}\n/*-----------------\n\t27. Blog Grid\n-----------------------*/\n\n.grid-blog .blog-title {\n    font-size: 18px;\n    margin: 0 0 5px;\n    min-height: 43px;\n}\n.grid-blog .blog-content p {\n\tmargin: 0 0 15px;\n}\n.grid-blog .blog-info {\n\tmargin-bottom: 15px;\n}\n.grid-blog .blog-image {\n\tmargin-bottom: 20px;\n}\n.blog.grid-blog {\n\tpadding: 20px;\n}\n.grid-blog .entry-meta {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\tflex-wrap: wrap;\n\tmargin-bottom: 0;\n}\n.grid-blog .entry-meta li {\n\tmargin-bottom: 10px;\n}\n.grid-blog .entry-meta li:last-child {\n\tflex: 0 0 100px;\n\tmax-width: 100px;\n}\n.grid-blog .post-author {\n    width: 189px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.grid-blog .post-author a:hover {\n\tcolor: #20c0f3\n}\n\n/*-----------------\n\t28. Responsive\n-----------------------*/\n\n@media only screen and (min-width:768px) {\n\t.avatar-xxl {\n\t\twidth: 8rem;\n\t\theight: 8rem;\n\t}\n\t.avatar-xxl .border {\n\t\tborder-width: 4px !important;\n\t}\n\t.avatar-xxl .rounded {\n\t\tborder-radius: 12px !important;\n\t}\n\t.avatar-xxl .avatar-title {\n\t\tfont-size: 42px;\n\t}\n\t.avatar-xxl.avatar-away:before,\n\t.avatar-xxl.avatar-offline:before,\n\t.avatar-xxl.avatar-online:before {\n\t\tborder-width: 4px;\n\t}\n}\n\n@media only screen and (min-width: 992px) {\n\t#toggle_btn {\n\t\talign-items: center;\n\t\tcolor: #333;\n\t\tdisplay: inline-flex;\n\t\tfloat: left;\n\t\tfont-size: 30px;\n\t\theight: 60px;\n\t\tjustify-content: center;\n\t\tmargin-left: 15px;\n\t\tpadding: 0 15px;\n\t}\n\t.mini-sidebar .header-left .logo img {\n\t\theight: auto;\n\t\tmax-height: 40px;\n\t\twidth: auto;\n\t}\n\t.mini-sidebar .header .header-left .logo {\n\t\tdisplay: none;\n\t}\n\t.mini-sidebar .header-left .logo.logo-small {\n\t\tdisplay: block;\n\t}\n\t.mini-sidebar .header .header-left {\n\t\tpadding: 0 5px;\n\t\twidth: 78px;\n\t}\n\t.mini-sidebar .sidebar {\n\t\twidth: 78px;\n\t}\n\t.mini-sidebar.expand-menu .sidebar {\n\t\twidth: 240px;\n\t}\n\t.mini-sidebar .menu-title {\n\t\tvisibility: hidden;\n\t\twhite-space: nowrap;\n\t}\n\t.mini-sidebar.expand-menu .menu-title {\n\t\tvisibility: visible;\n\t}\n\t.mini-sidebar .menu-title a {\n\t\tvisibility: hidden;\n\t}\n\t.mini-sidebar.expand-menu .menu-title a {\n\t\tvisibility: visible;\n\t}\n\t.modal-open.mini-sidebar .sidebar {\n\t\tz-index: 1051;\n\t}\n\t.mini-sidebar .sidebar .sidebar-menu ul > li > a span {\n\t\tdisplay: none;\n\t\ttransition: all 0.2s ease-in-out;\n\t\topacity: 0;\n\t}\n\t.mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a span {\n\t\tdisplay: inline;\n\t\topacity: 1;\n\t}\n\t.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li > a i {\n\t\tfont-size: 24px;\n\t\twidth: 20px;\n\t}\n\t.mini-sidebar .page-wrapper {\n\t\tmargin-left: 78px;\n\t}\n}\n\n@media only screen and (max-width: 1400px) {\n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, \n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\n\t\tmax-width: 180px;\n\t}\n}\n@media only screen and (max-width: 1199px) {\n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, \n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\n\t\tmax-width: 150px;\n\t}\n\t.chat-window .chat-cont-left {\n\t\tflex: 0 0 40%;\n\t\tmax-width: 40%;\n\t}\n\t.chat-window .chat-cont-right {\n\t\tflex: 0 0 60%;\n\t\tmax-width: 60%;\n\t}\n}\n@media only screen and (max-width: 991.98px) {\n\t.header .header-left {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t}\n\t.mobile_btn {\n\t\tcolor: #333 !important;\n\t\tcursor: pointer;\n\t\tdisplay: block;\n\t\tfont-size: 24px;\n\t\theight: 60px;\n\t\tleft: 0;\n\t\tline-height: 60px;\n\t\tpadding: 0 15px;\n\t\tposition: absolute;\n\t\ttext-align: center;\n\t\ttop: 0;\n\t\tz-index: 10;\n\t}\n\t#toggle_btn {\n\t\tdisplay: none;\n\t}\n\t.top-nav-search {\n\t\tdisplay: none;\n\t}\n\t.login-wrapper .loginbox .login-left {\n\t\tpadding: 80px 50px;\n\t\twidth: 50%;\n\t}\n\t.login-wrapper .loginbox .login-right {\n\t\tpadding: 50px;\n\t\twidth: 50%;\n\t}\n\t.sidebar {\n\t\tmargin-left: -225px;\n\t\twidth: 225px;\n\t\t-webkit-transition: all 0.4s ease;\n\t\t-moz-transition: all 0.4s ease;\n\t\ttransition: all 0.4s ease;\n\t\tz-index: 1041;\n\t}\n\t.page-wrapper {\n\t\tmargin-left: 0;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\t-webkit-transition: all 0.4s ease;\n\t\t-moz-transition: all 0.4s ease;\n\t\ttransition: all 0.4s ease;\n\t}\n\t.chat-window .chat-scroll {\n\t\tmax-height: calc(100vh - 285px);\n\t}\n\t.chat-window .chat-cont-left, .chat-window .chat-cont-right {\n\t\tflex: 0 0 100%;\n\t\tmax-width: 100%;\n\t\ttransition: left 0.3s ease-in-out 0s, right 0.3s ease-in-out 0s;\n\t\twidth: 100%;\n\t}\n\t.chat-window .chat-cont-left {\n\t\tborder-right: 0;\n\t}\n\t.chat-window .chat-cont-right {\n\t\tposition: absolute;\n\t\tright: calc(-100% + -1.875rem);\n\t\ttop: 0;\n\t}\n\t.chat-window .chat-cont-right .chat-header {\n\t\tjustify-content: start;\n\t}\n\t.chat-window .chat-cont-right .chat-header .back-user-list {\n\t\tdisplay: block;\n\t}\n\t.chat-window .chat-cont-right .chat-header .chat-options {\n\t\tmargin-left: auto;\n\t}\n\t.chat-window.chat-slide .chat-cont-left {\n\t\tleft: calc(-100% + -1.875rem);\n\t}\n\t.chat-window.chat-slide .chat-cont-right {\n\t\tright: 0;\n\t}\n\t.sidebar-overlay.opened {\n\t\tdisplay: block;\n\t}\n}\n\n@media only screen and (max-width: 767.98px) {\n\tbody {\n\t\tfont-size: 0.9375rem;\n\t}\n\th1, .h1 {\n\t\tfont-size: 2rem;\n\t}\n\th2, .h2 {\n\t\tfont-size: 1.75rem;\n\t}\n\th3, .h3 {\n\t\tfont-size: 1.5rem;\n\t}\n\th4, .h4 {\n\t\tfont-size: 1.125rem;\n\t}\n\th5, .h5 {\n\t\tfont-size: 1rem;\n\t}\n\th6, .h6 {\n\t\tfont-size: 0.875rem;\n\t}\n\t.header .has-arrow .dropdown-toggle:after {\n\t\tdisplay: none;\n\t}\n\t.user-menu.nav > li > a > span:not(.user-img) {\n\t\tdisplay: none;\n\t}\n\t.navbar-nav .open .dropdown-menu {\n\t\tfloat: left;\n\t\tposition: absolute;\n\t}\n\t.navbar-nav.user-menu .open .dropdown-menu {\n\t\tleft: auto;\n\t\tright: 0;\n\t}\n\t.header .header-left {\n\t\tpadding: 0 15px;\n\t}\n\t.header .header-left .logo {\n\t\tdisplay: none;\n\t}\n\t.header-left .logo.logo-small {\n\t\tdisplay: inline-block;\n\t}\n\t.login-wrapper .loginbox .login-left {\n\t\tdisplay: none;\n\t}\n\t.login-wrapper .loginbox {\n\t\tmax-width: 450px;\n\t\tmin-height: unset;\n\t}\n\t.login-wrapper .loginbox .login-right {\n\t\tfloat: none;\n\t\tpadding: 1.875rem;\n\t\twidth: 100%;\n\t}\n\t.invoice-container {\n\t\tpadding: 20px;\n\t}\n\t.left-action {\n\t\ttext-align: center;\n\t\tmargin-bottom: 15px;\n\t}\n\t.right-action {\n\t\ttext-align: center;\n\t}\n\t.top-action-left .float-left {\n\t\tfloat: none !important;\n\t}\n\t.top-action-left .btn-group {\n\t\tmargin-bottom: 15px;\n\t}\n\t.top-action-right {\n\t\ttext-align: center;\n\t}\n\t.top-action-right a.btn.btn-white {\n\t\tmargin-bottom: 15px;\n\t}\n\t.mail-sent-time {\n\t\tfloat: left;\n\t\tmargin-top: 10px;\n\t\twidth: 100%;\n\t}\n\t.profile-btn {\n\t\tflex: 0 0 100%;\n\t\tmargin-top: 20px;\n\t}\n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, \n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\n\t\tmax-width: 250px;\n\t}\n\t.app-dropdown {\n\t\tdisplay: none;\n\t}\n\t.edit-link {\n\t\tfont-size: 0.875rem;\n\t\tmargin-top: 0;\n\t}\n\t.product_price {\n\t\tfont-size: 1.5rem;\n\t}\n\t.login-wrapper .loginbox .login-right h1 {\n\t\tfont-size: 22px;\n\t}\n\t.error-box h1 {\n\t\tfont-size: 6em;\n\t}\n\t.error-box .btn {\n\t\tfont-size: 15px;\n\t\tmin-width: 150px;\n\t\tpadding: 8px 20px;\n\t}\n\t.dash-count {\n\t\tfont-size: 16px;\n\t}\n}\n\n@media only screen and (max-width: 575.98px) {\n\t.card {\n\t\tmargin-bottom: 0.9375rem;\n\t}\n\t.page-wrapper > .content {\n\t\tpadding: 0.9375rem 0.9375rem 0;\n\t}\n\t.chat-window {\n\t\tmargin-bottom: 0.9375rem;\n\t}\n\t.card-body {\n\t\tpadding: 1.25rem;\n\t}\n\t.card-header {\n\t\tpadding: .75rem 1.25rem;\n\t}\n\t.card-footer {\n\t\tpadding: .75rem 1.25rem;\n\t}\n\t.card-chart .card-body {\n\t\tpadding: 5px;\n\t}\n\t.page-header {\n\t\tmargin-bottom: 0.9375rem;\n\t}\n\t.account-wrapper {\n\t\tpadding: 0.9375rem;\n\t}\n\t.pagination-lg .page-link {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem 0.625rem;\n\t}\n\t.profile-image {\n\t\tflex: 0 0 100%;\n\t\tmargin-bottom: 20px;\n\t\ttext-align: center;\n\t}\n\t.profile-user-info {\n\t\ttext-align: center;\n\t}\n\t.profile-btn {\n\t\ttext-align: center;\n\t}\n\t.invoice-details, .invoice-payment-details > li span {\n\t\tfloat: left;\n\t\ttext-align: left;\n\t}\n\t.fc-toolbar .fc-right {\n\t\tdisplay: inline-block;\n\t\tfloat: none;\n\t\tmargin: 10px auto 0;\n\t\twidth: 200px;\n\t\tclear: both;\n\t}\n\t.fc-toolbar .fc-left {\n\t\tfloat: none;\n\t\tmargin: 0 auto;\n\t\twidth: 200px;\n\t}\n\t.fc-toolbar .fc-center {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\t.fc-toolbar .fc-center h2 {\n\t\twidth: 100%;\n\t}\n\t.profile-tab-cont {\n\t\tpadding-top: 1.25rem;\n\t}\n\t.chat-window .chat-cont-right .chat-header .media .media-body {\n\t\tdisplay: none;\n\t}\n}\n\n@media only screen and (max-width: 479px) {\n\t.add-btn {\n\t\tfont-size: 14px;\n\t\tpadding: 6px 7px;\n\t}\n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-name, \n\t.chat-window .chat-cont-left .chat-users-list a.media .media-body > div:first-child .user-last-chat {\n\t\tmax-width: 160px;\n\t}\n\t.page-header .breadcrumb {\n\t\tdisplay: none;\n\t}\n}\ni.fa.fa-edit {\n    font-size: 12px;\n}\ni.fa.fa-trash {\n    font-size: 12px;\n}\n.table-rating i:not(:last-child) {\n    margin-right: 3px;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
